<template>
  <div>
    <div style="position: absolute; top: 10px; left: 20px;" v-if="view === 1 && productInfo.productPic">
      <el-image style="height: 175px; width: 150px" :src="productInfo.productPic"
                :preview-src-list="[productInfo.productPic]"></el-image>
      <div v-if="view === 1 && productInfo.productName" style="position: absolute">
        <div style="display: flex; flex-direction: column;">
          <div style="white-space: nowrap; text-align: left;">商品名: {{ productInfo.productName }}</div>
          <div style="white-space: nowrap; text-align: left;">商家编码:
            <span class="sku-code">
              {{ productInfo.code }}
            </span>
          </div>
          <div style="white-space: nowrap; text-align: left;">规格: {{ productInfo.specs }}
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 3px;">
      <div style="margin-left: 80px;">
        <el-button @click="changeView(1)">发货</el-button>
        <el-button @click="changeView(2)">多件发货</el-button>
        <el-button @click="changeView(8)">播种发货</el-button>
        <el-button @click="changeView(3)">异常查询</el-button>
        <el-button @click="changeView(6)">售后处理</el-button>
        <el-button @click="changeView(7)">快递扫描</el-button>
      </div>

      <div v-if="view === 1" style="margin: 12px 0;">
        <div>
          <div style="font-weight: bolder;">
            扫码区

            <el-select style="margin-left: 8px;" v-model="matchChannel" placeholder="配单来源"
                       :class="matchChannel ? 'match_channel_success' : 'match_channel_danger'">
              <el-option v-for="chl in matchChannels"
                         :key="chl.value"
                         :label="chl.label"
                         :value="chl.value"></el-option>
            </el-select>
          </div>
          <p style="font-size: 12px; color: #909399;">注:
            配单来源必选(请登录再选择)，每次登录会自动清空，长时间不操作也会自动清空</p>
          <div style="display: flex; align-items: center; margin: 22px 0; justify-content: center;">

            <div style="display: flex; align-items: center; justify-content: center; width: 50%;">

              <el-input
                  style="margin-right: 12px;"
                  placeholder="扫描二维码"
                  :value="qrText"
                  @input="qrTextInput"
                  @keyup.enter.native="scanQrText"
                  clearable
                  :autofocus="true"
                  ref="inputRef"
              >
              </el-input>
            </div>
            <div>
              <el-button type="primary" @click="scanQrText"> 确认</el-button>
            </div>
          </div>
          <el-row>
            <el-button @click="getPrinters">刷新打印机</el-button>
            <el-select v-model="printerName" placeholder="请选择">
              <el-option
                  v-for="item in printers"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
              >
              </el-option>
            </el-select>
          </el-row>
        </div>

        <div style="margin-top: 50px">
          <el-row>
            <el-col :span="8">
              <el-table
                  :data="qrTextQueue"
                  border
                  style="margin-top: 50px"
                  :row-class-name="highlightSelected"
                  @row-click="rowClick"
              >
                <el-table-column prop="" label="批次" align="center" width="50">
                  <template slot-scope="{row}">
                    <el-radio :label="row.batchId" v-model="qrSelected" @change="handleQrChange">
                      <span> </span>
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="time" label="扫码时间" align="center">
                </el-table-column>
                <el-table-column prop="batchId" label="批次号" align="center"></el-table-column>
                <el-table-column prop="qrText" label="条码" align="center">
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="16" style="margin-top: -18px;">
              <div style="display: flex; margin-left: 130px; color: grey; font-size: 15px;" class="delivery_advice">
                <div>
                  换申通：{{ scanTextResult.stAdvised }}
                </div>
                <div>
                  换圆通：{{ scanTextResult.ytAdvised }}
                </div>
                <div>
                  换中通：{{ scanTextResult.ztAdvised }}
                </div>
                <div>
                  换顺丰：{{ scanTextResult.sfAdvised }}
                </div>
                <div>
                  换京东：{{ scanTextResult.jdAdvised }}
                </div>
              </div>
              <el-radio-group v-model="filterSelected">
                <el-radio :label="1">成功：{{ scanTextResult.success }}</el-radio>
                <el-radio :label="5"><span
                    :class="scanTextResult.printMiss ? 'warning_text' : ''">未出单：{{ scanTextResult.printMiss }}</span>
                </el-radio>
                <el-radio :label="2">失败：{{ scanTextResult.fail }}</el-radio>
                <el-radio :label="4">重试：{{ scanTextResult.retry }}</el-radio>
                <el-radio :label="3">总共：{{ scanTextResult.total }}</el-radio>
              </el-radio-group>

              <el-button style="margin-left: 8px;" size="mini" @click="clearPrintResultResult">
                清除打印缓存
              </el-button>

              <el-table
                  :data="filterPrintData"
                  border
                  style="width: 100%; margin-top: 19px"
                  :row-class-name="tableRowClassName"
                  @row-click="rowClick2"
                  @selection-change="sel => this.selections = sel"
              >
                <el-table-column
                    align="center"
                    type="selection"
                    label="选择"
                    :selectable="reprintable"
                    width="42px"
                >
                </el-table-column>
                <el-table-column prop="orderId" label="订单号" width="180" align="center">
                </el-table-column>
                <el-table-column prop="productPic" label="商品图片" align="center" v-if="false">
                  <template slot-scope="{row}">
                    <el-image class="img_box_mini" :src="row.productPic" :preview-src-list="[row.productPic]"
                              v-if="row.productPic">
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="qrText" label="二维码" width="180" v-if="false">
                </el-table-column>
                <el-table-column prop="waybillId" label="物流单号" align="center">
                </el-table-column>
                <el-table-column prop="message" label="响应消息" align="center">
                  <template slot-scope="{ row }">
                    <div v-html="getMessage(row.message)">
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="extraInfo" label="备注" align="center">
                  <template slot-scope="{ row }">
                    <span style="font-weight: bold; color: #E6A23C;">{{ row.extraInfo }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="printStatus" label="打印状态" align="center">
                  <template slot-scope="{row}">
                    <div v-if="row.printStatus && row.printStatus.status === 'success'">
                      <span style="color: #67C23A; font-size: 24px;"><i class="el-icon-success"></i></span>
                    </div>
                    <div
                        v-if="row.printStatus && (row.printStatus.status === 'failed' || row.printStatus.status === '打印失败')">
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          <div>失败原因: {{ row.printStatus.msg }}</div>
                          <div>详细: {{ row.printStatus.detail }}</div>
                        </div>
                        <el-link type="danger" :underline="false">
                      <span style="font-size: 24px;">
                        <i class="el-icon-error"></i>
                      </span>
                        </el-link>
                      </el-tooltip>
                    </div>
                    <div v-if="row.printStatus && row.printStatus.status === 'canceled'">
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          <div>信息: 已取消;{{ row.printStatus.msg }}</div>
                          <div>详细: {{ row.printStatus.detail }}</div>
                        </div>
                        <el-link type="info" :underline="false">
                          <span style="font-size: 24px;">
                            <i class="el-icon-warning"></i>
                          </span>
                        </el-link>
                      </el-tooltip>
                    </div>
                    <div v-if="row.printStatus && row.printStatus.status === 'timeout'">
                      <span style="color: #909399;"><i class="el-icon-warning"></i>请重新查询</span>
                      <el-button type="default" icon="el-icon-refresh-right" size="mini"
                                 @click="refreshPrintResultForRow(row)"></el-button>
                    </div>
                    <div v-if="!row.printStatus">
                      <span style="color: #909399;">未查询</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="nextStatus" label="重试状态" align="center">
                  <template slot-scope="{ row }">
                    <div v-if="row.nextStatus">
                      <el-tag type="info" effect="plain">
                        已重试
                      </el-tag>
                    </div>
                    <div v-else>-</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot="header" slot-scope="{ row }">
                    <el-button
                        type="warning"
                        size="mini"
                        @click="reprintWaybills"
                    >
                      批量重打
                    </el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                        type="warning"
                        size="mini"
                        icon="el-icon-printer"
                        v-if="scope.row.printData"
                        @click="reprint(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </div>
      </div>

      <div v-if="view === 2">
        <el-form :model="form" class="demo-form-inline" :inline="true" style="margin-top: 20px;">
          <!--          <div style="margin-left: 12px; display: flex; align-items: center; margin-top: 12px; margin-bottom: 12px;">-->
          <!--            <span style="font-weight: bolder; margin-right: 8px;">配单来源</span>-->
          <!--            <el-select v-model="matchChannel2" placeholder="配单来源" :class="matchChannel2 ? 'match_channel_success' : 'match_channel_danger'">-->
          <!--              <el-option v-for="chl in matchChannels"-->
          <!--                         :key="chl.value"-->
          <!--                         :label="chl.label"-->
          <!--                         :value="chl.value"></el-option>-->
          <!--            </el-select>-->
          <!--          </div>-->
          <div class="flex_div">
            <el-form-item class="deliver-taq" label="选择客户">
              <el-select @change="changeVipForMulti" v-model="vipName" placeholder="请选择" filterable :disabled="pickingSendInProgress">
                <el-option
                    v-for="item in vips"
                    :key="item.teamId"
                    :label="item.teamName"
                    :value="item.teamId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="deliver-taq" label="选择仓库">
              <el-select @change="warehouseCodeChangeForMulti" v-model="warehouseCode" placeholder="请选择" filterable :disabled="pickingSendInProgress">
                <el-option
                    v-for="item in erpWarehouses"
                    :key="item.warehouseCode"
                    :label="item.warehouseName"
                    :value="item.warehouseCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="deliver-taq">
              <el-button type="success" icon="el-icon-refresh" @click="() => loadMultipleOrders(teamId, true)" :disabled="pickingSendInProgress">刷新
              </el-button>
            </el-form-item>
            <el-form-item class="deliver-taq">
              <el-button
                  :type="autoSendMode ? 'primary' : 'default'"
                  @click="toggleAutoSendMode"
                  icon="el-icon-magic-stick"
              >
                {{ autoSendMode ? '退出自动发货' : '自动发货模式' }}
              </el-button>
            </el-form-item>
          </div>
          <div class="flex_div" v-if="pickingTasks.length || pickingStockOutId || pickingTasksLoading">
            <el-form-item class="deliver-taq" label="拣货单">
              <el-select v-model="pickingStockOutId" placeholder="请选择拣货单" clearable filterable
                         style="width: 480px;" :loading="pickingTasksLoading"
                         :disabled="pickingSendInProgress" @change="changePickingTask">
                <el-option v-for="task in pickingTasks" :key="task.id" :value="task.id"
                           :label="pickingTaskLabel(task)" :title="pickingTaskLabel(task)" :disabled="task.unavailable">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="flex_div">
            <el-form-item class="deliver-taq" label="批次管理" v-if="!pickingStockOutId">
              <el-select
                  @change="changeTaskGroup"
                  v-model="taskGroup"
                  placeholder="请选择批次"
                  value-key="id"
              >
                <el-option
                    v-for="item in taskGroups"
                    :key="item.id"
                    :label="item.title"
                    :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="deliver-taq">
              <el-button type="primary" @click="taskGroupDetail" :disabled="pickingOrdersLoading || pickingSendInProgress">
                {{ pickingStockOutId ? '本页批量发货' : '批次发货' }}
              </el-button>
            </el-form-item>
            <el-form-item class="deliver-taq" v-if="!pickingStockOutId">
              <el-button type="primary" @click="createTaskGroup">
                创建批次
              </el-button>
            </el-form-item>
            <el-form-item class="deliver-taq" v-if="!pickingStockOutId">
              <el-button type="primary" @click="createTaskGroupByScan">
                扫码创建
              </el-button>
            </el-form-item>
            <el-form-item class="deliver-taq" v-if="!pickingStockOutId">
              <el-button type="primary" @click="createMultipleTaskGroupByOrderNum">
                按单创建
              </el-button>
            </el-form-item>
            <el-form-item class="deliver-taq" v-if="!pickingStockOutId">
              <el-button type="text" @click="showMultiSendResult">
                批次结果
              </el-button>
            </el-form-item>
          </div>
          <div class="flex_div">
            <el-form-item label="扫码搜索批次" class="deliver-taq" v-if="!pickingStockOutId">
              <el-input
                  v-model="multiGroupQrText"
                  placeholder="扫码搜索批次"
                  @input="multiGroupQrTextInput"
                  @keyup.enter.native="loadTaskGroupByQrText()"
                  clearable
                  @clear="() => loadMultipleOrders(this.teamId, true)"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex_div">
            <el-form-item class="deliver-taq" label="扫码搜索任务">
              <el-input
                  v-model="multipleSearchQrText"
                  placeholder="扫码搜索任务"
                  @input="multipleSearchQrTextInput"
                  @keyup.enter.native="() => changeTaskGroup($event, true)"
                  clearable
              ></el-input>
            </el-form-item>
            <el-form-item class="deliver-taq" v-if="!pickingStockOutId">
              <el-button type="text" icon="el-icon-edit" @click="toEditMultiPageSize">
                <span style="font-size: 16px;">{{ multiPageSize }}</span>
              </el-button>
              条/页
            </el-form-item>
            <el-form-item class="deliver-taq" v-if="!pickingStockOutId">
              待处理批次{{ taskGroups.length - 1 }}
            </el-form-item>
          </div>

          <div class="flex_div">
            <el-form-item class="deliver-taq" label="全匹配找任务">
              <div style="position: relative;">
                <el-input
                    ref="allMatchInput"
                    v-model="allMatchQrText"
                    type="textarea"
                    placeholder="条码全匹配找任务（请扫单组的所有条码）"
                    @input="val => allMatchQrText = val"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    style="width: 450px;"
                    clearable
                ></el-input>
                <span class="custom_clearable" v-if="allMatchQrText" @click="() => allMatchQrText = ''">
                  <i class="el-icon-circle-close"></i>
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button @click="changeTaskGroup">确 认</el-button>
            </el-form-item>
          </div>


        </el-form>
        <!-- 自动发货模式下的左右分栏布局 -->
        <div v-if="autoSendMode" class="auto-send-layout">
          <!-- 左侧操作区域 -->
          <div class="auto-send-left">
            <div class="auto-send-section">
              <h3>操作区域</h3>
              <div class="auto-send-input-section">
                <el-input
                    ref="autoSendInput"
                    v-model="autoSendQrText"
                    placeholder="请扫描商品条码..."
                    @input="autoSendQrTextInput"
                    @keyup.enter.native="handleAutoSendQrText"
                    clearable
                    :autofocus="true"
                    class="auto-send-input"
                    size="medium"
                ></el-input>
                <div style="margin-top: 10px; display: flex; flex-wrap: wrap; gap: 10px;">
                  <el-button @click="clearAutoSendData" type="danger" size="small">清空数据</el-button>
                  <el-button @click="toggleAutoSendMode" type="info" size="small">退出模式</el-button>
                  <el-button
                      @click="toggleVerifyMode"
                      :type="verifyMode ? 'success' : 'primary'"
                      size="small"
                  >
                    {{ verifyMode ? '校验模式开启' : '播种校验' }}
                  </el-button>
                  <el-button
                      v-if="verifyMode"
                      @click="toggleSowingInOrder"
                      :type="sowingInOrder ? 'success' : 'default'"
                      :disabled="pickingOrdersLoading || pickingSendInProgress"
                      size="small"
                  >
                    是否按顺序：{{ sowingInOrder ? '开启' : '关闭' }}
                  </el-button>
                </div>
              </div>

              <!-- 删除提示区域 -->
              <div v-if="lastDeletedCode" class="auto-send-delete-notice">
                <h4>⚠️ 最近删除</h4>
                <div
                    style="background: linear-gradient(135deg, #ff4757 0%, #ff3742 100%); color: white; padding: 12px; border-radius: 6px; margin-bottom: 10px; animation: pulse 2s infinite;">
                  <div style="font-weight: bold; margin-bottom: 5px;">🚨 已自动删除条码: {{ lastDeletedCode }}</div>
                  <div style="font-size: 12px; opacity: 0.9;">当前商品组合无法匹配任何订单</div>
                </div>
              </div>

              <div v-if="autoSendData.scannedCodes.length > 0" class="auto-send-codes">
                <h4>已扫描条码</h4>
                <div class="auto-send-tags">
                  <el-tag
                      v-for="(item, index) in autoSendData.scannedCodes"
                      :key="index"
                      :type="item.matched ? 'success' : item.partialMatched ? 'warning' : 'danger'"
                      closable
                      @close="removeScannedCode(index)"
                      class="auto-send-tag"
                  >
                    {{ item.code }} ({{ item.count }})
                  </el-tag>
                </div>
              </div>
              <!-- 最近发货记录 -->
              <div class="auto-send-history">
                <h4>最近发货记录</h4>
                <el-table
                    :data="recentShipments"
                    stripe
                    size="small"
                    style="width: 100%"
                    :header-cell-style="{background:'#f8f9fa', color:'#606266', fontWeight:'bold'}"
                    border
                >
                  <el-table-column prop="time" label="发货时间" width="90" align="center">
                    <template slot-scope="{row}">
                      <span style="font-size: 12px;">{{ row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="waybillId" label="物流单号" width="90" align="center">
                    <template slot-scope="{row}">
                      <el-tooltip :content="row.waybillId" placement="top">
                        <span style="font-size: 12px;">{{ row.waybillId.substring(0, 8) }}...</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="message" label="返回消息" width="90" align="center">
                    <template slot-scope="{row}">
                      <el-tooltip :content="row.message" placement="top">
                        <span style="font-size: 12px;" :style="{color: row.status === 0 ? '#67C23A' : '#F56C6C'}">
                          {{ row.message.length > 8 ? row.message.substring(0, 8) + '...' : row.message }}
                        </span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="50" fixed="right" align="center">
                    <template slot-scope="{row}">
                      <el-button
                          type="warning"
                          size="mini"
                          icon="el-icon-refresh"
                          circle
                          style="padding: 4px; font-size: 12px;"
                          :disabled="!row.waybillId"
                          @click="resendOrder(row)"
                          :loading="row.loading"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-if="recentShipments.length === 0" style="text-align: center; padding: 20px; color: #909399;">
                  暂无发货记录
                </div>
              </div>

            </div>
          </div>

          <!-- 右侧数据展示区域 -->
          <div class="auto-send-right">
            <div style="margin-bottom: 15px;">
              <h3 style="margin: 0 0 12px 0; color: #303133; font-size: 16px; font-weight: bold; border-bottom: 2px solid #67c23a; padding-bottom: 8px; text-align: center;">
                📦 匹配订单列表
              </h3>
            </div>
            <div v-if="filteredMultipleOrders && filteredMultipleOrders.length">
              <el-card v-for="(order, idx) in renderedMultipleOrders" :key="order.order_id"
                       class="auto-send-order-card">
                <div slot="header" class="clearfix">
                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div style="display: flex; align-items: center; gap: 15px;">
                      <span style="font-weight: bold; color: #303133;">订单: {{ order.order_id }}</span>
                      <span style="color: #409eff; font-weight: bold; font-size: 18px;">总数: {{
                          order.combo_num
                        }}</span>
                      <span v-html="transformDeliver(order.deliver)"></span>
                      <span v-if="order.markDelivered" style="color: #67c23a; font-weight: bold;">✅ 已发货</span>
                    </div>
                    <div>
                      <el-button
                          v-if="!order.markDelivered"
                          @click="sendOrder(order, idx)"
                          :disabled="pickingOrdersLoading || pickingSendInProgress"
                          type="primary"
                          size="small"
                      >打印
                      </el-button>
                      <el-button
                          v-if="order.markDelivered"
                          @click="() => reprintWaybill(order.markDelivered, null)"
                          type="warning"
                          size="small"
                      >重打
                      </el-button>
                    </div>
                  </div>
                </div>
                <div
                    v-for="child in order.children"
                    :key="`${child.code}-${child.order_id}`"
                    class="text item"
                    :class="{ 'auto-send-matched-item': isAutoSendMatchedItem(child) }"
                >
                  <el-row>
                    <el-col :span="8">
                      <el-image
                          style="width: 70px; height: 70px"
                          :src="child.product_pic"
                          :preview-src-list="[child.product_pic]"
                      ></el-image>
                    </el-col>
                    <el-col :span="16">
                      <div style="font-weight: bold; color: #303133; margin-bottom: 4px;">{{ child.product_name }}</div>
                      <div style="color: #606266; margin-bottom: 4px;">编码: {{ child.code }}</div>
                      <div style="color: #606266; margin-bottom: 4px;">规格: {{ child.specs }}</div>
                      <div style="color: #409eff; font-weight: bold; font-size: 16px;">数量: {{ child.combo_num }}</div>
                      <div v-if="isAutoSendMatchedItem(child)" class="auto-send-match-tip">
                        已匹配扫描 {{ autoSendData.codeCounts[child.code] }} / {{ child.combo_num }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </div>
            <div v-else>
              <el-card style="text-align: center; padding: 30px;">
                <div v-if="autoSendData.scannedCodes.length > 0"
                     style="color: #F56C6C; font-size: 14px; font-weight: bold;">
                  ⚠️ 暂无包含已扫描商品的订单
                </div>
                <div v-else style="color: #909399; font-size: 14px;">
                  📋 请开始扫描商品条码...
                </div>
              </el-card>
            </div>
          </div>
        </div>

        <!-- 普通模式下的原有布局 -->
        <div v-else>
          <div v-if="filteredMultipleOrders && filteredMultipleOrders.length">
            <el-card v-for="(order, idx) in renderedMultipleOrders" :key="order.order_id">
              <div slot="header" class="clearfix">
                <span>序列号: {{ order.order_id }}</span>
                <span>| 总数:
                  <span style="color: red; font-size: xxx-large;">
                    {{ order.combo_num }}
                  </span>
                </span>
                <span>| 标志: <span v-html="transformDeliver(order.deliver)"></span></span>

                <span v-if="order.markDelivered" style="color: green; font-size: larger;">已发货成功！</span>

                <el-button
                    v-if="!order.markDelivered"
                    @click="sendOrder(order, idx)"
                    :disabled="pickingOrdersLoading || pickingSendInProgress"
                    style="float: right; padding: 3px 0"
                    type="text"
                >打印
                </el-button>

                <el-button
                    v-if="order.markDelivered"
                    @click="() => reprintWaybill(order.markDelivered, null)"
                    style="float: right; padding: 3px 0"
                    type="text"
                >重打
                </el-button>
              </div>
              <div
                  v-for="child in order.children"
                  :key="`${child.code}-${child.order_id}`"
                  class="text item"
              >
                <el-row>
                  <el-col :span="12">
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="child.product_pic"
                        :preview-src-list="[child.product_pic]"
                    ></el-image>
                  </el-col>
                  <el-col :span="12">
                    <div>{{ child.product_name }}</div>
                    <div>{{ child.code }}</div>
                    <div>{{ child.specs }} * <span
                        style="font-weight: bold; font-size: 20px; color: orangered;">{{ child.combo_num }}</span></div>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </div>
          <div v-else>
            <el-card>
              <div v-if="autoSendData.scannedCodes.length > 0">
                暂无包含已扫描商品的订单
              </div>
              <div v-else>
                暂无记录
              </div>
            </el-card>
          </div>
        </div>

        <div v-if="pickingStockOutId && filteredMultipleOrders.length" class="multiple-order-pagination">
          <el-pagination :current-page="multipleRenderPage" :page-size="multipleRenderPageSize"
                         :page-sizes="[10, 20, 50]" :total="filteredMultipleOrders.length"
                         :disabled="pickingOrdersLoading || pickingSendInProgress"
                         layout="total, sizes, prev, pager, next"
                         @current-change="changeMultipleRenderPage" @size-change="changeMultipleRenderPageSize">
          </el-pagination>
        </div>

        <el-dialog title="创建批次" :visible.sync="taskGroupCreateViewable">
          <el-select
              @change="changeTaskCode"
              v-model="taskCode"
              placeholder="请选择批次款式"
              value-key="code"
              multiple
          >
            <el-option
                v-for="item in codeList"
                :key="item.code"
                :label="item.product_name"
                :value="item"
                style="height: 100px"
            >
              <div class="text item">
                <el-row>
                  <el-col :span="12">
                    <img
                        :src="item.product_pic"
                        style="width: 100px; height: 100px"
                    />
                  </el-col>
                  <el-col :span="12">
                    <div>{{ item.product_name }}</div>
                    <div>{{ item.code }}</div>
                    <div>{{ item.specs }}</div>
                  </el-col>
                </el-row>
              </div>
            </el-option>
          </el-select>

          <el-input
              placeholder="扫二维码创建"
              v-model="qrTextInfo"
              @keyup.enter.native="getSkuFromQrText"
              clearable
              ref="inputRef"
          >
          </el-input>

          <el-row v-for="item in taskCode">
            <el-col>
              <div>产品名称: {{ item.product_name }} ||| 产品规格: {{ item.specs }} ||| 数量:1</div>
            </el-col>
          </el-row>

          <div slot="footer" class="dialog-footer">
            <el-button @click="taskGroupCreateViewable = false">取 消</el-button>
            <el-button type="primary" @click="toConfirmCreate">确 定</el-button>
          </div>
        </el-dialog>
      </div>

      <div v-if="view === 3">
        <div style="margin-top: 12px;">
          <el-row>
            <el-col :span="4"><p>条码</p></el-col>
            <el-col :span="9">
              <el-input
                  placeholder="条码/物流号码"
                  :value="qrCode"
                  @input="qrCodeInput"
                  @keyup.enter.native="queryByQrText"
                  clearable
              >
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="queryByQrText"> 确认</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="reprintByQrCode">
                重打面单
              </el-button>
            </el-col>
            <el-col :span="2"> {{ recordsNum }}件</el-col>

            <el-col :span="2">
              <el-button type="warning" @click="batchReprint">批量重打</el-button>
            </el-col>
          </el-row>
          <div>
            <div>
              <el-table
                  :data="records"
                  border
                  style="width: 100%"
                  :row-class-name="tableRowclassName_inquire"
                  @selection-change="handleSelectionChange"
              >
                <el-table-column align="center" type="selection" width="55">
                </el-table-column>
                <el-table-column prop="createdTime" label="入库时间">
                </el-table-column>
                <el-table-column prop="lastUpdateTime" label="更新时间">
                </el-table-column>
                <el-table-column prop="orderId" label="订单号"></el-table-column>
                <el-table-column prop="waybillId" label="物流单号">
                </el-table-column>
                <el-table-column prop="orderStatus" label="订单状态">
                </el-table-column>
                <el-table-column prop="errorMsg" label="状态描述">
                </el-table-column>
                <el-table-column prop="logisticsStatus" label="揽收状态">
                </el-table-column>
                <el-table-column prop="packerName" label="打包人">
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                        size="mini"
                        icon="el-icon-warning"
                        @click="errOrder(scope.row)"
                    ></el-button>
                    <el-button
                        type="warning"
                        size="mini"
                        icon="el-icon-printer"
                        @click="reprintWaybill(scope.row.waybillId)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div v-if="view === 6">
        <div>
          <el-switch v-model="enableGlobalScanListener" @change="() => updateScannerListeners()"></el-switch>
          自动物流扫描识别
        </div>
        <div>
          <el-dialog :title="'签收商品确认' + afterSaleConfirmDto.suffix"
                     :visible.sync="afterSaleConfirmDto.dialogVisible"
                     width="1000px">
            <new-sku-selection
                :teamid="vipName"
                :visible="afterSaleConfirmDto.innerDialog"
                :appended="true"
                @dialogClose="() => this.afterSaleConfirmDto.innerDialog = false"
                @confirmSelection="handleConfirmSelection"
            >
            </new-sku-selection>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <div v-if="hasInterceptItems" style="color: #f56c6c; font-weight: bold; font-size: 14px;">
                <i class="el-icon-warning"></i>
                拦截商品只能转次品
              </div>
              <div v-else></div>
              <div>
                <el-button type="success" size="mini" @click="editItem()">新增</el-button>
              </div>
            </div>
            <div>
              <el-table :data="afterSaleConfirmDto.items" border>
                <el-table-column label="图片" prop="image" align="center">
                  <template slot-scope="{ row }">
                    <el-image :src="row.orderVo.product_pic" :preview-src-list="[row.orderVo.product_pic]">
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column property="productName" label="商品名" align="center">
                  <template slot-scope="{ row }">
                    {{ row.orderVo.product_name }}
                  </template>
                </el-table-column>
                <el-table-column property="code" label="商家编码" align="center">
                  <template slot-scope="{ row }">
                    <span class="sku-code">{{ row.orderVo.code }}</span>
                    <div>
                      <el-button type="text" size="mini"
                                 @click="() => pullErpSkuByCode(afterSaleConfirmDto.teamId, row.orderVo.code)">拉取
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="specs" label="规格" align="center">
                  <template slot-scope="{ row }">
                    {{ row.orderVo.specs }}
                  </template>
                </el-table-column>
                <el-table-column label="类型" prop="giveaway" align="center" width="110px">
                  <template slot-scope="{ row }">
                    <el-select v-model="row.giveaway" :disabled="!row.newCreated" size="mini">
                      <el-option :value="false" label="非赠品"></el-option>
                      <el-option :value="true" label="赠品"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column property="num" label="数量" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <el-input-number style="width: 110px;" v-model="row.num" :min="1" size="mini"
                                     @change="(cur, old) => handlePlanQtyChange(cur, old, row)">
                    </el-input-number>
                  </template>
                </el-table-column>
                <el-table-column property="actualQty" label="需上架数量" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <el-input-number style="width: 110px;" v-model="row.actualQty" :min="0" :max="row.num" size="mini">
                    </el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="订单卖家备注" prop="customRemark" v-if="false" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <el-input v-if="!row.newCreated" v-model="row.customRemark" placeholder="订单备注" size="mini"
                              clearable></el-input>
                    <span v-if="row.newCreated">---</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" prop="operation" align="center">
                  <template slot-scope="{ row }">
                    <div class="op_div">
                      <div>
                        <el-button type="primary" size="mini" @click="editItem(row)">更换</el-button>
                      </div>
                      <div>
                        <el-button type="danger" size="mini"
                                   @click="deleteItem(row)">删除
                        </el-button>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="快捷转异常/次品" prop="unusual" align="center">
                  <template slot-scope="{ row }">
                    <div class="op_div">
                      <div v-if="!row.intercept">
                        <el-button type="default" size="mini" @click="markItem(row, 'unusualItems')">少件</el-button>
                      </div>
                      <div>
                        <el-button
                            :type="row.intercept ? 'danger' : 'default'"
                            size="mini"
                            @click="markItem(row, 'defectiveItems')"
                            :class="row.intercept ? 'intercept-defective-btn' : ''"
                        >次品
                        </el-button>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="display: flex; justify-content: left; align-items: center; margin-top: 12px;">
              <span style="font-weight: bold;">备注信息：</span>
              <el-input placeholder="请输入备注信息(小于50字)"
                        style="width: 300px;"
                        v-model="afterSaleConfirmDto.customRemark"
                        size="small"
                        ref="afterSaleRemarkInput"
                        clearable></el-input>
            </div>

            <!-- 异常列表 -->
            <div v-if="afterSaleConfirmDto.unusualItems && afterSaleConfirmDto.unusualItems.length">
              <div class="dashed_line"></div>
              <div>
                <el-divider content-position="left">异常列表</el-divider>
              </div>
              <div>
                <el-table :data="afterSaleConfirmDto.unusualItems" border>
                  <el-table-column label="图片" prop="image" align="center">
                    <template slot-scope="{ row }">
                      <el-image :src="row.orderVo.product_pic" :preview-src-list="[row.orderVo.product_pic]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column property="productName" label="商品名" align="center">
                    <template slot-scope="{ row }">
                      {{ row.orderVo.product_name }}
                    </template>
                  </el-table-column>
                  <el-table-column property="code" label="商家编码" align="center">
                    <template slot-scope="{ row }">
                      <span class="sku-code">{{ row.orderVo.code }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="specs" label="规格" align="center">
                    <template slot-scope="{ row }">
                      {{ row.orderVo.specs }}
                    </template>
                  </el-table-column>
                  <el-table-column label="异常类型" prop="giveaway" align="center" width="110px">
                    <template slot-scope="{ row }">
                      少件
                    </template>
                  </el-table-column>
                  <el-table-column property="num" label="数量" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number style="width: 110px;" v-model="row.num" :min="1" size="mini">
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="operation" align="center">
                    <template slot-scope="{ row }">
                      <div class="op_div">
                        <div>
                          <el-button type="danger" size="mini"
                                     @click="revertMarkItem(row, 'unusualItems')">取消
                          </el-button>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <!-- 次品列表 -->
            <div v-if="afterSaleConfirmDto.defectiveItems && afterSaleConfirmDto.defectiveItems.length">
              <div class="dashed_line"></div>
              <div style="display: flex; align-items: center;">
                <el-divider content-position="left">次品列表</el-divider>
                <div style="display: flex; align-items: center; flex-shrink: 0; margin-left: 12px;">
                  <div style="font-weight: bold; margin-right: 5px;">次品仓：</div>
                  <el-select v-model="afterSaleConfirmDto.defectiveWarehouseCode" placeholder="次品仓">
                    <el-option
                        v-for="ware in erpWarehouses.filter(w => w.goodsType === 2)"
                        :key="ware.warehouseCode"
                        :label="ware.warehouseName"
                        :value="ware.warehouseCode"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div>
                <el-table :data="afterSaleConfirmDto.defectiveItems" border>
                  <el-table-column label="图片" prop="image" align="center">
                    <template slot-scope="{ row }">
                      <el-image :src="row.orderVo.product_pic" :preview-src-list="[row.orderVo.product_pic]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column property="productName" label="商品名" align="center">
                    <template slot-scope="{ row }">
                      {{ row.orderVo.product_name }}
                    </template>
                  </el-table-column>
                  <el-table-column property="code" label="商家编码" align="center">
                    <template slot-scope="{ row }">
                      <span class="sku-code">{{ row.orderVo.code }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="specs" label="规格" align="center">
                    <template slot-scope="{ row }">
                      {{ row.orderVo.specs }}
                    </template>
                  </el-table-column>
                  <el-table-column property="num" label="数量" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number style="width: 110px;" v-model="row.num" :min="1" size="mini">
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column property="actualQty" label="数量" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number style="width: 110px;" v-model="row.actualQty" :min="0" :max="row.num"
                                       size="mini">
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column property="defective" label="次品描述" align="center" width="200">
                    <template slot-scope="{ row }">
                      <el-input v-model="row.defective"
                                placeholder="请输入次品描述"
                                :autosize="{ minRows: 3, maxRows: 5}"
                                type="textarea"
                                clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="operation" align="center">
                    <template slot-scope="{ row }">
                      <div class="op_div">
                        <div v-if="!row.intercept">
                          <el-button type="danger" size="mini"
                                     @click="revertMarkItem(row, 'defectiveItems')">取消
                          </el-button>
                        </div>
                        <div v-else style="color: #f56c6c; font-weight: bold;">
                          强制次品
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <div style="margin-bottom: 20px;">
                <el-checkbox v-model="afterSaleConfirmDto.printQualifiedCert">打印合格证</el-checkbox>
              </div>
              <div>
                <el-button @click="afterSaleConfirmDto.dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="processAfterSale(afterSaleConfirmDto.printQualifiedCert)">确 认
                </el-button>
              </div>
            </div>
          </el-dialog>
        </div>
        <div>
          <el-dialog title="拦截件签收商品确认" :visible.sync="afterSaleConfirmDto.interceptDialogVisible"
                     width="1000px">
            <new-sku-selection
                :teamid="vipName"
                :visible="afterSaleConfirmDto.innerDialog"
                :appended="true"
                @dialogClose="() => afterSaleConfirmDto.innerDialog = false"
                @confirmSelection="handleConfirmSelection"
            >
            </new-sku-selection>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <div v-if="hasInterceptItems" style="color: #f56c6c; font-weight: bold; font-size: 14px;">
                <i class="el-icon-warning"></i>
                拦截商品只能转次品
              </div>
              <div v-else></div>
              <div>
                <el-button type="success" size="mini" @click="editItem()">新增</el-button>
              </div>
            </div>
            <div>
              <el-table :data="afterSaleConfirmDto.items" border>
                <el-table-column label="图片" prop="image" align="center">
                  <template slot-scope="{ row }">
                    <el-image :src="row.orderVo.product_pic" :preview-src-list="[row.orderVo.product_pic]">
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column property="productName" label="商品名" align="center">
                  <template slot-scope="{ row }">
                    {{ row.orderVo.product_name }}
                  </template>
                </el-table-column>
                <el-table-column property="code" label="商家编码" align="center">
                  <template slot-scope="{ row }">
                    <span class="sku-code">{{ row.orderVo.code }}</span>
                    <div>
                      <el-button type="text" size="mini"
                                 @click="() => pullErpSkuByCode(afterSaleConfirmDto.teamId, row.orderVo.code)">拉取
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="specs" label="规格" align="center">
                  <template slot-scope="{ row }">
                    {{ row.orderVo.specs }}
                  </template>
                </el-table-column>
                <el-table-column label="类型" prop="giveaway" align="center" width="110px">
                  <template slot-scope="{ row }">
                    <el-select v-model="row.giveaway" :disabled="!row.newCreated" size="mini">
                      <el-option :value="false" label="非赠品"></el-option>
                      <el-option :value="true" label="赠品"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column property="num" label="数量" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <el-input-number style="width: 110px;" v-model="row.num" :min="1" size="mini">
                    </el-input-number>
                  </template>
                </el-table-column>
                <el-table-column property="num" label="需上架" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <el-input-number style="width: 110px;"
                                     v-model="row.actualQty"
                                     :min="0"
                                     :max="row.num"
                                     size="mini">
                    </el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="快捷转异常/次品" prop="unusual" align="center">
                  <template slot-scope="{ row }">
                    <div class="op_div">
                      <div v-if="!row.intercept">
                        <el-button type="default" size="mini" @click="markItem(row, 'unusualItems')">少件</el-button>
                      </div>
                      <div>
                        <el-button
                            :type="row.intercept ? 'danger' : 'default'"
                            size="mini"
                            @click="markItem(row, 'defectiveItems')"
                            :class="row.intercept ? 'intercept-defective-btn' : ''"
                        >次品
                        </el-button>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" prop="operation" align="center">
                  <template slot-scope="{ row }">
                    <div class="op_div">
                      <div>
                        <el-button type="primary" size="mini" @click="editItem(row)">更换</el-button>
                      </div>
                      <div>
                        <el-button type="danger" size="mini" @click="deleteItem(row)">删除</el-button>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 异常列表 -->
            <div v-if="afterSaleConfirmDto.unusualItems && afterSaleConfirmDto.unusualItems.length">
              <div class="dashed_line"></div>
              <div>
                <el-divider content-position="left">异常列表</el-divider>
              </div>
              <div>
                <el-table :data="afterSaleConfirmDto.unusualItems" border>
                  <el-table-column label="图片" prop="image" align="center">
                    <template slot-scope="{ row }">
                      <el-image :src="row.orderVo.product_pic" :preview-src-list="[row.orderVo.product_pic]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column property="productName" label="商品名" align="center">
                    <template slot-scope="{ row }">
                      {{ row.orderVo.product_name }}
                    </template>
                  </el-table-column>
                  <el-table-column property="code" label="商家编码" align="center">
                    <template slot-scope="{ row }">
                      <span class="sku-code">{{ row.orderVo.code }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="specs" label="规格" align="center">
                    <template slot-scope="{ row }">
                      {{ row.orderVo.specs }}
                    </template>
                  </el-table-column>
                  <el-table-column property="num" label="数量" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number style="width: 110px;" v-model="row.num" :min="1" size="mini">
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column property="num" label="需上架" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number style="width: 110px;"
                                       v-model="row.actualQty"
                                       :min="0"
                                       :max="row.num"
                                       size="mini">
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="operation" align="center">
                    <template slot-scope="{ row }">
                      <div class="op_div">
                        <div>
                          <el-button type="danger" size="mini"
                                     @click="revertMarkItem(row, 'unusualItems')">取消
                          </el-button>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <!-- 次品列表 -->
            <div v-if="afterSaleConfirmDto.defectiveItems && afterSaleConfirmDto.defectiveItems.length">
              <div class="dashed_line"></div>
              <div style="display: flex; align-items: center;">
                <el-divider content-position="left">次品列表</el-divider>
                <div style="display: flex; align-items: center; flex-shrink: 0; margin-left: 12px;">
                  <div style="font-weight: bold; margin-right: 5px;">次品仓：</div>
                  <el-select v-model="afterSaleConfirmDto.defectiveWarehouseCode" placeholder="次品仓">
                    <el-option
                        v-for="ware in erpWarehouses.filter(w => w.goodsType === 2)"
                        :key="ware.warehouseCode"
                        :label="ware.warehouseName"
                        :value="ware.warehouseCode"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div>
                <el-table :data="afterSaleConfirmDto.defectiveItems" border>
                  <el-table-column label="图片" prop="image" align="center">
                    <template slot-scope="{ row }">
                      <el-image :src="row.orderVo.product_pic" :preview-src-list="[row.orderVo.product_pic]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column property="productName" label="商品名" align="center">
                    <template slot-scope="{ row }">
                      {{ row.orderVo.product_name }}
                    </template>
                  </el-table-column>
                  <el-table-column property="code" label="商家编码" align="center">
                    <template slot-scope="{ row }">
                      <span class="sku-code">{{ row.orderVo.code }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="specs" label="规格" align="center">
                    <template slot-scope="{ row }">
                      {{ row.orderVo.specs }}
                    </template>
                  </el-table-column>
                  <el-table-column property="num" label="数量" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number style="width: 110px;" v-model="row.num" :min="1" size="mini">
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column property="num" label="需上架" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number style="width: 110px;" v-model="row.actualQty" :min="0" :max="row.num"
                                       size="mini">
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column property="defective" label="次品描述" align="center" width="200">
                    <template slot-scope="{ row }">
                      <el-input v-model="row.defective"
                                placeholder="请输入次品描述"
                                :autosize="{ minRows: 3, maxRows: 5}"
                                type="textarea"
                                clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="operation" align="center">
                    <template slot-scope="{ row }">
                      <div class="op_div">
                        <div v-if="!row.intercept">
                          <el-button type="danger" size="mini"
                                     @click="revertMarkItem(row, 'defectiveItems')">取消
                          </el-button>
                        </div>
                        <div v-else style="color: #f56c6c; font-weight: bold;">
                          强制次品
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div slot="footer" class="dialog-footer">
              <div style="margin-bottom: 20px;">
                <el-checkbox v-model="afterSaleConfirmDto.interceptPrintQualifiedCert">打印合格证</el-checkbox>
              </div>
              <div>
                <el-button @click="() => this.afterSaleConfirmDto.interceptDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="receiveIntercept(afterSaleConfirmDto.interceptPrintQualifiedCert)">确
                  认
                </el-button>
              </div>
            </div>
          </el-dialog>
        </div>

        <div>
          <el-dialog title="入库单详情"
                     :visible.sync="afterSaleEntryOrderDialog"
                     :before-close="handleAfterSaleEntryOrderDialogClose"
                     width="1000px">
            <new-sku-selection
                :teamid="vipName"
                :visible="afterSaleEntryOrderInnerDialog"
                :appended="true"
                @dialogClose="() => this.afterSaleEntryOrderInnerDialog = false"
                @confirmSelection="handleAfterSaleEntryOrderConfirmSelection"
            >
            </new-sku-selection>
            <new-sku-selection
                :teamid="vipName"
                :visible="createAfterSaleEntryOrderInnerDialog"
                :appended="true"
                title="入库单明细选择"
                @dialogClose="() => this.createAfterSaleEntryOrderInnerDialog = false"
                @confirmSelection="(row) => toCreateAfterSaleEntryOrder(row, curAfter)"
            >
            </new-sku-selection>
            <el-dialog :title="createAfterSaleEntryOrderForm.title"
                       :visible.sync="createAfterSaleEntryOrderForm.visible" width="800px" append-to-body>
              <div style="display: flex; justify-content: left;">
                <el-form :model="createAfterSaleEntryOrderForm">
                  <el-form-item label="仓库选择" label-width="90px">
                    <el-select v-model="createAfterSaleEntryOrderForm.warehouseCode" placeholder="请选择仓库"
                               filterable>
                      <el-option v-for="(ware, idx) in erpWarehouses"
                                 :value="ware.warehouseCode" :label="ware.warehouseName"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>

              <div>
                <el-table
                    :data="createAfterSaleEntryOrderForm.items && createAfterSaleEntryOrderForm.items.length ? createAfterSaleEntryOrderForm.items : []"
                    border>
                  <el-table-column label="图片" prop="image" align="center">
                    <template slot-scope="{ row }">
                      <el-image :src="row.image" :preview-src-list="[row.image]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column property="productName" label="商品名" align="center">
                    <template slot-scope="{ row }">
                      {{ row.productName }}
                    </template>
                  </el-table-column>
                  <el-table-column property="code" label="商家编码" align="center">
                    <template slot-scope="{ row }">
                      <span class="sku-code">{{ row.code }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="specs" label="规格" align="center">
                    <template slot-scope="{ row }">
                      {{ row.specs }}
                    </template>
                  </el-table-column>
                  <el-table-column property="planQty" label="入库数量" align="center" width="150px">
                  </el-table-column>
                  <el-table-column property="actualQty" label="需上架数量" align="center" width="160px">
                    <template slot-scope="{ row }">
                      <el-input-number v-model="row.actualQty" :min="0" :max="row.planQty"
                                       size="mini"></el-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="() => this.createAfterSaleEntryOrderForm.visible = false">取 消</el-button>
                <el-button type="primary" @click="doCreateAfterSaleEntryOrder()">确 认</el-button>
              </div>
            </el-dialog>
            <el-dialog title="转次品确认" :visible.sync="transferDefectiveDialog" width="800px" append-to-body>
              <div style="display: flex; justify-content: left;">
                <el-form :model="transferForm">
                  <el-form-item label="次品仓选择" label-width="90px">
                    <el-select v-model="transferForm.warehouseCode" placeholder="请选择次品仓" filterable>
                      <el-option v-for="(ware, idx) in erpWarehouses.filter(w => w.goodsType === 2)"
                                 :value="ware.warehouseCode" :label="ware.warehouseName"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>

              <div>
                <el-table :data="transferForm.items" border>
                  <el-table-column label="图片" prop="image" align="center">
                    <template slot-scope="{ row }">
                      <el-image :src="row.erpSku.image" :preview-src-list="[row.erpSku.image]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column property="productName" label="商品名" align="center">
                    <template slot-scope="{ row }">
                      {{ row.erpSku.productName }}
                    </template>
                  </el-table-column>
                  <el-table-column property="code" label="商家编码" align="center">
                    <template slot-scope="{ row }">
                      <span class="sku-code">{{ row.itemCode }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="specs" label="规格" align="center">
                    <template slot-scope="{ row }">
                      {{ row.erpSku.specs }}
                    </template>
                  </el-table-column>
                  <el-table-column property="planQty" label="签收数量" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number style="width: 110px;" v-model="row.planQty" :max="1" :min="0" size="mini">
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column prop="defective" label="次品描述" align="center" width="250px">
                    <template slot-scope="{ row }">
                      <el-input v-model="row.defective" placeholder="次品描述;将体现在标签上" clearable></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="() => this.transferDefectiveDialog = false">取 消</el-button>
                <el-button type="primary" @click="transferToDefective()">确 认</el-button>
              </div>
            </el-dialog>
            <div style="display: flex; justify-content: flex-start;">
              <el-button icon="el-icon-plus" type="primary" size="mini"
                         @click="() => this.createAfterSaleEntryOrderInnerDialog = true">新建入库单
              </el-button>
            </div>
            <div v-for="(entryOrder, index) in curAfter.entryOrderList">
              <div style="display: flex; align-items: center;" class="entry_btn_div">
                <el-divider content-position="left">
                  <el-tag :type="getTagTypeByStatus(entryOrder.status)" effect="plain" size="small"
                          style="margin-right: 5px;">{{ entryOrder.statusDesc }}
                  </el-tag>
                  {{ entryOrder.orderTypeDesc }}单[{{ index + 1 }}] -
                  【{{ entryOrder.warehouseVo.warehouseName }}({{ getWarehouseType(entryOrder.warehouseVo.goodsType) }})】
                </el-divider>
                <!--                <div v-if="entryOrder.editing">-->
                <!--                  <el-button type="primary" size="mini" @click="editEditingItem()">新增明细</el-button>-->
                <!--                </div>-->
                <div v-if="entryOrder.editing && !isDefectiveOrder(entryOrder)">
                  <el-button type="warning" size="mini" @click="toTransferToDefective(entryOrder)">转次品</el-button>
                </div>
                <div v-if="entryOrder.editing">
                  <el-button type="danger" size="mini" @click="toCloseEntryOrder(entryOrder)">作废</el-button>
                </div>
                <div v-if="!entryOrder.editing">
                  <el-button type="warning" size="mini" @click="toEditEntryOrder(entryOrder)">编辑</el-button>
                </div>
                <div v-if="entryOrder.editing">
                  <el-button type="info" size="mini" @click="cancelEditEntryOrder(entryOrder)">取消编辑</el-button>
                </div>
                <div v-if="entryOrder.editing">
                  <el-button type="success" size="mini" @click="finishEditEntryOrder(entryOrder)">完成编辑</el-button>
                </div>
              </div>
              <div>
                <el-table @selection-change="handleItemsSelectionChange"
                          :data="entryOrder.editing ? entryOrder.editingItems : entryOrder.items" border>
                  <!--                  <el-table-column :selectable="tableSelectable" type="selection" label="选择"-->
                  <!--                                   align="center"></el-table-column>-->
                  <el-table-column label="图片" prop="image" align="center">
                    <template slot-scope="{ row }">
                      <el-image :src="row.erpSku.image" :preview-src-list="[row.erpSku.image]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column property="productName" label="商品名" align="center">
                    <template slot-scope="{ row }">
                      {{ row.erpSku.productName }}
                    </template>
                  </el-table-column>
                  <el-table-column property="code" label="商家编码" align="center">
                    <template slot-scope="{ row }">
                      <span class="sku-code">{{ row.itemCode }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="specs" label="规格" align="center">
                    <template slot-scope="{ row }">
                      {{ row.erpSku.specs }}
                    </template>
                  </el-table-column>
                  <el-table-column label="类型" prop="inventoryTypeDesc" align="center" width="110px"
                                   v-if="!isDefectiveOrder(entryOrder)">
                    <template slot-scope="{ row }">
                      <div>
                        <span v-if="!entryOrder.editing">{{ row.inventoryTypeDesc }}</span>
                        <div v-if="entryOrder.editing">
                          <el-select v-model="row.inventoryType" size="mini">
                            <el-option value="ZP" label="正品"></el-option>
                            <!--                            <el-option value="CC" label="残次"></el-option>-->
                            <el-option value="LP" label="赠品"></el-option>
                          </el-select>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="次品描述" prop="defective" align="center" v-if="isDefectiveOrder(entryOrder)"
                                   width="230px">
                    <template slot-scope="{ row }">
                      <span v-if="!entryOrder.editing">{{ row.defective }}</span>
                      <div v-if="entryOrder.editing">
                        <el-input v-model="row.defective"
                                  placeholder="次品描述；将体现在标签"
                                  size="mini"
                                  clearable></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column property="planQty" label="签收数量" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number v-if="entryOrder.editing" style="width: 110px;" v-model="row.planQty" :min="0"
                                       :max="1"
                                       size="mini" @change="(cur, old) => handlePlanQtyChange(cur, old, row)">
                      </el-input-number>
                      <span v-if="!entryOrder.editing">{{ row.planQty }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="actualQty" label="需上架数量" align="center" width="150px">
                    <template slot-scope="{ row }">
                      <el-input-number v-if="entryOrder.editing" style="width: 110px;" v-model="row.actualQty" :min="0"
                                       :max="row.planQty"
                                       size="mini">
                      </el-input-number>
                      <span v-if="!entryOrder.editing">{{ row.actualQty }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="confirmQty" label="上架数量" align="center">
                    <template slot-scope="{ row }">
                      <span v-if="row.id">{{ row.confirmQty }}</span>
                      <span v-else>---</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="operation" align="center" width="120px">
                    <template slot-scope="{ row }">
                      <div class="op_div">
                        <div>
                          <el-button v-if="row.id" type="default" size="mini"
                                     @click="reprintAfterSaleLabel(entryOrder, row)">重打标签
                          </el-button>
                          <el-button v-if="row.id" type="default" size="mini"
                                     @click="printTagLabelForEntryOrder(entryOrder)">打印合格证
                          </el-button>
                        </div>
                        <!--                        <div>-->
                        <!--                          <el-button type="primary" size="mini" v-if="entryOrder.editing" @click="editEditingItem(row)">-->
                        <!--                            更换规格-->
                        <!--                          </el-button>-->
                        <!--                        </div>-->
                        <!--                        <div>-->
                        <!--                          <el-button type="danger" size="mini" v-if="entryOrder.editing"-->
                        <!--                                     @click="deleteEntryOrderItem(entryOrder, row)">删除-->
                        <!--                          </el-button>-->
                        <!--                        </div>-->
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="display: flex; align-items: center; justify-content: left; margin-top: 12px;">
                <span style="font-weight: bold; color: #303133;">单据备注：</span>
                <span style="color: #606266;"> {{ entryOrder.remark }} </span>
                <el-button style="margin-left: 5px;" type="default" size="mini" icon="el-icon-edit"
                           @click="editEntryOrderRemark(entryOrder, 'remark')"></el-button>
              </div>
              <div style="display: flex; align-items: center; justify-content: left; margin-top: 12px;">
                <span style="font-weight: bold; color: #303133;">内部备注：</span>
                <span style="color: #606266;"> {{ entryOrder.innerRemark }} </span>
                <el-button style="margin-left: 5px;" type="default" size="mini" icon="el-icon-edit"
                           @click="editEntryOrderRemark(entryOrder, 'innerRemark')"></el-button>
              </div>
              <div class="dashed_line" v-if="index < curAfter.entryOrderList.length - 1">
              </div>
            </div>
          </el-dialog>
        </div>

        <div style="margin-top: 5px;">
          <el-form :inline="true" class="demo-form-inline" v-model="afterSaleForm">
            <div style="display: flex; justify-content: left;">
              <el-form-item class="deliver-taq" label="物流单号">
                <el-input
                    placeholder="物流单号/手机号"
                    v-model="qrText"
                    @keyup.native="handleWaybillKeyUp"
                    style="width: 200px;"
                    clearable
                    ref="waybillInputRef"
                >
                </el-input>
                <!--                <el-button @click="onAfterSaleProcessComplete">聚焦</el-button>-->

                <el-button style="margin-left: 8px;" @click="waybillScan($event, null, true)">确认</el-button>
              </el-form-item>
              <el-form-item label="客户" class="deliver-taq">
                <el-select style="width: 150px;" @change="changeVip" v-model="vipName" placeholder="请选择" filterable
                           clearable>
                  <el-option
                      v-for="item in vips"
                      :key="item.teamId"
                      :label="item.teamName"
                      :value="item.teamId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库" class="deliver-taq">
                <el-select style="width: 180px;" @change="warehouseCodeChange" v-model="warehouseCode"
                           placeholder="请选择"
                           filterable>
                  <el-option
                      v-for="ware in erpWarehouses"
                      :key="ware.warehouseCode"
                      :label="ware.warehouseName"
                      :value="ware.warehouseCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="deliver-taq">
                <el-switch
                    v-model="labelPrinter"
                    @change="labelPrinterChange"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="本地"
                    inactive-text="云">
                </el-switch>
              </el-form-item>
              <el-form-item label="标签机" class="deliver-taq">
                <el-select
                    style="width: 100px;"
                    @change="changePrinter"
                    v-model="printerCode"
                    placeholder="选择标签机"
                >
                  <el-option
                      v-for="item in printerCodes"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="display: flex; justify-content: left;">
              <!-- 拦截件模式才有 -->
              <el-form-item class="deliver-taq" label="原面单ID" v-if="workMode===1">
                <el-input v-model="originWaybillId" placeholder="原面单ID(处理换单)"
                          @keyup.enter.native="showOriginWaybill"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div style="display: flex; justify-content: left;">
              <el-form-item class="deliver-taq" label="处理内容">
                <el-select v-model="workMode" @change="handleWorkModeChange" placeholder="处理内容">
                  <el-option
                      v-for="item in workModes"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="转异常处理" class="deliver-taq">
                <el-select v-model="unusual" placeholder="异常原因" clearable>
                  <el-option
                      v-for="item in unusuals"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                  >
                  </el-option>
                </el-select>
                <el-button style="margin-left: 8px;" type="danger" @click="toUnusual">确认</el-button>
                <after-sale-order-sync-btn style="margin-left: 12px;"></after-sale-order-sync-btn>
              </el-form-item>
            </div>

          </el-form>
        </div>
        <el-popover
            refs="myPopover"
            trigger="manual"
            popper-class="waybill-popover"
            v-model="popVisible"
            :visible-arrow="false"
            :style="`width: ${waybillPopoverWidth}; max-width: ${waybillPopoverWidth};`"
        >
          <div style="text-align: center; background: yellow; overflow: hidden; box-sizing: border-box; width: 100%;">
          <span
              :style="`font-size: clamp(40px, 8vw, ${waybillFontSize}px); color: black; white-space: nowrap; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis;`">{{
              scanWaybillId
            }}</span>
          </div>
        </el-popover>
        <el-row>
          <div v-if="workMode === 0 || workMode === 3">
            <el-card v-if="afterList && afterList.length">
              <el-card v-for="(order, idx) in afterList" :key="order.aftersaleId">
                <div slot="header" class="clearfix">
                  <span> {{ order.applyTime }}</span>
                  <span>| {{ order.reasonDesc }}</span>
                  <span>| {{ order.refundStatusDesc }}</span>
                  <span>| {{ order.shopName }}</span>
                  <span v-if="order.refundKind">| <span
                      style="font-weight: bold; color: #E6A23C;">{{ order.refundKindDesc }}</span></span>
                </div>
                <div
                    v-for="(child, childIndex) in order.items"
                    :key="child.orderId"
                    class="text item"
                >
                  <el-row>
                    <el-col :span="9">
                      <img
                          :src="child.productVo.lbImages[0].url"
                          style="width: 334px"
                      />
                    </el-col>
                    <el-col :span="9">
                      <div class="split" v-if="child.platform === 21">
                        <div>奇门订单号: {{ child.pid }}</div>
                        <div>{{ getPlatformOrderLabel(child.orderVo.originOrderPlatform) }}:
                          {{ child.orderVo.originOrderId }}
                        </div>
                      </div>
                      <div class="split" v-if="child.platform === 5">
                        <div>视频号订单号: {{ child.pid }}</div>
                        <div>毅播订单号: {{ child.orderId }}</div>
                      </div>
                      <div class="split" v-else-if="child.platform === 17">
                        <div>有赞订单号: {{ child.pid }}</div>
                        <div>退款子订单号: {{ child.orderId }}</div>
                      </div>
                      <div class="split" v-else-if="child.platform === 18">
                        <div>小红书订单号: {{ child.pid }}</div>
                        <div>毅播订单号: {{ child.orderId }}</div>
                      </div>
                      <div class="split" v-else>{{ child.orderId }}</div>
                      <div class="split">标题：
                        <span v-html="getItemProductName(child.productVo.name)"></span>
                      </div>
                      <div class="split">
                        商品编码：<span style="font-weight: bold; color: red; font-size: xx-large;">
                        {{ child.orderVo ? child.orderVo.code : "" }}
                        <template>
                          <el-button type="text" size="mini" @click="() => updateCode(child.orderVo)">
                            更新编码
                          </el-button>
                        </template>
                      </span>
                      </div>
                      <div class="split">
                        规格：{{ child.productVo.specs.name }} *
                        <span style="font-weight: bold; color: red; font-size: 26px;">
                          {{ child.num }}
                        </span>
                      </div>

                      <div class="split">
                        备注: {{ order.recordItems[0].remark }}
                      </div>
                      <div class="split">
                        客服备注:
                        {{ order.orderVo ? order.orderVo.seller_remark : "" }}
                      </div>

                      <div v-if="getItemOrderVoView(child).visible" class="split">
                        实付金额：<span
                          style="font-weight: bold; color: #67C23A;">{{ getItemOrderVoView(child).payAmount }}</span>
                        <span style="margin: 0 8px;">/</span>
                        退款金额：<span
                          style="font-weight: bold; color: #F56C6C;">{{ getItemOrderVoView(child).refundAmount }}</span>
                      </div>
                      <div class="split">
                        <el-link type="primary" @click="() => toLoadMorePictures(child)">更多图片</el-link>
                      </div>
                    </el-col>
                    <el-col :span="6" v-if="workMode === 0">

                      <div class="split">
                        <el-button type="primary" v-if="!child.giveaway && childIndex === 0"
                                   :disabled="!!(order.entryOrderList && order.entryOrderList.length)"
                                   @click="confirmRec(order, child, 0)"
                        >退款收货
                        </el-button>
                      </div>
                      <div class="split">
                        <el-button type="success" v-if="!child.giveaway && childIndex === 0"
                                   :disabled="!!(order.entryOrderList && order.entryOrderList.length)"
                                   @click="confirmRec(order, child, 1)"
                        >换货收货
                        </el-button>
                      </div>
                      <div class="split">
                        <el-button type="info" v-if="!child.giveaway && childIndex === 0"
                                   :disabled="!!(order.entryOrderList && order.entryOrderList.length)"
                                   @click="confirmRec(order, child, 2)"
                        >仅收货
                        </el-button>
                      </div>
                      <div class="split" v-if="childIndex === 0">
                        <el-button type="warning" v-if="order.entryOrderList && order.entryOrderList.length"
                                   @click="showEntryOrders(order)">入库单详情
                        </el-button>
                      </div>

                      <div v-if="child.giveaway" style="color: grey; font-weight: bold;">
                        <div>
                          <el-tag style="margin-right: 8px;" type="success" effect="plain" size="small">提示</el-tag>
                          赠品签收请在
                        </div>
                        <div>主商品处一并处理</div>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="dashed_line" v-if="childIndex < order.items.length - 1"></div>
                </div>
              </el-card>
            </el-card>
          </div>
          <div>
            <el-card v-if="workMode === 1 && waybillInterceptDto.afterList && waybillInterceptDto.afterList.length">
              <div style="margin-bottom: 12px; font-weight: bold; font-size: 18px;">
                【{{ waybillInterceptDto.isYiboSend ? '毅播发出' : '非毅播发出' }}】拦截件处理
              </div>
              <div style="margin-bottom: 12px;">
                <el-button type="default" @click="addInterceptRemark(waybillInterceptDto)">拦截件备注</el-button>

                <el-button type="primary"
                           :disabled="!!(waybillInterceptDto.entryOrderList && waybillInterceptDto.entryOrderList.length)"
                           @click="firmRecWaybillIntercept(waybillInterceptDto)">拦截件签收
                </el-button>

                <el-button type="warning"
                           v-if="waybillInterceptDto.entryOrderList && waybillInterceptDto.entryOrderList.length"
                           @click="showEntryOrders(waybillInterceptDto)">入库单详情
                </el-button>
              </div>
              <el-card
                  v-for="(child, idx) in waybillInterceptDto.afterList"
                  :key="child.order_id"
              >
                <el-row>
                  <el-col :span="9">
                    <img :src="child.product_pic" style="width: 334px"/>
                  </el-col>
                  <el-col :span="9">
                    <div class="split" v-if="child.platform === 5">
                      <div>视频号订单号: {{ child.pid }}</div>
                      <div>毅播订单号: {{ child.order_id }}</div>
                    </div>
                    <div class="split" v-else>{{ child.order_id }}</div>
                    <div class="split">
                      <span v-html="getItemProductName(child.product_name)"></span>
                    </div>
                    <div>
                      <span style="font-weight: bold; color: red; font-size: xx-large;">{{ child.code }}
                        <el-button type="text" size="mini" @click="() => updateCode(child)">
                          更新编码
                        </el-button>
                      </span>
                    </div>
                    <div class="split">
                      {{ child.specs }} * {{ child.combo_num }}
                    </div>

                    <div class="split">备注: {{ child.custom_remark }}</div>
                    <div class="split">客服备注: {{ child.seller_remark }}</div>
                    <div class="split">拦截件备注: {{ child.interceptRemark }}</div>
                  </el-col>
                </el-row>
              </el-card>
            </el-card>
          </div>
        </el-row>
      </div>

      <div v-if="view === 7">
        <div>
          <el-row style="margin-top: 20px">
            <el-col :span="3" v-if="packageWaybillMode === 0"><p style="margin-left: 0">包裹扫码区</p></el-col>
            <el-col :span="3" v-if="packageWaybillMode === 1"><p style="margin-left: 0">物流单扫描</p></el-col>
            <el-col :span="6" v-if="packageWaybillMode === 0">
              <el-input
                  placeholder="扫描物流单"
                  :value="packageWaybill"
                  @input="packageWaybillInput"
                  @keyup.enter.native="scanPackageWaybill"
                  clearable
                  :autofocus="true"
              >
              </el-input>
            </el-col>
            <el-col :span="2" v-if="packageWaybillMode === 0">
              <el-button type="primary" @click="scanPackageWaybill">确认</el-button>
            </el-col>
            <el-col :span="5" v-if="packageWaybillMode === 1">
              <el-input
                  placeholder="扫描物流单"
                  :value="packageWaybill"
                  @input="packageWaybillInput"
                  @keyup.enter.native="packageWaybillQuery()"
                  clearable
                  :autofocus="true"
              >
              </el-input>
            </el-col>
            <el-col :span="5" v-if="packageWaybillMode === 1" style="margin-left: 5px;">
              <el-date-picker
                  v-model="dates"
                  :picker-options="pickerOptions2"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 350px"
                  align="right"
              />
            </el-col>
            <el-col :span="2" v-if="packageWaybillMode === 1" style="margin-left: 120px">
              <el-button type="primary" @click="packageWaybillQuery()">查询</el-button>
            </el-col>
            <el-col :span="6" style="margin-left: 0px;">
              模式：
              <el-select v-model="packageWaybillMode" placeholder="请选择模式">
                <el-option :value="0" label="扫码"></el-option>
                <el-option :value="1" label="查询"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-left: 22px;">
            <el-col :span="6" style="margin-left: 0px;">
              快递员：
              <el-select v-model="courierUserSelected" placeholder="快递员" @change="handleCourierChange">
                <el-option :value="1" label="屏山-快递员"></el-option>
                <el-option :value="2" label="市桥-快递员"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" style="margin-left: 0px;" v-if="packageWaybillMode === 1">
              <el-button @click="exportCourierScanRecords" type="success">导出</el-button>
            </el-col>
          </el-row>
          <div style="margin-top: 10px" v-if="packageWaybillMode === 0">
            <el-row>
              <el-col :span="22">
                <el-table
                    :data="packageWaybillList"
                    border
                    style="width: 100%; margin-top: 26px"
                >
                  <el-table-column prop="createdTime" label="时间" align="center"></el-table-column>
                  <el-table-column prop="waybillId" label="物流单号" align="center"></el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
          <div style="margin-top: 10px" v-if="packageWaybillMode === 1">
            <el-row>
              <el-col :span="22">
                <el-table
                    :data="expressDeliveryList"
                    v-loading="expressDeliveryLoading"
                    border
                    style="width: 100%; margin-top: 26px"
                >
                  <el-table-column prop="createdTime" label="时间" align="center"></el-table-column>
                  <el-table-column prop="waybillId" label="物流单号" align="center"></el-table-column>
                </el-table>
                <el-pagination
                    @current-change="handleExpressDeliveryPageChange"
                    :current-page.sync="pageInfo.page"
                    :page-size="pageInfo.size"
                    layout="total, prev, pager, next"
                    :total="pageInfo.total">
                </el-pagination>

              </el-col>
            </el-row>

          </div>
        </div>
      </div>

      <div>
        <el-dialog
            title="是否配货正确？"
            :visible.sync="confirmDialog"
            width="50%">
          <el-image style="height: 220px; width: 200px" :src="productConfirm.productPic"
                    :preview-src-list="[productConfirm.productPic]">
          </el-image>
          <div style="font-size: 16px; font-weight: bold;">商品名称：{{ productConfirm.productName }}</div>
          <div style="font-size: 16px; font-weight: bold;">商家编码：{{ productConfirm.code }}</div>
          <div style="font-size: 16px; font-weight: bold;">规格：{{ productConfirm.specs }}</div>
          <span slot="footer" class="dialog-footer">
        <el-button @click="cancelProductConfirm">取 消</el-button>
        <el-button type="primary" @click="productConfirmForBatch">确 认</el-button>
      </span>
        </el-dialog>
      </div>
      <el-image v-show="false"
                ref="imgRef2"
                :preview-src-list="morePicDialog.productImages"></el-image>
    </div>
  </div>
</template>

<script>
import printerCodeUtils from "~/utils/printerCodeUtils";
import local_printer from "~/utils/local_printer";
import afterSaleApi from "~/request/afterSaleApi";
import erpCloudWarehouseApi from "~/request/newSys/erpCloudWarehouseApi";
import erpAfterSaleApi from "~/request/newSys/erpAfterSaleApi";
import entryOrderApi from "~/request/newSys/entryOrderApi";
import userApi from "~/request/userApi";
import request from "~/request/request";
import packagedApi from "~/request/packagedApi";
import printer from "~/utils/printer";
import davinci_printer from "~/utils/davinci_printer";
import ks_printer from "~/utils/ksPrinter";
import pddPrinter from "~/utils/pddPrinter";
import entryOrderStatus, {EntryOrderStatus} from "~/utils/newSys/entryOrderStatus";
import entryOrderTypeUtil, {EntryOrderType} from "~/utils/newSys/entryOrderType";
import warehouseApi from "~/request/warehouseApi";
import cloudprint from "~/service/cloudprint";
import erpProductApi from "~/request/newSys/erpProductApi";
import timeUtil from "~/utils/timeUtil";
import slsApi from "~/request/slsApi";
import uuid from "~/utils/uuid";
import actionStatusUtils from "~/utils/actionStatusUtils";
import debounce from "~/utils/debounce";
import printerNotifier from "~/utils/printerNotifier";
import productApi from "~/request/productApi";
import utils from "~/utils";
import errorUtils from "~/utils/errorUtils";
import {createScannerHandler} from "~/utils/scannerUtils";
import UserTokenUtils from "~/utils/userTokenUtils";
import platformUtils from "~/utils/platformUtils";
import skuUtiltiyApi from "~/request/skuUtiltiyApi";
import exchangeUnusualFlow from "~/utils/exchangeUnusualFlow";

// 单次取单上限；页面显示数量由前端分页独立控制。
const PICKING_TASK_FETCH_SIZE = 9999

const texts = []

export default {
  mixins: [exchangeUnusualFlow],
  filters: {
    // 截断长文本的过滤器
    truncate(value) {
      if (!value) return '';
      if (value.length <= 10) return value;
      return value.substring(0, 8) + '...';
    }
  },
  props: {
    fromLogisticsId: {
      type: Number,
      default: null
    },

    fromTeamId: {
      type: Number,
      default: null
    },
    fromView: {
      type: Number,
      default: 1
    },
    fromWorkMode: {
      type: Number,
      default: 0
    },
    loginInfo: {
      type: Object,
      default: function () {
        return {
          userId: 0,
          name: '未登录'
        }
      }
    },
    fromVips: {
      type: Array,
      default: () => []
    },
    fromPrinterCode: {
      type: String,
      default: null
    },
    fromDeliveryPrinters: {
      type: Array,
      default: () => []
    },
    fromQrText: {
      type: String,
      default: null
    },
    fromOriginWaybill: {
      type: String,
      default: null
    },
    fromAutoWaybill: {
      type: Boolean,
      default: false
    },
    waybillFontSize: {
      type: Number,
      default: 180
    }
  },
  name: "index",
  data() {
    return {
      enableGlobalScanListener: false,
      globalScanner: null,
      waybillScanner: null,

      lastScanTimer: null,
      matchChannel: '',
      matchChannels: [
        // {label: '未选择', value: ''},
        {label: '托管-配单', value: '2'},
        {label: '到货-配单', value: '0'},
        {label: '售后-配单', value: '3'}
      ],

      matchChannel2: '0',

      multipleOrdersRequestID: null,

      view: 1,
      userInfo: {},
      vipName: null,
      warehouseCode: '',

      qrText: '',
      labelPrinter: null,
      printerCodes: [],
      printerCode: null,

      workMode: 0,
      afterList: [],
      changeWaybillId: '',
      originWaybillId: '',
      popVisible: false,
      unusuals: [
        {
          name: '换货',
          code: 8,
        },
        {
          name: "无头件",
          code: 1,
        },
        {
          name: "多件",
          code: 2,
        },
        {
          name: "少件",
          code: 3,
        },
        {
          name: "错件",
          code: 4,
        },
        {
          name: "影响二次销售",
          code: 5,
        },
        {
          name: "换单拦截",
          code: 6,
        },
        {
          name: '售后关闭',
          code: 7,
        }

      ],
      unusual: null,
      scanWaybillId: '',

      keyUpLastTime: null,
      continuousCount: 0,
      realQrText: '',
      lastKey: '',
      fakeEnter: false,
      lastGap: 0,

      workModes: [
        {
          name: "拆包处理",
          code: 0,
        },
        {
          name: "拦截件",
          code: 1,
        },
        {
          name: "售后查询",
          code: 3
        }
      ],

      erpWarehouses: [],
      erpWarehousesLoading: false,

      afterSaleForm: {},

      afterSaleConfirmDto: {
        dialogVisible: false,
        items: [],
        printQualifiedCert: false, // 是否打印合格证（用于processAfterSale）
        interceptPrintQualifiedCert: false // 是否打印合格证（用于receiveIntercept）
      },
      rowToUpdate: null,
      curAfter: {
        entryOrderList: []
      },
      afterSaleEntryOrderDialog: false,
      itemsSelections: [],
      editingEntryOrderId: null,

      afterSaleEntryOrderInnerDialog: false,
      editingItemToUpdate: null,
      transferForm: {},
      transferDefectiveDialog: false,
      formLabelWidth: '120px',
      waybillInterceptDto: {
        afterList: []
      },
      form: {},

      printers: [],
      printerName: '',

      qrTextQueue: [],
      taskGroup: {id: 0, title: "未分配"},
      taskGroups: [],
      pickingStockOutId: null,
      pickingTasks: [],
      pickingTasksLoading: false,
      pickingOrdersLoading: false,
      pickingSendInProgress: false,
      pickingScopeVersion: 0,
      multiGroupQrText: '',
      multipleSearchQrText: '',

      allMatchQrText: '',

      multiSendResult: new Map(),
      multiChangeableList: [],
      multiChangeableDialog: false,
      multiPageSize: 10,
      multipleRenderPage: 1,
      multipleRenderPageSize: 10,
      multipleOrders: [],
      teamId: null,
      taskGroupCreateViewable: false,
      codeList: [],
      taskCode: [],

      qrTextInfo: '',
      qrSelected: '',
      filterSelected: 3,

      productConfirm: {},
      confirmDialog: false,
      courierInfo: {},

      qrCode: '',
      records: [],
      statusMap: {},
      waybillSelections: [],
      packageWaybillMode: 0,
      packageWaybill: '',
      packageWaybillList: [],
      courierUserSelected: 1,

      dates: [],
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)

              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      expressDeliveryList: [],
      pageInfo: {
        page: 0,
        size: 30,
        total: 0
      },
      expressDeliveryLoading: false,
      createAfterSaleEntryOrderInnerDialog: false,
      createAfterSaleEntryOrderForm: {},

      morePicDialog: {
        productImages: [],
        showImages: (images) => {
          this.$set(this.morePicDialog, 'productImages', images)
          this.$refs.imgRef2.showViewer = true
        }
      },

      selections: [],
      currentRequestID: null,

      autoTeam: true,

      // 自动发货相关数据
      autoSendQrText: '',
      autoSendData: {
        scannedCodes: [], // 已扫描的条码列表
        codeCounts: {} // 每个code的计数
      },
      autoSendMode: false,
      lastDeletedCode: null, // 最近删除的条码
      recentShipments: [], // 最近发货记录栈
      verifyMode: false, // 播种校验模式
      sowingInOrder: false, // 播种校验是否按格号顺序发货
    }
  },


  watch: {
    filteredMultipleOrders() {
      this.multipleRenderPage = 1
    }
  },
  methods: {
    updateCode(child) {
      const {skuId, platform} = child
      this.findSkuByIdThen(skuId, platform + '', stdSku => {
        if (stdSku.code === child.code) {
          this.$message.warning('链接最新编码与当前编码一致，无需更新')
        } else {
          this.$set(child, 'code', stdSku.code)
          this.$message.success('更新成功')
        }
      })
    },

    findSkuByIdThen(skuId, platform, callback) {
      const loading = utils.getGlobalLoading()
      skuUtiltiyApi.findSkuById(skuId, platform).then(stdSku => {
        if (callback) {
          callback(stdSku)
        }
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        loading.close()
      })
    },

    pullErpSkuByCode(teamId, code) {
      const loading = utils.getGlobalLoading()
      erpProductApi.pullProductBySkuCode(teamId, code).then(() => {
        this.$message.success('拉取成功')
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        loading.close()
      })
    },

    getPlatformOrderLabel(originOrderPlatform) {
      const platformName = platformUtils.getPlatform(originOrderPlatform);
      return platformName ? `${platformName}订单号` : '交易平台订单号';
    },
    getGlobalScannerHandler() {
      return createScannerHandler({
        onComplete: qrText => {
          this.vipName = ''
          this.qrText = qrText
          this.waybillScan(this.event, null, true)
        },
        minLength: 7,
        maxInterval: 100
      })
    },

    onAfterSaleProcessComplete() {
      // 清空输入框
      this.qrText = ''
      // 聚焦输入框
      this.$refs.waybillInputRef.focus()
    },

    getMessage(message) {
      return message.replace('盒子发货', `<span style="color: #67C23A; font-weight: bolder;">盒子发货</span>`)
    },

    toLoadMorePictures(item) {
      const {pid} = item.productVo
      const {shopId, platform, productImages} = item
      if (productImages) {
        this.morePicDialog.showImages(productImages)
        return
      }

      // console.log('@@@ddd', pid, shopId, platform)
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      productApi.productDetailForVariousPlatforms({
        productId: pid,
        shopId,
        platform
      }).then(data => {
        // console.log('@productDetail@@', data)
        const {lbImages, xqImages} = data
        item.productImages = [...lbImages, ...xqImages].map(img => img.url)
        this.morePicDialog.showImages(item.productImages)
      }).catch(err => {
        console.error(err.message)
        this.$message.error(err.message)
      }).finally(() => {
        loading.close()
      })
    },

    getItemProductName(productName) {
      productName = productName || ''
      const pattern = /\w*\d{3,}/g
      const matches = productName.match(pattern)
      if (matches && matches.length) {
        matches.forEach(mc => {
          productName = productName.replace(mc, `<span style="color: red; font-weight: bold; font-size: xx-large;">${mc}</span>`)
        })
      }
      return productName
    },

    getItemOrderVoView(child) {
      const orderVo = child.orderVo || {}
      const confirmPlatforms = [0, 1, 7, 16, 17]
      const refundAmount = child.refundAmount || child.refundFee
      return {
        visible: confirmPlatforms.includes(child.platform),
        payAmount: orderVo.payAmount / 100 || '-',
        refundAmount: refundAmount / 100 || '-'
      }
    },

    reprintable(row, index) {
      const {printData, waybillId} = row
      return printData && waybillId
    },


    reprintWaybills() {
      const selections = this.selections
      if (!selections.length) {
        this.$message.warning('请勾选需要重打的项目')
        return
      }
      let printerName = this.printerName
      this.$confirm('确认批量重打？', '提示').then(() => {
        this.doBatchReprintPromise(0, selections, printerName).then(() => {
          this.$message.success('已重打')
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    },

    clearPrintResultResult() {
      cloudprint.resetCloudPrinter()
      this.$message.success('清除成功！')
    },

    waybillInterceptPreQueryPromise(waybill, selectedTeam) {
      // 返回值的说明：
      // 0 直接继续查询，1 切换团队系统不切换 2 切换团队 切换系统
      return new Promise((resolve, reject) => {
        afterSaleApi.findSourceByInterceptWaybill(waybill).then(source => {
          const {teamId, version} = source
          if (teamId !== selectedTeam) {
            const result = !!version ? 1 : 2
            const callback = result === 1 ? () => {
              this.waybillScan()
            } : null
            this.changeVip(teamId, callback)
            resolve(result)
          } else {
            resolve(0)
          }
        }).catch(err => {
          if (selectedTeam) {
            resolve(0)
          } else {
            reject(err)
          }
        })
      })
    },

    markItem(row, listField) {
      const afterSaleConfirmDto = this.afterSaleConfirmDto
      const item = JSON.parse(JSON.stringify(row))
      let toAddList = afterSaleConfirmDto[listField]
      const num = row.num
      if (num > 1) {
        this.$set(row, 'num', num - 1)
      } else {
        let {items} = afterSaleConfirmDto
        this.$set(afterSaleConfirmDto, 'items', items.filter(it => it.orderVo.code !== row.orderVo.code))
      }
      this.handlePlanQtyChange(row.num, num, row)

      toAddList = toAddList ? toAddList : []
      const index = toAddList.findIndex(it => it.orderVo.code === item.orderVo.code)
      if (index > -1) {
        this.$set(toAddList[index], 'num', toAddList[index].num + 1)
      } else {
        item.num = 1
        if (listField === 'defectiveItems') {
          item.defective = item.orderVo && item.orderVo.seller_remark ? item.orderVo.seller_remark : ''
          item.actualQty = 1
        }
        toAddList.push(item)
      }
      this.$set(afterSaleConfirmDto, listField, toAddList)
    },

    revertMarkItem(row, listField) {
      // 如果是拦截商品且要取消次品标记，则不允许
      if (row.intercept && listField === 'defectiveItems') {
        this.$message.warning('拦截商品强制转次品，无法取消！')
        return
      }

      const afterSaleConfirmDto = this.afterSaleConfirmDto
      const item = JSON.parse(JSON.stringify(row))
      let markItems = afterSaleConfirmDto[listField]
      let {items} = afterSaleConfirmDto
      const num = row.num
      if (num > 1) {
        this.$set(row, 'num', num - 1)
      } else {
        this.$set(afterSaleConfirmDto, listField, markItems.filter(it => it.orderVo.code !== row.orderVo.code))
      }
      const index = items.findIndex(it => it.orderVo.code === item.orderVo.code)
      if (index > -1) {
        this.$set(items[index], 'num', items[index].num + 1)
        this.$set(items[index], 'actualQty', items[index].num + 1)
      } else {
        item.num = 1
        item.actualQty = 1
        items.push(item)
      }
      this.$set(afterSaleConfirmDto, 'items', items)
    },

    toCloseEntryOrder(entryOrder) {
      this.$confirm('确认【作废】此单据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateGroupStatus(entryOrder, EntryOrderStatus.Closed, () => {
          this.$message.success('作废单据成功～')
          // 清空历史勾选
          this.itemsSelections = []
          this.$set(entryOrder, 'editing', false)
          this.editingEntryOrderId = null
          this.loadAfterSaleEntryOrder(this.curAfter, true)
        })
      }).catch(() => {
      })
    },

    updateGroupStatus(row, status, callback) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const {id} = row
      const entryOrder = {
        id,
        status
      }
      erpAfterSaleApi.closeAfterSaleEntryOrder(entryOrder).then(() => {
        loading.close()
        if (callback) {
          callback()
        }
      }).catch(err => {
        this.$message.error(err.message)
        loading.close()
      })
    },

    handlePlanQtyChange(cur, old, row) {
      this.$set(row, 'actualQty', cur)
    },

    async sendOrder(order, idx) {
      if (this.pickingOrdersLoading || this.pickingSendInProgress) return
      const scope = this.capturePickingScope()
      if (!scope.warehouseCode) {
        this.$message.warning('请选择仓库')
        return
      }
      if (!this.multipleOrders.some(item => String(item.order_id) === String(order.order_id))) {
        this.$message.warning('发货任务已更新，请重新扫码')
        return
      }
      try {
        await this.$confirm('是否确认已经配齐？', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'})
      } catch (err) {
        return
      }
      if (!this.isPickingScopeCurrent(scope) || this.pickingOrdersLoading || this.pickingSendInProgress) {
        this.$message.warning('发货任务已更新，请重新扫码')
        return
      }
      const userId = this.userInfo.userId
      if (!userId) {
        this.$message.error('请先登录')
        return
      }
      this.pickingSendInProgress = true
      try {
        const printData = await warehouseApi.multipleOrderSend(order.order_id, this.logisticsId, userId, scope.warehouseCode, scope.stockOutId)
        if (printData.status !== 0) {
          await this.$alert(printData.errorMsg || '发货失败', '发货失败', {confirmButtonText: '确定'})
          return
        }
        this.$emit('waybillPopoverQueueUpdate', printData.waybillId)
        this.$emit('showWaybillPopover')
        try {
          await cloudprint.doPrint(printData, this.printerName)
          await this.$alert(printData.errorMsg || '发货成功', '获取成功', {confirmButtonText: '确定'})
        } catch (err) {
          await this.$alert(err.message, '打印错误', {confirmButtonText: '去解决'})
        }
      } catch (err) {
        this.$message.error(err.message || '多件发货失败')
      } finally {
        if (this.isPickingScopeCurrent(scope)) {
          await this.loadMultipleOrders(scope.teamId, true)
        }
        this.pickingSendInProgress = false
      }
    },

    getRequestID() {
      return uuid.getUUID(8, 16)
    },

    exportCourierScanRecords() {
      const dates = this.dates
      const courierUserSelected = this.courierUserSelected
      if (!dates || dates.length !== 2) {
        this.$message.warning('请选择导出时间范围')
        return
      }
      const query = {
        courierScan: courierUserSelected,
        dateType: 0,
        startTime: dates[0],
        endTime: dates[1],
        warehouseIdList: [1]
      }
      const queryJson = JSON.stringify(query)
      const sessionKey = this.courierInfo.sessionKey
      let url = `/api/yifahuo/afterSale/exportExpressDelivery?queryJson=${queryJson}&sessionKey=${sessionKey}`

      window.open(url, '_blank')
    },

    handleCourierChange(val) {
      this.packageWaybillList = []
    },

    handleExpressDeliveryPageChange(val) {
      this.packageWaybillQuery(val - 1)
    },

    packageWaybillQuery(page) {
      page = page || 0
      const packageWaybill = this.packageWaybill || null
      const dates = this.dates
      let startTime = null
      let endTime = null
      if (dates && dates.length === 2) {
        startTime = dates[0]
        endTime = dates[1]
      }
      const query = {
        waybillId: packageWaybill,
        startTime,
        endTime,
        courierScan: this.courierUserSelected,
        userType: 2
      }
      const sessionKey = this.courierInfo.sessionKey
      this.expressDeliveryLoading = true
      afterSaleApi.expressDeliveryList(query, page, null, sessionKey).then(data => {
        this.expressDeliveryList = data.data
        this.pageInfo.page = data.page
        this.pageInfo.total = data.total
        this.expressDeliveryLoading = false
      }).catch(err => {
        this.$message.error(err.message)
        this.expressDeliveryLoading = false
      })

    },

    scanPackageWaybill() {
      const waybill = this.packageWaybill
      if (!waybill) {
        this.$message.warning("请扫描物流单号!")
        return
      }
      this.outerPopoverMsg = waybill
      this.outerPopVisible = true
      setTimeout(() => {
        this.outerPopVisible = false
      }, 3000)
      afterSaleApi.scanPackageByCourier(waybill, this.courierUserSelected).then(res => {
        this.packageWaybillList.unshift(res)
        if (this.packageWaybillList.length > 30) {
          this.packageWaybillList.pop()
        }
        this.packageWaybill = ''
      }).catch(err => {
        this.$message.error(err.message)
        this.packageWaybill = ''
      })
    },

    packageWaybillInput(value) {
      value += ''
      this.packageWaybill = value
    },

    errOrder(row) {
      let id = row.id
      this.$confirm(row.waybillId + "实际未发出?", "异常订单标记", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        warehouseApi.errOrderSign(id).then(() => {
          this.$message("完成");
        }).catch((err) => {
          this.$alert(err.message);
        })
      })
    },

    handleSelectionChange(selections) {
      this.waybillSelections = selections
    },

    batchReprint() {
      let selections = this.waybillSelections
      if (!selections || !selections.length) {
        this.$message.error("请勾选需要重打的面单")
        return
      }
      let len = selections.length

      this.$confirm(`确认重打勾选的面单,共「${len}」单?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$message({
          message: "重打中...",
          type: "success",
        })
        selections.forEach((item) => {
          this.reprintWaybill(item.waybillId)
        })
        this.waybillSelections = []
      }).catch(() => {
      })
    },

    reprintByQrCode() {
      let qrCode = this.qrCode
      this.$confirm('确认要重新打印面单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reprintWaybill(qrCode)
        this.qrCode = ''
      }).catch(() => {
        this.$message.info('已取消重打面单')
      })
    },

    reprintWaybill(waybillId) {
      let printerName = this.printerName
      // 物流单号重打
      warehouseApi.reprintOrder(waybillId).then((data) => {
        if (data.status === 0) {
          this.$emit('waybillPopoverQueueUpdate', waybillId)
          this.$emit('showWaybillPopover')
          cloudprint.doPrint(data, printerName, true).then(() => {
            // this.$message("获取成功")
          }).catch((err) => {
            this.$alert(err.message, "打印错误", {
              confirmButtonText: "去解决",
            })

          })
        } else {

          this.$alert(data.errorMsg, "打印错误", {
            confirmButtonText: "去解决",
          })
        }
      }).catch((err) => {
        this.$message(err.message)
      })
    },

    queryByQrText() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      let qrText = this.qrCode
      warehouseApi.findSkuSendRecord(qrText, 36).then((data) => {
        data = data.map((o) => {
          const actionStatus = o.actionStatus
          o.orderStatus = this.statusMap[actionStatus]
          o.orderId = o.totalNum > 1 ? `共${o.totalNum}含${o.num}件` : o.orderId
          return o
        })
        loading.close()
        this.$message.info('搜索完成～')
        this.records = data
      }).catch((err) => {
        loading.close()
        this.$message(err.message)
      })
    },

    qrCodeInput(value) {
      this.qrCode = value
    },

    // 异常查询高亮显示
    tableRowclassName_inquire({row, rowIndex}) {
      if (row.actionStatus !== 10) {
        return "warning-row"
      } else if (row.logisticsStatus.indexOf("未揽收") > -1) {
        return "warning-row"
      } else {
        return "success-row"
      }
    },


    multipleSearchQrTextInput(value) {
      this.multipleSearchQrText = value + ''
    },

    transformDeliver(deliver) {
      if (deliver.indexOf('申通') > -1) {
        deliver = deliver.replace('申通', this.elTagGenerator('申通', '#FFE940'))
      }

      if (deliver.indexOf('圆通') > -1) {
        deliver = deliver.replace('圆通', this.elTagGenerator('圆通', 'green'))
      }

      if (deliver.indexOf('中通') > -1) {
        deliver = deliver.replace('中通', this.elTagGenerator('中通', 'blue'))
      }

      if (deliver.indexOf('顺丰') > -1) {
        deliver = deliver.replace('顺丰', this.elTagGenerator('顺丰', 'black'))
      }

      if (deliver.indexOf('京东') > -1) {
        deliver = deliver.replace('京东', this.elTagGenerator('京东', 'red'))
      }
      return deliver
    },

    elTagGenerator(content, type) {
      return `<span style="color: ${type}; font-weight: bold; font-size: 24px;">${content}</span>`
    },

    loadAndSaveCourier() {
      const courierId = '816545130'
      const token = UserTokenUtils.genLoginToken(courierId)
      userApi.userIdLogin(token).then(userInfo => {
        this.courierInfo = userInfo
      }).catch(err => {
        console.log("userIdLogin err", err)
      })
    },

    productConfirmForBatch: debounce(function () {
      this.confirmDialog = false
      const productConfirm = this.productConfirm
      const {info} = productConfirm
      const {value, userId, logisticsId, amount, batchQrId} = info
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.scanQrTextQueue(value, userId, logisticsId, amount, loading, batchQrId, [])
    }, 150),

    cancelProductConfirm() {
      this.confirmDialog = false
      const productConfirm = this.productConfirm
      const {info} = productConfirm
      const {value} = info
      //此条码不算被扫过（没有实际去获取面单），因此去掉这条记录
      let index = texts.indexOf(value)
      if (index > -1) {
        texts.splice(index, 1)
      }
    },

    scanQrTextQueue(value, userId, logisticsId, amount, loading, batchQrId, extraInfoList) {
      if (amount <= 0) {
        loading.close()
        if (extraInfoList && extraInfoList.length) {
          this.$alert(`商家特殊备注有【${extraInfoList.length}】单，请注意`, '提示')
        }
        return false
      }
      let num = amount >= 3 ? 3 : amount
      this.scanQrTextNext(value, userId, logisticsId, num, batchQrId, extraInfoList)
          .then(() => {
            amount -= 3
            // 触发物流弹窗
            this.$emit('showWaybillPopover')
            this.scanQrTextQueue(value, userId, logisticsId, amount, loading, batchQrId, extraInfoList)
          })
          .catch((err) => {
            console.error(err)
            loading.close()
          })
    },

    scanQrTextNext(value, userId, logisticsId, num, batchQrId, extraInfoList) {
      return new Promise((resolve, reject) => {
        warehouseApi
            .scanQrText(value, userId, logisticsId, num, this.matchChannel)
            .then((res) => {
              // console.log(res)
              let printDataList = [];
              let queuePrintDataList = []
              for (let data of res) {
                if (data.status === 0) {
                  // console.log("data", data)
                  printDataList.push(data)
                  let item = this.getItemFromPrintData(data, value)
                  if (item.extraInfo) {
                    extraInfoList.push(item.extraInfo)
                  }
                  this.updatePrintDataList(item, batchQrId);
                  queuePrintDataList.push(item)
                } else {
                  let item = {
                    orderId: "",
                    qrText: value,
                    waybillId: "",
                    message: data.errorMsg,
                    status: data.status,
                    productPic: data.productPic,
                    productName: data.productName,
                    specs: data.spesc,
                    nextStatus: data.nextStatus,
                    errorMsg: data.errorMsg
                  };
                  this.updatePrintDataList(item, batchQrId);
                  queuePrintDataList.push(item)
                  // voice.aplayAudio()
                }
              }
              let printerName = this.printerName;
              if (printDataList.length > 0) {
                this.updatePrintResultForPrintDataList(queuePrintDataList)
                cloudprint
                    .doPrintBath(printDataList, printerName)
                    .then(() => {
                      this.qrText = "";
                      resolve();
                    })
                    .catch((err) => {
                      console.error(err);
                      this.$message.error(err.message);
                      resolve();
                    });
              } else {
                resolve();
              }
            })
            .catch((error) => {
              console.error(error);
              this.$message.error(error.message)
              let errMsg = error.message
              //网络超时
              if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') > -1) {
                errMsg = '网络超时:' + error.message
              } else {
                errMsg = '请求失败：' + error.message
              }
              errMsg += ';少打面单：' + num
              let errItem = {
                orderId: "",
                qrText: value,
                errNum: num,
                message: errMsg
              }
              // console.log('+++--', errItem)
              this.updatePrintDataList(errItem, batchQrId)
              resolve()
            });
      });
    },

    updatePrintDataList(printData, batchQrId) {
      const {qrText, status} = printData
      let queue = this.qrTextQueue
      let qrInfo = queue.find(item => item.qrText === qrText)
      console.log("待push的printData", printData)
      console.log("qrInfo", qrInfo, "传入的batchId", batchQrId)
      if (qrInfo && qrInfo.batchId === batchQrId) {
        //队列里面存在这个条码了，而且是同一批次
        //找到这个条码的信息
        if (status !== 0) {
          this.$set(qrInfo, 'error', true)
        }
        let printDataList = qrInfo.printDataList
        printDataList.unshift(printData)
      } else {
        //队列里面还不存在这个条码,分配一个batchId和当前的时间
        //构造一个qrInfo对象，加进去
        let qrInfo = {
          batchId: batchQrId,
          qrText,
          printDataList: [printData],
          time: timeUtil.format(new Date(), 'hh:mm:ss')
        }
        if (status !== 0) {
          this.$set(qrInfo, 'error', true)
        }
        queue.unshift(qrInfo)
      }
      //批次条码列表默认选中最近的扫码
      this.qrSelected = batchQrId

      if (queue.length > 30) {
        queue.pop()
      }
      this.qrTextQueue = queue

      // let list = this.printDataList;
      // list.unshift(printData);
      //
      // if (list.length > 100) {
      //   list.pop();
      // }
      //
      // this.printDataList = list;
    },

    handleQrChange(val) {

    },

    doBatchReprintPromise(index, selections, printerName) {
      return new Promise(resolve => {
        if (index >= selections.length) {
          resolve()
          return
        }

        const data = selections[index]
        this.doReprintPromise(data, printerName).then(() => {

        }).catch(err => {
          this.$message.error(err.message)
        }).finally(() => {
          this.doBatchReprintPromise(index + 1, selections, printerName)
        })
      })

    },

    reprint(data) {
      // console.log(data);
      let printerName = this.printerName
      if (data.waybillId) {
        this.$confirm(data.waybillId, "是否重新打印").then(() => {
          // 如果是打印状态失败的，重新拿printData重打，其他使用原来的printData重打
          this.doReprintPromise(data, printerName).then(() => {
            // this.$message.success('已打印')
          }).catch(err => {
            this.$message.error(err.message)
          })
        })
      } else {
        this.$message("没有可以打印的内容")
      }
    },

    doReprintPromise(data, printerName) {
      this.updatePrintResultForPrintDataList([data])
      return new Promise((resolve, reject) => {
        warehouseApi.reprintOrder(data.waybillId).then(printData => {
          this.$emit('waybillPopoverQueueUpdate', data.waybillId)
          this.$emit('showWaybillPopover')
          cloudprint.doPrint(printData, printerName, true).then(() => {
            resolve()
          }).catch(reject)
        }).catch(reject)
      })
    },

    getItemFromPrintData(data, value) {
      let isTikshop = false
      if (data.params) {
        isTikshop = true
      }
      let item
      const {waybillId} = data
      this.$emit('waybillPopoverQueueUpdate', waybillId)
      const isBoxSend = data.errorMsg && data.errorMsg.includes('盒子发货')
      if (isTikshop) {
        item = {
          orderId: data.orderId,
          qrText: value,
          waybillId: data.waybillId,
          message: "获取成功" + (isBoxSend ? '; 盒子发货' : ''),
          printData: data.printData,
          status: data.status,
          customArea: data.customArea,
          sender: data.sender,
          standardTemplateUrl: data.standardTemplateUrl,
          params: data.params,
          signature: data.signature,
          productPic: data.productPic,
          productName: data.productName,
          code: data.code,
          specs: data.spesc,
          dataFrom: data.dataFrom,
          nextStatus: data.nextStatus,
          errorMsg: data.errorMsg,
          extraInfo: data.extraInfo
        }
      } else {
        item = {
          orderId: data.orderId,
          qrText: value,
          waybillId: data.waybillId,
          message: "获取成功" + (isBoxSend ? '; 盒子发货' : ''),
          printData: data.printData,
          status: data.status,
          customArea: data.customArea,
          sender: data.sender,
          productPic: data.productPic,
          productName: data.productName,
          specs: data.spesc,
          code: data.code,
          dataFrom: data.dataFrom,
          nextStatus: data.nextStatus,
          errorMsg: data.errorMsg,
          extraInfo: data.extraInfo
        }
      }
      return item
    },

    updatePrintResultForPrintDataList(printDataList) {
      printDataList.forEach(printData => {
        const {waybillId} = printData
        if (waybillId) {
          printerNotifier.addListener(waybillId, 'PRINT_RESULT', printStatus => {
            this.$set(printData, 'printStatus', printStatus)
          })
        }
      })
    },

    refreshPrintResultForRow(row) {
      // console.log('refreshPrintResultForRow', row)
      const index = this.queueIndex
      let queue = this.qrTextQueue
      const batch = queue[index]
      // 只有时分秒，需要处理跨天的情况
      let scanTime = batch.time
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.refreshPrintResultPromise(row, scanTime).then(res => {
        if (res.row && res.result && res.result.length) {
          const task = res.result[0]
          const {printStatus} = task
          const docList = printStatus.filter(status => status.documentID === row.waybillId)
          if (docList && docList.length) {
            this.$set(row, 'printStatus', docList[0])
          }
        }
        this.$message.success('刷新成功!')
        loading.close()
      }).catch(err => {
        this.$message.error('刷新失败：' + err.message)
        loading.close()
      })

    },

    refreshPrintResultForBatch() {
      const index = this.queueIndex
      if (index === -1) {
        this.$message.warning('暂时没有获取面单的记录!')
        return
      }
      let queue = this.qrTextQueue
      const printDataList = queue[index].printDataList
      // console.log('refreshPrintResultForBatch list', printDataList)
      const batch = queue[index]
      let scanTime = batch.time
      // 找到所有查询超时的物流单对应的row
      const unusualRows = printDataList.filter(printData => {
        return printData.printStatus && printData.printStatus.status !== 'success'
      })
      if (!unusualRows || !unusualRows.length) {
        this.$message.warning('没有出单异常的面单!')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      const promises = []
      unusualRows.forEach(row => {
        const promise = this.refreshPrintResultPromise(row, scanTime)
        promises.push(promise)
      })
      Promise.all(promises).then(resultList => {
        resultList.forEach(res => {
          if (res.row && res.result && res.result.length) {
            const row = res.row
            const task = res.result[0]
            const {printStatus} = task
            const docList = printStatus.filter(status => status.documentID === row.waybillId)
            if (docList && docList.length) {
              this.$set(row, 'printStatus', docList[0])
            }
          }
        })
        this.$message.success('刷新成功！')
        loading.close()
      }).catch(err => {
        this.$message.error('错误提示：' + err.message)
        loading.close()
      })
    },

    refreshPrintResultPromise(row, scanTime) {
      // scanTime 只有时分秒，需要处理跨天的情况
      return new Promise((resolve) => {
        const splits = scanTime.split(':')
        const now = new Date()
        const startTime = new Date()
        startTime.setHours(splits[0] * 1)
        startTime.setMinutes(splits[1] * 1)
        startTime.setSeconds(splits[2] * 1)
        if (startTime.getTime() > now.getTime()) {
          startTime.setTime(startTime.getTime() - 1000 * 60 * 60 * 24)
        }
        console.log('startTime', startTime)
        const start = timeUtil.format(startTime, 'yyyy-MM-dd hh:mm:ss')
        const end = timeUtil.format(now, 'yyyy-MM-dd hh:mm:ss')
        const {waybillId} = row
        slsApi.findPrinterResultList(start, end, waybillId).then(res => {
          resolve({result: res, row})
        }).catch(err => {
          resolve({})
        })
      })
    },

    rowClick(row) {
      this.qrSelected = row.batchId
    },

    rowClick2(row) {
      const origin = this.selectedRow
      if (origin) {
        origin.checked = false
      }

      this.selectedRow = row
      this.$set(this.selectedRow, 'checked', true)
    },

    // 发货异常高亮显示
    tableRowClassName({row, rowIndex}) {
      let str = ''
      if (row.message && row.message.includes('获取成功')) {
        str += "success-row"
      } else {
        str += "warning-row"
      }

      if (row.checked) {
        str += ' select-row'
      }
      return str
    },
    // 发货异常高亮显示
    highlightSelected({row, rowIndex}) {
      let cls = ''
      if (row.batchId === this.qrSelected) {
        cls += 'success-row1'
      }

      if (row.error) {
        cls += ' warning-row'
      }
      return cls
    },

    toEditMultiPageSize() {
      const pageSize = this.multiPageSize
      this.$prompt('请输入批次返回的条数', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: pageSize
      }).then(({value}) => {
        value = value * 1
        // console.log('newSize', value, isNaN(value))
        if (isNaN(value) || value <= 0) {
          this.$message.warning('请输入合法的数量!')
          return
        }
        this.multiPageSize = value
        // 重新加载批次信息
        this.changeTaskGroup()
      }).catch(() => {
      })
    },

    getSkuFromQrText() {
      let value = this.qrTextInfo
      let taskCode = this.taskCode
      erpProductApi.findErpSkuVoByQrText(value).then(info => {
        let cf = taskCode.filter(item => {
          return item.code === info.code
        })
        if (cf.length > 0) {
          this.$message('重复了')
          return false
        }
        // 将erpSkuVo构造成matchedOrderVo
        const {image, specs, code, productName} = info
        const vo = {
          product_name: productName,
          product_pic: image,
          code,
          specs
        }
        taskCode.push(vo)
        this.taskCode = taskCode
        this.qrTextInfo = ''
      })
    },

    toConfirmCreate() {
      const warehouseCode = this.warehouseCode
      if (!warehouseCode) {
        this.$message.warning('请选择仓库')
        return
      }
      if (!this.taskCode || this.taskCode.length === 0) {
        this.$message("款式选择错误")
        return false
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      const mo = this.taskCode.map(sk => {
        return {
          num: 1,
          code: sk.code,
        }
      })
      let modal = {
        teamId: this.teamId,
        modals: mo,
        // platform: null 暂时没有设置,
        warehouseCode,
        newSystem: true
      }
      // console.log(modal)
      warehouseApi
          .creatMultipleTaskGroup(modal)
          .then((data) => {
            let taskGroups = this.taskGroups
            taskGroups.push(data)
            this.taskGroup = data
            this.taskGroups = taskGroups
            this.loadMultipleOrders(this.teamId, true)
            // 清空taskCode
            this.taskCode = []
            // 清空扫码
            this.qrTextInfo = ''
            this.taskGroupCreateViewable = false
            loading.close();
          })
          .catch((err) => {
            this.$alert(err.message)
            loading.close()
          })
    },

    changeTaskCode(val) {
      this.taskCode = val
    },

    getMultipleOrderQuerySize(stockOutId = this.pickingStockOutId, taskId = this.taskGroup.id) {
      return stockOutId ? PICKING_TASK_FETCH_SIZE : taskId ? this.multiPageSize : null
    },

    async findMultipleOrdersForScope(scope, taskId, qrText, isCurrent = () => true) {
      const size = this.getMultipleOrderQuerySize(scope.stockOutId, taskId)
      if (!scope.stockOutId) {
        return warehouseApi.findMultipleOrder(scope.teamId, taskId, qrText, 0, size,
            scope.warehouseCode, scope.verifyMode, scope.stockOutId)
      }
      const orders = []
      const ids = new Set()
      let page = 0
      let pageCount = 1
      do {
        if (!isCurrent()) return []
        const result = await warehouseApi.findMultipleOrder(scope.teamId, taskId, qrText, page, size,
            scope.warehouseCode, scope.verifyMode, scope.stockOutId, true)
        if (!isCurrent()) return []
        if (!result || !Array.isArray(result.data)) throw new Error('加载拣货单订单失败，请刷新重试')
        result.data.forEach(order => {
          if (order.order_id == null) throw new Error('加载拣货单订单失败，请刷新重试')
          const key = String(order.order_id)
          if (!ids.has(key)) {
            ids.add(key)
            orders.push(order)
          }
        })
        // 全条码匹配接口返回完整匹配结果，不走后端分页。
        if (Array.isArray(qrText) && qrText.length > 1) return orders
        const total = Number(result.total)
        if (result.total == null || !Number.isInteger(total) || total < 0) {
          throw new Error('无法读取拣货单订单数量，请刷新重试')
        }
        const returnedSize = result.size == null ? size : Number(result.size)
        if (!Number.isInteger(returnedSize) || returnedSize <= 0) {
          throw new Error('无法读取拣货单订单数量，请刷新重试')
        }
        pageCount = Math.max(1, Math.ceil(total / returnedSize))
        page += 1
        // 后端会按播种模式过滤本页，不能用本页返回条数判断是否已经取完。
      } while (page < pageCount)
      return orders
    },

    changeMultipleRenderPage(page) {
      this.multipleRenderPage = page
    },

    changeMultipleRenderPageSize(size) {
      this.multipleRenderPageSize = size
      this.multipleRenderPage = 1
    },

    capturePickingScope() {
      return {version: this.pickingScopeVersion, teamId: this.teamId, warehouseCode: this.warehouseCode,
        stockOutId: this.pickingStockOutId, taskId: this.taskGroup.id, verifyMode: this.verifyMode}
    },

    isPickingScopeCurrent(scope) {
      return scope.version === this.pickingScopeVersion && String(scope.teamId) === String(this.teamId)
          && scope.warehouseCode === this.warehouseCode && scope.stockOutId === this.pickingStockOutId
          && scope.taskId === this.taskGroup.id && scope.verifyMode === this.verifyMode
    },

    pickingTaskLabel(task) {
      const remark = (task.remark || '').replace(/[（(]\s*请[^()（）]*[）)]/g, '').trim()
      return `${task.id} · ${remark || '拣货单'}（${task.orderCount || 0}单）`
    },

    clearPickingMatch() {
      this.pickingScopeVersion += 1
      this.multipleOrdersRequestID = null
      this.pickingTasksLoading = false
      this.pickingOrdersLoading = false
      this.multipleOrders = []
      this.multipleRenderPage = 1
      this.multipleSearchQrText = ''
      this.multiGroupQrText = ''
      this.allMatchQrText = ''
      this.taskGroup = {id: 0, title: '未分配'}
      this.clearAutoSendData()
    },

    changePickingTask(value) {
      this.pickingStockOutId = value || null
      this.clearPickingMatch()
      return this.loadMultipleOrders(this.teamId, true)
    },

    warehouseCodeChangeForMulti(val) {
      this.warehouseCode = val
      this.loadMultipleOrders(this.vipName, false)
    },

    // 自动发货相关方法
    toggleAutoSendMode() {
      this.autoSendMode = !this.autoSendMode
      if (this.autoSendMode) {
        this.$message.success('已进入自动发货模式')
        // 清空自动发货数据（不会清除最近发货记录）
        this.clearAutoSendData()
        // 聚焦到输入框
        this.$nextTick(() => {
          if (this.$refs.autoSendInput) {
            this.$refs.autoSendInput.focus()
          }
        })
      } else {
        this.$message.info('已退出自动发货模式')
        // 清空自动发货数据（不会清除最近发货记录）
        this.clearAutoSendData()
        // 重置过滤后的订单显示
        this.$forceUpdate()
      }
    },

    // 切换播种校验模式
    toggleVerifyMode() {
      this.verifyMode = !this.verifyMode

      if (this.verifyMode) {
        this.$message({
          message: '已开启播种校验模式',
          type: 'success',
          duration: 2000
        })
      } else {
        this.$message({
          message: '已关闭播种校验模式',
          type: 'info',
          duration: 2000
        })
      }

      // 重新加载订单数据，使用新的matchFlag值
      this.loadMultipleOrders(this.teamId, true)
    },

    toggleSowingInOrder() {
      if (!this.verifyMode || this.pickingOrdersLoading || this.pickingSendInProgress) return
      this.sowingInOrder = !this.sowingInOrder
      // 切换规则后丢弃尚未返回的扫码结果，并重新开始扫描。
      this.pickingScopeVersion += 1
      this.clearAutoSendData()
      this.$nextTick(() => {
        if (this.$refs.autoSendInput) this.$refs.autoSendInput.focus()
      })
    },

    autoSendQrTextInput(value) {
      this.autoSendQrText = value + ''
    },

    handleAutoSendQrText() {
      if (this.pickingOrdersLoading || this.pickingSendInProgress) return
      const scopeVersion = this.pickingScopeVersion
      console.log('handleAutoSendQrText@@@', this.autoSendData)
      const qrText = this.autoSendQrText.trim()
      if (!qrText) {
        this.$message.warning('请输入条码')
        return
      }

      // 调用API获取erpSku信息
      erpProductApi.findErpSkuVoByQrText(qrText).then(erpSku => {
        if (scopeVersion !== this.pickingScopeVersion || this.pickingSendInProgress || this.pickingOrdersLoading) { return }
        const {code} = erpSku

        console.log('扫描到商品:', code, '原始二维码:', qrText)
        console.log("code value:", code)
        // if (!this.autoSendData.codeCounts) {
        //   this.$set(this.autoSendData, 'codeCounts', {});
        // }

        this.autoSendData.codeCounts = {
          ...this.autoSendData.codeCounts,
          [code]: this.autoSendData.codeCounts[code] ? this.autoSendData.codeCounts[code] + 1 : 1
        }
        //更新条码计数 - 使用$set确保响应性
        // if (!this.autoSendData.codeCounts[code]) {
        //   this.autoSendData.codeCounts[code]=0
        //   //this.$set(this.autoSendData.codeCounts, code, 0)
        //   console.log("111cs",this.autoSendData.codeCounts)
        // }
        // this.autoSendData.codeCounts[code]=this.autoSendData.codeCounts[code] + 1
        // //this.$set(this.autoSendData.codeCounts, code, this.autoSendData.codeCounts[code] + 1)

        console.log('更新后的codeCounts:', this.autoSendData.codeCounts)

        // 添加到已扫描列表
        const scannedItem = {
          code,
          count: this.autoSendData.codeCounts[code],
          qrText,  // 保存原始qrText
          timestamp: new Date().toLocaleTimeString(),
          matched: false,
          partialMatched: false
        }

        this.autoSendData.scannedCodes.push(scannedItem)

        console.log('已扫描列表:', this.autoSendData.scannedCodes)

        // 检查匹配情况
        this.checkAutoSendMatch()

        // 清空输入框并聚焦
        this.autoSendQrText = ''
        this.$nextTick(() => {
          this.$refs.autoSendInput.focus()
        })

      }).catch(err => {
        if (scopeVersion !== this.pickingScopeVersion) return
        this.$message.error('条码识别失败: ' + err.message)
        this.autoSendQrText = ''
      })
    },

    checkAutoSendMatch() {
      const {multipleOrders} = this
      const {codeCounts} = this.autoSendData

      if (!multipleOrders || multipleOrders.length === 0) {

        this.updateScannedCodesStatus()
        this.removeLastScannedCode()
        return
      }

      // 获取已扫描的商品编码列表
      const scannedCodes = Object.keys(codeCounts).filter(code => codeCounts[code] > 0)

      let hasFullMatch = false
      let hasPartialMatch = false
      let matchedOrder = null
      let anyOrderHasScannedItem = false // 新增变量，标记是否有任何订单包含已扫描的商品

      // 遍历所有可能的订单
      // 我们需要确保订单中的每个商品都能在扫描到的商品中找到对应的数量，且扫描数量不多不少
      for (let i = 0; i < multipleOrders.length; i++) {
        const order = multipleOrders[i]
        if (!order.children || order.children.length === 0) continue

        // 复制一份扫描到的商品计数，用于当前订单的匹配校验
        const scannedCountsCopy = {...codeCounts}
        let currentOrderFullyMatched = true
        let currentOrderPartiallyMatchedForThisOrder = false // 针对当前订单的部分匹配

        // 检查订单的每个子项
        for (let j = 0; j < order.children.length; j++) {
          const child = order.children[j]
          const {code, combo_num} = child
          const scannedAvailable = scannedCountsCopy[code] || 0


          if (scannedCodes.some(item => item === code)) { // 只要订单包含当前扫描的商品，就认为是相关的
            anyOrderHasScannedItem = true;
          }

          if (scannedAvailable >= combo_num) {
            // 扫描到的数量足够满足当前商品需求
            scannedCountsCopy[code] -= combo_num
            currentOrderPartiallyMatchedForThisOrder = true // 至少有一个商品匹配
          } else {
            // 扫描到的数量不足
            currentOrderFullyMatched = false
            // 不再直接break，而是继续检查，确保所有已扫描商品都被考虑
          }
        }

        // 检查是否所有扫描的商品都被当前订单消耗（没有多余）
        const allScannedConsumedByThisOrder = Object.keys(scannedCountsCopy).every(code => scannedCountsCopy[code] === 0)

        // 如果当前订单完全匹配了所有商品的需求，并且没有多余的扫描商品
        if (currentOrderFullyMatched && allScannedConsumedByThisOrder) {
          hasFullMatch = true
          matchedOrder = order
          break // 找到一个完全匹配的订单，可以停止检查其他订单
        }

        // 如果当前订单是部分匹配（扫描了部分商品，且这些商品都在订单内，但未完全满足所有需求，或有少量多余）
        // 并且至少有一个扫描的商品在当前订单中被找到
        if (currentOrderPartiallyMatchedForThisOrder) {
          hasPartialMatch = true; // 存在至少一个订单是部分匹配
        }
      }

      // 如果没有完全匹配的订单，并且有扫描商品，同时至少有一个订单是部分匹配的
      // 或者没有任何订单被部分匹配，但有扫描商品（这种情况通常意味着扫到了一个不属于任何订单的商
      if (!hasFullMatch && this.autoSendData.scannedCodes.length > 0 && (!anyOrderHasScannedItem)) {


        // 没有任何订单包含已扫描的商品或扫描数量超过订单需求，删除最后一个扫描的条码
        this.removeLastScannedCode()
        return
      }

      // 更新扫描状态
      this.updateScannedCodesStatus(hasFullMatch, hasPartialMatch)

      // 如果找到完全匹配的订单，自动发货
      if (hasFullMatch && matchedOrder) {
        // 按顺序开启时，额外检查播种格号顺序。
        if (this.verifyMode && this.sowingInOrder) {

          const currentSowingCellCode = matchedOrder.sowingCellCode
          const sowingOrders = [...multipleOrders]

          // 按全部播种订单检查前格，使用副本避免影响无序匹配。
          sowingOrders.sort((a, b) => {
            const codeA = a.sowingCellCode ? parseInt(a.sowingCellCode.split('-')[1]) : Infinity
            const codeB = b.sowingCellCode ? parseInt(b.sowingCellCode.split('-')[1]) : Infinity
            return codeA - codeB
          })

          const firstMatchedOrder = sowingOrders[0]

          if (firstMatchedOrder && firstMatchedOrder.order_id !== matchedOrder.order_id) {
            // 存在更靠前的匹配订单，提示用户
            const scope = this.capturePickingScope()
            this.$confirm(`当前匹配订单【${matchedOrder.order_id}】的播种格号为【${currentSowingCellCode}】，但存在更靠前的匹配订单【${firstMatchedOrder.order_id}】播种格号为【${firstMatchedOrder.sowingCellCode}】，是否继续发货当前订单？`, '提示', {
              confirmButtonText: '继续发货',
              cancelButtonText: '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true
            }).then(() => {
              if (!this.isPickingScopeCurrent(scope) || !this.sowingInOrder) return
              this.autoSendOrder(matchedOrder)
            }).catch(() => {
              this.$message.info('已取消发货')
            })
          } else {
            // 当前匹配订单就是最靠前的，直接发货
            this.autoSendOrder(matchedOrder)
          }
        } else {
          // 未开启按顺序时，按普通自动发货逻辑直接发货
          this.autoSendOrder(matchedOrder)
        }
      } else if (!hasFullMatch && !anyOrderHasScannedItem && this.autoSendData.scannedCodes.length > 0) {



        // 如果没有部分匹配，删除最后一个扫描的条码
        this.removeLastScannedCode()
      }
    },

    updateScannedCodesStatus(hasFullMatch = false, hasPartialMatch = false) {
      this.autoSendData.scannedCodes.forEach(item => {
        item.matched = hasFullMatch
        item.partialMatched = hasPartialMatch && !hasFullMatch
      })
    },

    removeLastScannedCode() {
      if (this.autoSendData.scannedCodes.length > 0) {
        const lastItem = this.autoSendData.scannedCodes[this.autoSendData.scannedCodes.length - 1]
        const {code} = lastItem

        console.log('删除最后一个扫描的条码:', code)

        // 减少计数
        if (this.autoSendData.codeCounts[code] > 0) {
          const newCount = this.autoSendData.codeCounts[code] - 1
          if (newCount === 0) {
            //this.autoSendData.codeCounts[code]=0
            this.$delete(this.autoSendData.codeCounts, code)
          } else {
            //this.autoSendData.codeCounts[code]=newCount
            this.$set(this.autoSendData.codeCounts, code, newCount)
          }
        }

        // 移除最后一个扫描项
        this.autoSendData.scannedCodes.pop()

        // 设置最近删除的条码
        this.lastDeletedCode = code

        console.log('删除后的codeCounts:', this.autoSendData.codeCounts)

        // 通知用户 - 使用更强烈的提示
        this.$message({
          message: `🚨 <strong>自动删除不匹配条码: ${code}</strong>\n\n⚠️ 当前商品组合无法匹配任何订单\n📋 系统已自动删除最后扫描的条码\n💡 请重新扫描正确的商品组合`,
          type: 'error',
          duration: 6000,
          showClose: true,
          customClass: 'auto-delete-message',
          dangerouslyUseHTMLString: true
        })

        // 播放提示音（如果浏览器支持）
        this.playDeleteSound()

        // 3秒后清除删除提示
        setTimeout(() => {
          this.lastDeletedCode = null
        }, 3000)

        // 重新检查匹配，如果还是没有匹配，继续删除
        this.$nextTick(() => {
          this.checkAutoSendMatch()
        })
      }
    },

    removeScannedCode(index) {
      const item = this.autoSendData.scannedCodes[index]
      const {code} = item

      // 减少计数
      if (this.autoSendData.codeCounts[code] > 0) {
        const newCount = this.autoSendData.codeCounts[code] - 1
        if (newCount === 0) {
          //this.autoSendData.codeCounts[code]=0
          this.$delete(this.autoSendData.codeCounts, code)
        } else {
          //this.autoSendData.codeCounts[code]=newCount
          this.$set(this.autoSendData.codeCounts, code, newCount)
        }
      }

      // 移除指定项
      this.autoSendData.scannedCodes.splice(index, 1)

      // 重新检查匹配
      this.checkAutoSendMatch()
    },

    clearAutoSendData() {
      this.autoSendData.scannedCodes = []
      this.autoSendData.codeCounts = {}
      this.autoSendQrText = ''
      this.lastDeletedCode = null
      console.log('清空后的autoSendData:', this.autoSendData)
      // 注意：不清除最近发货记录(recentShipments)
    },

    // 添加发货记录到最近发货记录栈
    addShipmentRecord(orderId, waybillId, status, message) {
      // 创建新的发货记录
      const newRecord = {
        orderId: orderId || '',
        waybillId: waybillId || '',
        status: status,
        message: message || '',
        time: new Date().toLocaleString(),
        loading: false
      };

      // 将新记录添加到栈顶
      this.recentShipments.unshift(newRecord);

      // 保持最多10条记录
      if (this.recentShipments.length > 10) {
        this.recentShipments.pop();
      }
    },

    // 重新发送订单
    resendOrder(record) {
      if (record.loading) return;

      // 设置加载状态
      this.$set(record, 'loading', true);

      const warehouseCode = this.warehouseCode;
      if (!warehouseCode) {
        this.$message.warning('请选择仓库');
        this.$set(record, 'loading', false);
        return;
      }

      let printerName = this.printerName;
      let logisticsId = this.logisticsId;
      let userId = this.userInfo.userId;
      if (!userId) {
        this.$message.error("请先登录");
        this.$set(record, 'loading', false);
        return;
      }

      warehouseApi.reprintOrder(record.waybillId).then((printData) => {
        if (printData.status === 0) {
          const {waybillId} = printData
          this.$emit('waybillPopoverQueueUpdate', waybillId)
          this.$emit('showWaybillPopover')

          cloudprint
              .doPrint(printData, printerName)
              .then(() => {
                this.$message.success(`订单 ${record.orderId} 重新打印成功！`);

                // 更新当前记录
                this.$set(record, 'waybillId', waybillId);
                this.$set(record, 'status', 0);
                this.$set(record, 'message', '重新打印成功');
                this.$set(record, 'time', new Date().toLocaleString());

                // 添加一条新记录
                this.addShipmentRecord(record.orderId, waybillId, 0, '重新打印成功');
              })
              .catch((err) => {
                this.$message.error(`打印错误: ${err.message}`);
                this.$set(record, 'message', `打印错误: ${err.message}`);
                this.$set(record, 'status', -1);
              });
          this.$emit('showWaybillPopover');
        } else {
          this.$message.error(`重新打印失败: ${printData.errorMsg}`);
          this.$set(record, 'message', `重新打印失败: ${printData.errorMsg}`);
          this.$set(record, 'status', 1);
        }
      })
          .catch((err) => {
            this.$message.error(`重新打印错误: ${err.message}`);
            this.$set(record, 'message', `重新打印错误: ${err.message}`);
            this.$set(record, 'status', 1);
          })
          .finally(() => {
            this.$set(record, 'loading', false);
          });
    },

    // 播放删除提示音
    playDeleteSound() {
      try {
        // 创建音频上下文
        const audioContext = new (window.AudioContext || window.webkitAudioContext)()
        const oscillator = audioContext.createOscillator()
        const gainNode = audioContext.createGain()

        oscillator.connect(gainNode)
        gainNode.connect(audioContext.destination)

        // 设置音频参数
        oscillator.frequency.setValueAtTime(800, audioContext.currentTime)
        oscillator.frequency.setValueAtTime(600, audioContext.currentTime + 0.1)
        oscillator.frequency.setValueAtTime(400, audioContext.currentTime + 0.2)

        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3)

        oscillator.start(audioContext.currentTime)
        oscillator.stop(audioContext.currentTime + 0.3)
      } catch (error) {
        console.log('音频播放失败:', error)
      }
    },

    getOrderRequirement(code) {
      // 从过滤后的订单中获取该商品的需求数量
      if (this.filteredMultipleOrders.length > 0) {
        const order = this.filteredMultipleOrders[0] // 取第一个订单作为参考
        const child = order.children.find(child => child.code === code)
        return child ? child.combo_num : 0
      }
      return 0
    },

    // 仅用于UI展示：标记已扫描且在当前订单商品中的条目
    isAutoSendMatchedItem(child) {
      if (!this.autoSendMode || !child || !child.code) {
        return false
      }
      const scannedCount = this.autoSendData.codeCounts[child.code] || 0
      return scannedCount > 0
    },

    async autoSendOrder(order) {
      if (this.pickingOrdersLoading || this.pickingSendInProgress) return
      const scope = this.capturePickingScope()
      if (!scope.warehouseCode) {
        this.$message.warning('请选择仓库')
        return
      }
      if (!this.multipleOrders.some(item => String(item.order_id) === String(order.order_id))) {
        this.$message.warning('发货任务已更新，请重新扫码')
        return
      }
      const userId = this.userInfo.userId
      if (!userId) {
        this.$message.error('请先登录')
        return
      }
      const codeQrMap = {}
      this.autoSendData.scannedCodes.forEach(item => {
        if (!codeQrMap[item.code]) codeQrMap[item.code] = []
        if (item.qrText) codeQrMap[item.code].push(item.qrText)
      })
      const codeQrTextList = Object.keys(codeQrMap).map(code => ({code, qrTextList: codeQrMap[code]}))
      this.pickingSendInProgress = true
      try {
        const printData = await warehouseApi.multipleOrderSendV2(order.order_id, this.logisticsId, userId,
            scope.warehouseCode, codeQrTextList, this.verifyMode, scope.stockOutId)
        if (printData.status !== 0) {
          this.addShipmentRecord(order.order_id, '', 1, `发货失败: ${printData.errorMsg}`)
          this.$message.error(`自动发货失败: ${printData.errorMsg}`)
          return
        }
        this.$emit('waybillPopoverQueueUpdate', printData.waybillId)
        this.addShipmentRecord(order.order_id, printData.waybillId, 0, '发货成功')
        this.$emit('showWaybillPopover')
        try {
          await cloudprint.doPrint(printData, this.printerName)
          this.$message.success(`订单 ${order.order_id} 自动发货成功！`)
        } catch (err) {
          this.$message.error(`打印错误: ${err.message}`)
          const record = this.recentShipments.find(item => item.orderId === order.order_id)
          if (record) {
            this.$set(record, 'message', `打印错误: ${err.message}`)
            this.$set(record, 'status', -1)
          }
        }
      } catch (err) {
        this.addShipmentRecord(order.order_id, '', 1, `发货错误: ${err.message}`)
        this.$message.error(`自动发货错误: ${err.message}`)
      } finally {
        if (this.isPickingScopeCurrent(scope)) {
          await this.loadMultipleOrders(scope.teamId, true)
        }
        this.pickingSendInProgress = false
      }
    },

    changeVipForMulti(val) {
      this.clearPickingMatch()
      this.pickingStockOutId = null
      this.pickingTasks = []
      this.teamId = val || null
      const scopeVersion = this.pickingScopeVersion
      this.vipName = val ? val : null
      if (this.vipName) {
        const vips = this.vips
        const index = vips.findIndex(v => v.teamId === this.vipName)
        if (index > -1) {
          const team = vips[index]
          console.log('team', team)
          if (!team.version) {
            // 整理一个dto返回去
            // 目前只有 多件发货 和 售后管理需要选择客户
            // 1、记住当前的 view
            // 2、记住当前选择的客户

            // 3、记住当前的标签机
            // 4、记住是本地打印还是云打印
            // 5、记住拆包当前的处理内容
            const memo = {
              view: this.view,
              teamId: this.vipName,
              afterView: {
                printerCode: this.printerCode,
                labelPrinter: this.labelPrinter,
                workMode: this.workMode
              }
            }
            this.$emit('switchToOldSysFromTeamChange', memo)
            return
          }
        }
      }
      this.loadErpWarehouses(this.vipName, () => {
        if (scopeVersion === this.pickingScopeVersion) this.loadMultipleOrders(val, false)
      })
    },

    getVipByTeamId(teamId) {
      return this.vips.find(v => v.teamId === teamId * 1)
    },

    // 售后/拦截件签收弹窗「打印合格证」的默认勾选状态，由管理员在后台按客户配置，未配置则不勾选
    getDefaultPrintQualifiedCert(teamId) {
      if (!teamId) {
        return false
      }
      const vip = this.getVipByTeamId(teamId)
      return !!(vip && vip.defaultPrintQualifiedCert)
    },

    loadTaskGroupByQrText() {
      const warehouseCode = this.warehouseCode
      if (!warehouseCode) {
        this.$message.warning('请选择仓库')
        return
      }
      let qrText = (this.multiGroupQrText || '').trim()
      if (qrText) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        warehouseApi.findAllRemnantReadyOrderGroup(this.teamId, 1, qrText, warehouseCode).then((data) => {
          loading.close()
          this.multiGroupQrText = ''
          if (data && data.length) {
            this.taskGroups = data
            // 默认选中第一个批次
            this.taskGroup = data[0]
            this.changeTaskGroup()
          } else {
            // 保留原来的批次列表
            this.$message.warning('找不到符合条件的批次！')
          }
        }).catch(err => {
          loading.close()
          console.log('findAllRemnantReadyOrderGroup err', err)
          this.$message.error('错误提示: ' + err.message)
        })
      }
    },

    multiGroupQrTextInput(value) {
      this.multiGroupQrText = value + ''
    },

    changeTaskGroup(e, clearText) {
      if (this.pickingSendInProgress) return
      this.pickingScopeVersion += 1
      this.clearAutoSendData()
      this.multipleOrders = []
      const scope = this.capturePickingScope()
      const warehouseCode = this.warehouseCode
      if (!warehouseCode) {
        this.$message.warning('请选择仓库')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      let taskGroup = this.taskGroup
      let multipleSearchQrText = this.multipleSearchQrText || null
      if (this.allMatchQrText) {
        multipleSearchQrText = utils.computedIdList(this.allMatchQrText)
      }
      const requestID = uuid.getUUID(8, 16)
      this.multipleOrdersRequestID = requestID
      const matchFlag = this.verifyMode // 使用verifyMode作为matchFlag参数
      console.log('加载订单数据, 校验模式:', matchFlag ? '开启' : '关闭')
      const stockOutId = this.pickingStockOutId
      this.pickingOrdersLoading = true
      const isCurrent = () => requestID === this.multipleOrdersRequestID && this.isPickingScopeCurrent(scope)
      return this.findMultipleOrdersForScope(scope, taskGroup.id || null, multipleSearchQrText, isCurrent).then((data) => {
        loading.close()
        if (requestID !== this.multipleOrdersRequestID || !this.isPickingScopeCurrent(scope)) { return }
        this.pickingOrdersLoading = false
        this.multipleOrders = data
        if (clearText) {
          this.multipleSearchQrText = ''
        }
        if (multipleSearchQrText instanceof Array && multipleSearchQrText.length > 1 && data.length) {
          this.allMatchQrText = ''
          // 自动聚焦输入框
          this.$refs.allMatchInput.focus()

          // 只要第一条数据, 避免误操作
          const order = data[0]
          this.multipleOrders = [order]
          if (order && order.order_id) {
            //自动发货（一单）
            const id = order.order_id
            let userId = this.userInfo.userId
            this.pickingSendInProgress = true
            const autoPrintTask = this.buildMultiOrderSendPromise([id], this.logisticsId, userId, warehouseCode, stockOutId)
            const loading2 = this.$loading({
              lock: true,
              text: "发货中...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            })
            return autoPrintTask.then(result => {
              loading2.close()
              if (result.success) {
                const waybillId = (result.data[0] || {}).waybillId
                // 发货成功，已发货
                this.$set(order, 'markDelivered', waybillId)
              } else {
                let errMsg = result.errMsg || (result.data[0] || {}).errorMsg
                this.$alert('发货失败:' + errMsg, '提示')
              }
            }).finally(() => {
              this.pickingSendInProgress = false
              loading2.close()
            })
          }
        }
      }).catch(err => {
        if (requestID === this.multipleOrdersRequestID) { this.pickingOrdersLoading = false; this.multipleOrders = [] }
        this.$message(err.message)
        loading.close()
      })
    },

    buildMultiOrderSendPromise(ids, logisticsId, userId, warehouseCode, stockOutId = this.pickingStockOutId) {
      console.log("buid")
      return new Promise(resolve => {
        warehouseApi.multipleOrderSend(ids, logisticsId, userId, warehouseCode, stockOutId).then(result => {
          // 这里就可以先分别打印了
          let printData = result.data.filter(item => item.status === 0)
          if (printData && printData.length) {
            printData.forEach(item => {
              this.$emit('waybillPopoverQueueUpdate', item.waybillId)
            })
            cloudprint.doPrintBath(printData, this.printerName)
                .then(() => {
                })
                .catch((error) => {
                  console.log('doPrintBath error', error)
                  this.$message.error(error.message)
                })
            this.$emit('showWaybillPopover')
          }
          resolve(result)
        }).catch(err => {
          this.$message.error(err.message)
          resolve({
            errMsg: err.message,
            errNum: ids.length
          })
        })
      })
    },

    taskGroupDetail() {
      if (this.pickingOrdersLoading || this.pickingSendInProgress) return false
      const scope = this.capturePickingScope()
      const renderPage = this.multipleRenderPage
      const stockOutId = scope.stockOutId
      const warehouseCode = this.warehouseCode
      if (!warehouseCode) {
        this.$message.warning('请选择仓库')
        return false
      }
      const selected = this.pickingTasks.find(task => String(task.id) === String(stockOutId))
      let taskGroup = stockOutId
          ? {id: `picking-${stockOutId}`, title: this.pickingTaskLabel(selected || {id: stockOutId})}
          : this.taskGroup
      if (!taskGroup.id) {
        this.$message("仅批次可批量打单")
        return false
      }
      let multipleOrders = stockOutId ? this.renderedMultipleOrders : this.multipleOrders
      if (multipleOrders.length <= 0) {
        this.$message("无批量打单需求")
        return false
      }

      const misMatchGroup = []
      let ids = multipleOrders.filter(it => {
        if (stockOutId) return true
        const {multipleTaskId} = it
        if (multipleTaskId && multipleTaskId * 1 !== taskGroup.id * 1) {
          // 批次不对应
          misMatchGroup.push(it.order_id)
        }
        return !!multipleTaskId
      }).map((it) => {
        return it.order_id
      })

      if (ids.length <= 0) {
        this.$message("批次订单加载异常，请刷新")
        return false
      }
      if (misMatchGroup && misMatchGroup.length) {
        // 如果出现这种异常，上报一下错误
        errorUtils.uploadError('multipleOrderSendEx', `批次【${taskGroup.id}】与批次发货查询批次不匹配: 【${misMatchGroup}】`)
      }

      let groupSize = 3
      let groups = []
      // 将ids进行分组，暂时是三个一组, 更改groupSize即可
      for (let i = 0; i * groupSize < ids.length; i++) {
        let start = i * groupSize
        let end = Math.min(i * groupSize + groupSize, ids.length)
        let group = ids.slice(start, end)
        groups.push(group)
      }

      return this.$confirm((stockOutId ? `拣货单 ${stockOutId} 本页 ${ids.length} 单确认配齐？` : taskGroup.title + "确认配齐?"), "批量打单提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (!this.isPickingScopeCurrent(scope) || this.pickingOrdersLoading || this.pickingSendInProgress
            || (stockOutId && renderPage !== this.multipleRenderPage)) {
          this.$message.warning('发货任务已更新，请重新选择')
          return false
        }
        let userId = this.userInfo.userId
        if (!userId) {
          this.$message.error("请先登录")
          return false;
        }
        let logisticsId = this.logisticsId

        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        this.pickingSendInProgress = true
        // 同一拣货单共用后端单据锁，分组请求顺序执行。
        const sendAll = stockOutId
            ? groups.reduce((chain, group) => chain.then(async results => {
              results.push(await this.buildMultiOrderSendPromise(group, logisticsId, userId, warehouseCode, stockOutId))
              return results
            }), Promise.resolve([]))
            : Promise.all(groups.map(group => this.buildMultiOrderSendPromise(group, logisticsId, userId, warehouseCode, stockOutId)))
        let errorList = []
        return sendAll.then(resultList => {
          // 多件打印之后，自动消除扫码输入的二维码条码
          this.multipleSearchQrText = ''
          // 重新加载多件任务列表
          // this.changeVip(this.teamId, true)
          this.loadMultipleOrders(this.teamId, true)
          // 收集打印结果
          // 成功的单数
          let success = 0
          let fail = 0
          let stAdvised = 0, ytAdvised = 0, ztAdvised = 0, sfAdvised = 0, jdAdvised = 0
          resultList.forEach(result => {
            if (result.status === 0) {
              success += result.success
            } else {
              if (result.data) {
                success += result.success
                fail += result.fail
                const {data} = result
                if (data && data.length) {
                  data.forEach(printData => {
                    if (printData.status === 12) {
                      const {errorMsg} = printData
                      if (errorMsg.indexOf('请用申通') > -1) {
                        stAdvised++
                      } else if (errorMsg.indexOf('请用圆通') > -1) {
                        ytAdvised++
                      } else if (errorMsg.indexOf('请用中通') > -1) {
                        ztAdvised++
                      } else if (errorMsg.indexOf('请用顺丰') > -1) {
                        sfAdvised++
                      } else if (errorMsg.indexOf('请用京东') > -1) {
                        jdAdvised++
                      }
                    }
                  })
                }
              } else {
                fail += result.errNum
                errorList.push(`获取【${result.errNum}】个面单失败，原因：` + result.errMsg)
              }
            }
          })

          const multiSendResultMap = this.multiSendResult
          if (multiSendResultMap.has(taskGroup.id)) {
            const result = multiSendResultMap.get(taskGroup.id)
            const {totalStAdvised, totalYtAdvised, totalZtAdvised, totalSfAdvised, totalJdAdvised} = result
            const multiSendResult = {
              stAdvised,
              ytAdvised,
              ztAdvised,
              sfAdvised,
              jdAdvised,
              totalStAdvised: totalStAdvised + stAdvised,
              totalYtAdvised: totalYtAdvised + ytAdvised,
              totalZtAdvised: totalZtAdvised + ztAdvised,
              totalSfAdvised: totalSfAdvised + sfAdvised,
              totalJdAdvised: totalJdAdvised + jdAdvised
            }
            multiSendResultMap.set(taskGroup.id, multiSendResult)
          } else {
            const multiSendResult = {
              stAdvised,
              ytAdvised,
              ztAdvised,
              sfAdvised,
              jdAdvised,
              totalStAdvised: stAdvised,
              totalYtAdvised: ytAdvised,
              totalZtAdvised: ztAdvised,
              totalSfAdvised: sfAdvised,
              totalJdAdvised: jdAdvised
            }
            multiSendResultMap.set(taskGroup.id, multiSendResult)
          }
          let tips = `成功打印${success}单,失败${fail}单<br/>`
          if (stAdvised) {
            tips += `请用【申通】：【${stAdvised}】单<br/>`
          }
          if (ytAdvised) {
            tips += `请用【圆通】：【${ytAdvised}】单<br/>`
          }
          if (ztAdvised) {
            tips += `请用【中通】：【${ztAdvised}】单<br/>`
          }
          if (sfAdvised) {
            tips += `请用【顺丰】：【${sfAdvised}】单<br/>`
          }
          if (jdAdvised) {
            tips += `请用【京东】：【${jdAdvised}】单<br/>`
          }

          if (errorList && errorList.length) {
            errorList.forEach(errMsg => {
              tips += `${errMsg}<br/>`
            })
          }

          if (fail > 0) {
            this.$alert(
                tips,
                "有订单异常",
                {
                  confirmButtonText: "错误详情",
                  dangerouslyUseHTMLString: true
                }
            )
          } else {
            this.$alert(`成功打印${success}单`, "获取成功", {
              confirmButtonText: "确认",
            })
          }
        }).catch(err => {
          this.$message.error(err.message || '批量发货失败')
        }).finally(() => {
          this.pickingSendInProgress = false
          loading.close()
        })

      }).catch(err => {
        if (err !== 'cancel' && err !== 'close') this.$message.error(err.message || '批量发货失败')
      })
    },

    createTaskGroupByScan() {
      // 清除旧数据
      this.qrTextInfo = ''
      this.taskCode = []
      this.taskGroupCreateViewable = true
    },

    createTaskGroup() {
      let taskGroup = this.taskGroup
      if (taskGroup.id) {
        this.$message("请切换为未分配批次")
        return false
      }
      // 抓取款式
      let orders = this.multipleOrders
      if (orders.length === 0) {
        this.$message("没有可创建内容")
        return false
      }

      const codeList = []
      const codeSet = new Set()
      for (let i = 0; i < orders.length; i++) {
        for (let j = 0; j < orders[i].children.length; j++) {
          let item = orders[i].children[j]
          let code = item.code
          if (codeSet.has(code)) {
            continue
          }

          // 暂不处理 件数大于1件的组合
          if (item.combo_num > 1) {
            continue
          }
          codeSet.add(code);
          codeList.push(orders[i].children[j])
        }
      }

      if (codeList.length === 0) {
        this.$message("无可创建批次的款式")
        return false
      }
      this.codeList = codeList
      this.qrTextInfo = ''
      this.taskGroupCreateViewable = true
    },

    createMultipleTaskGroupByOrderNum() {
      const warehouseCode = this.warehouseCode
      if (!warehouseCode) {
        this.$message.warning('请选择仓库')
        return
      }
      let taskGroup = this.taskGroup
      if (taskGroup.id) {
        this.$message("请切换为未分配批次")
        return false
      }
      let orders = this.multipleOrders
      if (orders.length === 0) {
        this.$message("没有可以创建的内容，刷新重试")
        return false
      }
      this.$confirm('是否创建').then(res => {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        if (res === 'confirm') {
          warehouseApi
              .createMultipleTaskGroupByOrderNum(this.teamId, warehouseCode)
              .then((data) => {
                let taskGroups = this.taskGroups
                let group = data[0]
                taskGroups.push(...data)
                this.taskGroup = group
                this.taskGroups = taskGroups
                // this.changeVip(this.teamId, true)
                this.loadMultipleOrders(this.teamId, true)
                loading.close()
              })
              .catch((err) => {
                this.$alert(err.message)
                loading.close()
              })
        }
      })
    },

    showMultiSendResult() {
      const map = this.multiSendResult
      const taskGroup = this.taskGroup
      const key = taskGroup.id
      if (map.has(key)) {
        const result = map.get(key)
        const {
          stAdvised,
          ytAdvised,
          ztAdvised,
          sfAdvised,
          jdAdvised,
          totalStAdvised,
          totalYtAdvised,
          totalZtAdvised,
          totalSfAdvised,
          totalJdAdvised
        } = result
        const row1 = {
          title: '上次结果',
          stAdvised,
          ytAdvised,
          ztAdvised,
          sfAdvised,
          jdAdvised
        }
        const row2 = {
          title: '合计',
          stAdvised: totalStAdvised,
          ytAdvised: totalYtAdvised,
          ztAdvised: totalZtAdvised,
          sfAdvised: totalSfAdvised,
          jdAdvised: totalJdAdvised
        }
        this.multiChangeableList = [row1, row2]
        this.multiChangeableDialog = true
      } else {
        this.$message.info('无可换快递信息!')
      }
    },

    isDefectiveOrder(entryOrder) {
      const {orderType} = entryOrder
      return orderType === EntryOrderType.CPRK
    },

    isUnusualOrder(entryOrder) {
      const {orderType} = entryOrder
      return orderType === EntryOrderType.YCRK
    },

    getPrinters() {
      if (!printer.getConnect()) {
        printer.doConnect()
      }

      if (!davinci_printer.getConnect()) {
        davinci_printer.doConnect()
      }

      if (!ks_printer.getConnect()) {
        ks_printer.doConnect()
      }

      if (!pddPrinter.getConnect()) {
        pddPrinter.doConnect()
      }

      let printers1 = []
      let printers2 = []
      let printers3 = []
      let printers4 = []
      let promises = []
      let printers = []

      this.printers = []

      let p1 = printer
          .getPrinters()
          .then((res) => {
            printers1 = res.printers
            this.DEFAULT_PRINTER = res.defaultPrinter
            return new Promise((resolve) => {
              resolve(printers1)
            })
          })
          .catch((err) => {
            return Promise.resolve([])
          })

      let p2 = davinci_printer
          .getPrinters()
          .then((res) => {
            printers2 = res.printers
            this.DEFAULT_PRINTER = res.defaultPrinter
            return new Promise((resolve) => {
              resolve(printers2)
            })
          })
          .catch((err) => {
            return Promise.resolve([])
          })

      let p3 = ks_printer.getPrinters().then(res => {
        printers3 = res.printers
        this.DEFAULT_PRINTER = res.defaultPrinter
        return new Promise((resolve => {
          resolve(printers3)
        }))
      }).catch((err) => {
        return Promise.resolve([])
      })
      let p4 = pddPrinter.getPrinters().then(res => {
        printers4 = res.printers
        this.DEFAULT_PRINTER = res.defaultPrinter
        return new Promise(resolve => {
          resolve(printers4)
        })
      }).catch((err) => {
        return Promise.resolve([])
      })

      promises.push(p1)
      promises.push(p2)
      promises.push(p3)
      promises.push(p4)

      Promise.all(promises).then((res) => {
        let res1 = res[0]
        let res2 = res[1]
        let res3 = res[2]
        let res4 = res[3]
        printers = res1
        let set = new Set()

        res1.forEach((item) => {
          set.add(item.name)
        })

        res2.forEach((item) => {
          if (!set.has(item.name)) {
            printers.push(item)
            set.add(item.name)
          }
        })

        res3.forEach((item) => {
          if (!set.has(item.name)) {
            printers.push(item)
            set.add(item.name)
          }
        })

        res4.forEach((item) => {
          if (!set.has(item.name)) {
            printers.push(item)
            set.add(item.name)
          }
        })

        if (!printers.length) {
          this.$message({
            message: "打印机刷新失败",
            type: "warning",
          })
        } else {
          this.printers = printers
          if (this.DEFAULT_PRINTER) {
            this.printerName = this.DEFAULT_PRINTER
          }
          this.$message({
            message: "打印机刷新成功",
            type: "success",
          })
        }
      })
    },

    loadVips() {
      const warehouseId = this.userInfo.warehouseId
      packagedApi.vipUsers(warehouseId).then((vips) => {
        this.vips = vips
      })
    },

    showCurrentLogistics() {
      const logisticsId = this.logisticsId
      const companies = this.LOGISTICS_COMPANIES
      const index = companies.findIndex(com => com.value === logisticsId)
      let msg = ''
      if (index > -1) {
        msg = `当前快递【${companies[index].label}】`
      } else {
        msg = `快递码异常，请联系技术`
      }
      this.outerPopoverMsg = msg
      this.outerPopVisible = true
      setTimeout(() => {
        this.outerPopVisible = false
      }, 3000)

    },

    qrTextInput(value) {
      // console.log("value", value)
      value += ""
      this.qrText = value
    },

    scanQrText: debounce(function (e, re) {
      let value = this.qrText
      if (value.startsWith("UID") || value.startsWith("uid")) {
        // 用户登录
        let token = value.toString()
        userApi.userIdLogin(token).then(userInfo => {
          this.userInfo = userInfo
          request.setSessionKey(userInfo.sessionKey)
          this.loadPrinters()
          this.loadVips()
          this.qrText = ''
          this.$emit('loginChange', userInfo)

          // 清空面单来源
          this.matchChannel = ''
          // 重置定时器
          this.resetLastScanTimer()
        }).catch(err => {
          console.log("userIdLogin err", err)
          this.$message.error(err.message)
        })
        return false
      }

      let userId = this.userInfo.userId
      if (!userId) {
        this.$message.error("请先登录")
        return false
      }

      if (!this.matchChannel) {
        this.$message.error('请选择配单来源')
        return false
      }

      if (!value || value.length <= 4) {
        this.$message.error("条码数据格式错误")
        return false
      }

      if (texts.indexOf(value) > -1 && !re) {
        this.$message.error("该标签被扫描过!")
        this.$confirm(
            "如果是长时间未出单请耐心等待，或找主管处理！",
            "确定重复扫码？"
        )
            .then((res) => {
              this.scanQrText(e, true)
            })
            .catch((err) => {
            })
        return false
      }
      const batchQrId = uuid.getUUID(8, 16)
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      if (value.endsWith("V3")) {
        let splits = value.split("-")
        if (splits[1] !== "1") {
          texts.push(value)
        }
      } else if (value.endsWith("V2")) {
        let splits = value.split(":")
        if (splits[1] !== "1") {
          texts.push(value)
        }
      } else if (value.endsWith("AL")) {
        let splits = value.split("-")
        if (splits[1] !== "1") {
          texts.push(value)
        }
      } else if (value.endsWith("V4")) {
        let splits = value.split("-")
        if (splits[1] !== "1") {
          texts.push(value)
        }
      }

      let amount = 1
      let strs = value.split("-")
      if (strs.length === 7) {
        try {
          amount = parseInt(strs[1])
        } catch (e) {
          this.$message.error("标签格式错误" + value)
          console.error(e)
          loading.close()
          return false
        }
      }
      let logisticsId = this.logisticsId

      // 重置定时器
      this.resetLastScanTimer()

      if (amount > 10) {
        this.getProductInfoFromQrTextPromise(value).then(sku => {
          const {image, productName, code, specs} = sku
          this.productConfirm = {
            productPic: image,
            productName: productName,
            specs: specs,
            code: code,
            info: {
              value,
              userId,
              logisticsId,
              amount,
              batchQrId
            }
          }
          loading.close()
          this.confirmDialog = true
        })
      } else {
        this.scanQrTextQueue(value, userId, logisticsId, amount, loading, batchQrId, [])
      }
    }, 150),

    resetLastScanTimer() {
      if (this.lastScanTimer != null) {
        clearTimeout(this.lastScanTimer)
      }

      this.lastScanTimer = setTimeout(() => {
        // 长时间不操作自动清空配单来源选择
        this.matchChannel = ''
      }, 60 * 60 * 1000)
    },

    getProductInfoFromQrTextPromise(qrText) {
      // 只有条码信息，不能直接知道 是新系统用户还是旧系统用户
      // 策略1：看看能不能拿到条码的团队ID, 匹配我们的vips。如果找得到，就直接确定了是否是新系统用户。无法确定则全查
      // 策略2：直接先查新接口去erpSku表找，找不到就旧接口继续找
      // 这里先使用
      return new Promise((resolve) => {
        erpProductApi.findErpSkuVoByQrText(qrText).then(erpSku => {
          resolve(erpSku)
        }).catch(() => {
          warehouseApi.getSkuInfoForScanQrText(qrText).then(matchedOrderVo => {
            const {product_pic, product_name, specs, code} = matchedOrderVo
            resolve({
              image: product_pic,
              productName: product_name,
              code,
              specs
            })
          }).catch(err => {
            resolve({
              productName: err.message,
              specs: '找不到商品信息',
            })
          })
        })
      })
    },

    // 加载售后入库单的信息
    loadInterceptEntryOrder(interceptDto, showLoading) {
      const {waybillId} = interceptDto
      const query = {
        expressCode: waybillId
      }
      let loading = null
      if (showLoading) {
        loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
      }
      this.$set(interceptDto, 'entryOrderList', [])
      entryOrderApi.findEntryOrders(query).then(data => {
        data.data.sort((a, b) => {
          if (a.goodsType === b.goodsType) {
            return a.id - b.id
          } else {
            return a.goodsType - b.goodsType
          }
        })
        this.$set(interceptDto, 'entryOrderList', data.data)
        if (showLoading) {
          loading.close()
        }
      }).catch(err => {
        if (showLoading) {
          loading.close()
        }
        this.$message.error('加载入库单信息异常：' + err.message)
        console.log('editEntryOrder err', err)
      })

    },

    receiveIntercept(printQualifiedCert = false) {
      const confirmDto = this.afterSaleConfirmDto
      console.log("confirmDto", confirmDto)
      const {items, defectiveItems = []} = confirmDto
      const printerCode = this.printerCode
      let warehouseCode = this.warehouseCode
      const {waybillId} = confirmDto
      let {isYiboSend} = confirmDto
      let originWaybillId = null
      let acceptWaybill
      let orderWaybill = waybillId
      let isCC = defectiveItems.length > 0
      let finalItems = isCC ? defectiveItems : items;
      if (isCC) {
        warehouseCode = confirmDto.defectiveWarehouseCode
      }
      if (this.changeWaybillId) {
        //存在换单
        acceptWaybill = this.changeWaybillId
        originWaybillId = orderWaybill
      } else {
        //没有换单，那么毅播发货的单号就是签收的单号
        acceptWaybill = orderWaybill
      }
      const entryOrderItems = finalItems.map(item => {
        const {orderVo, num, giveaway, pid, order_id, platform, actualQty} = item
        const {code} = orderVo
        let type = giveaway ? 'LP' : 'ZP'
        if (isCC) {
          type = 'CC'
        }
        return {
          itemCode: code,
          planQty: num,
          actualQty,
          inventoryType: type,
          platform,
          orderId: order_id,
          parentOrderId: pid
        }
      })
      isYiboSend = isYiboSend ? 'true' : 'false'
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      erpAfterSaleApi.receiveIntercept(acceptWaybill, originWaybillId, printerCode, warehouseCode, isYiboSend, entryOrderItems, printQualifiedCert).then(() => {
        this.$message.success('签收成功~')
        this.$set(this.afterSaleConfirmDto, 'interceptDialogVisible', false)
        this.loadInterceptEntryOrder(this.waybillInterceptDto)
        loading.close()
      }).catch(err => {
        loading.close()
        console.log('receiveIntercept err', err)
        this.$message.error('发生错误：' + err.message)
      })

    },

    firmRecWaybillIntercept(waybillInterceptDto) {
      this.checkParam(this.printerCode, "请选择打印机！")
      this.checkParam(this.warehouseCode, "请选择仓库！")
      // 把拦截件的数据结构构造成afterSaleInfo，同用相同的组件和方法
      const items = waybillInterceptDto.afterList.map(item => {
        const {product_name, product_pic, code, specs} = item
        item.orderVo = {
          product_pic,
          product_name,
          code,
          specs
        }
        item.num = item.combo_num
        item.actualQty = item.combo_num
        item.giveaway = item.orderType === 4
        return item
      })
      const {waybillId, isYiboSend} = waybillInterceptDto
      const loading = utils.getGlobalLoading()
      const checkCombinationPromise = new Promise(resolve => {
        const promises = []
        const allItems = []
        items.forEach(it => {
          const {code, num} = it
          const p = new Promise(innerResolve => {
            const finalCode = encodeURIComponent(code)
            erpProductApi.findErpSkuVoByTeamIdAndCode(this.vipName, finalCode).then(erpSkuVo => {
              const {skuType, combinationSkuDto, intercept} = erpSkuVo
              if (skuType === 1 && combinationSkuDto && combinationSkuDto.splitSkuDtoList && combinationSkuDto.splitSkuDtoList.length) {
                const splitItems = combinationSkuDto.splitSkuDtoList
                const finalItems = []
                splitItems.forEach(split => {
                  const itemCpy = JSON.parse(JSON.stringify(it))
                  const {orderVo} = itemCpy
                  orderVo.product_name = split.productName
                  orderVo.code = split.skuCode
                  orderVo.specs = split.specs

                  itemCpy.num = split.num * num
                  itemCpy.actualQty = split.num * num
                  // 保存 intercept 字段到 item 中
                  itemCpy.intercept = intercept
                  finalItems.push(itemCpy)
                })
                innerResolve(finalItems)
              } else {
                it.actualQty = it.num
                // 保存 intercept 字段到 item 中
                it.intercept = intercept
                innerResolve([it])
              }
            }).catch(ignore => {
              innerResolve([it])
            })
          })
          promises.push(p)
        })

        Promise.all(promises).then(resultList => {
          resultList.forEach(its => {
            allItems.push(...its)
          })
          resolve(allItems)
        })
      })

      checkCombinationPromise.then(finalItems => {
        this.afterSaleConfirmDto = {
          waybillId,
          isYiboSend,
          interceptDialogVisible: true,
          items: JSON.parse(JSON.stringify(finalItems)),
          remark: '',
          defectiveItems: [],
          unusualItems: [],
          teamId: waybillInterceptDto.teamId,
          interceptPrintQualifiedCert: this.getDefaultPrintQualifiedCert(waybillInterceptDto.teamId)
        }

        // 默认的次品仓（如需要转次品）
        const defectiveWarehouseCodes = this.erpWarehouses.filter(w => w.goodsType === 2).map(w => w.warehouseCode)
        if (defectiveWarehouseCodes && defectiveWarehouseCodes.length) {
          this.afterSaleConfirmDto.defectiveWarehouseCode = defectiveWarehouseCodes[0]
        }

        // 检查是否有拦截件，如果有则自动标记为次品
        const interceptItems = finalItems.filter(item => item.intercept === true)
        if (interceptItems.length > 0) {
          interceptItems.forEach(item => {
            this.markItem(item, 'defectiveItems')
          })
        }
      }).finally(() => {
        loading.close()
      })

    },

    editEntryOrderRemark(row, key) {
      let {id} = row
      let remark = row[key]
      remark = remark || ''
      this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: remark
      }).then(({value}) => {
        const entryOrder = {
          id
        }
        entryOrder[key] = value || ''
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        entryOrderApi.editEntryOrder(entryOrder).then(() => {
          this.$message.success('编辑备注成功！')
          this.$set(row, key, entryOrder[key])
          loading.close()
        }).catch(err => {
          this.$message.error('编辑备注失败：' + err.message)
          loading.close()
        })

      }).catch(() => {

      })
    },

    editEditingItem(row) {
      this.editingItemToUpdate = row
      this.afterSaleEntryOrderInnerDialog = true
    },

    toCreateAfterSaleEntryOrder(row, after) {
      const {image, code, productName, specs} = row
      const {entryOrderList, orderType} = after
      const orderTypeDesc = entryOrderTypeUtil.getDescribe(orderType)
      if (!entryOrderList.length) {
        this.$message.warning('数据异常：没有关联的其他入库单，请刷新重试，重试不成功则联系技术')
        return
      }
      const someOrder = entryOrderList[0]
      const {relatedOrder, expressCode, teamId} = someOrder
      const wareIndex = this.erpWarehouses.findIndex(ware => ware.goodsType === 1)
      this.createAfterSaleEntryOrderForm = {
        items: [{
          image,
          productName,
          code,
          specs,
          planQty: 1,
          actualQty: 1
        }],
        orderType,
        title: `【${orderTypeDesc}】入库单创建`,
        relatedOrder,
        expressCode,
        teamId,
        warehouseCode: wareIndex > -1 ? this.erpWarehouses[wareIndex].warehouseCode : null,
        visible: true
      }
    },

    doCreateAfterSaleEntryOrder() {
      const form = this.createAfterSaleEntryOrderForm
      const {teamId, warehouseCode, orderType, expressCode, relatedOrder, items} = form
      const {code, planQty, actualQty} = items[0]
      const order = {
        teamId,
        warehouseCode,
        status: EntryOrderStatus.ToBeReviewed,
        orderType,
        subOrderType: orderType === EntryOrderType.STRK ? EntryOrderType.JSRK : null,
        expressCode,
        relatedOrder
      }
      const item = {
        itemCode: code,
        planQty,
        actualQty
      }
      const entryOrderDto = {
        entryOrder: order,
        erpEntryOrderItems: [item]
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      erpAfterSaleApi.createAfterSaleEntryOrder(entryOrderDto).then(() => {
        this.$message.success('创建成功!')
        loading.close()
        this.createAfterSaleEntryOrderInnerDialog = false
        this.createAfterSaleEntryOrderForm.visible = false
        if (orderType === EntryOrderType.STRK) {
          this.loadAfterSaleEntryOrder(this.curAfter, true)
        } else if (orderType === EntryOrderType.LJRK) {
          this.loadInterceptEntryOrder(this.curAfter, true)
        }
      }).catch(err => {
        this.$message.error('入库单创建异常：' + err.message)
        loading.close()
      })
    },

    handleAfterSaleEntryOrderConfirmSelection(row) {
      const {productName, code, specs, image} = row
      if (this.editingItemToUpdate) {
        // 更新明细
        const editingItem = this.editingItemToUpdate
        const {erpSku} = editingItem
        if (code === editingItem.itemCode) {
          this.$message.warning('您要更换的款与所选是同款，请检查～')
          return
        }
        this.$set(editingItem, 'itemCode', code)
        this.$set(erpSku, 'productName', productName)
        this.$set(erpSku, 'code', code)
        this.$set(erpSku, 'image', image)
        this.$set(erpSku, 'specs', specs)
        // this.$message.success('编辑明细成功～')
        this.afterSaleEntryOrderInnerDialog = false
      } else {
        // 新增明细
        const item = {
          itemCode: code,
          planQty: 1,
          erpSku: {
            productName,
            image,
            code,
            specs
          },
          inventoryType: 'ZP',
          inventoryTypeDesc: '正品'
        }
        const entryOrderList = this.curAfter.entryOrderList
        const index = entryOrderList.findIndex(entryOrder => entryOrder.editing)
        if (index === -1) {
          this.$message.error('添加明细：数据异常，请联系技术')
        } else {
          const entryOrder = entryOrderList[index]
          const editingItems = entryOrder.editingItems
          const codeList = editingItems.map(item => item.itemCode)
          if (codeList.indexOf(code) > -1) {
            this.$message.warning('此款已经存在于明细中了噢～')
          } else {
            editingItems.push(item)
            this.$set(entryOrder, 'editingItems', editingItems)
            // this.$message.success('新增明细成功～')
            this.afterSaleEntryOrderInnerDialog = false
          }
        }
      }
    },

    deleteEntryOrderItem(entryOrder, item) {
      let {editingItems} = entryOrder
      const {itemCode} = item
      editingItems = editingItems.filter(item => item.itemCode !== itemCode)
      this.$set(entryOrder, 'editingItems', editingItems)
    },

    handleAfterSaleEntryOrderDialogClose(done) {
      const entryOrderList = this.curAfter.entryOrderList
      entryOrderList.forEach(entryOrder => {
        this.$set(entryOrder, 'editing', false)
      })
      this.editingEntryOrderId = null
      // 清空历史勾选
      this.itemsSelections = []
      done()
    },

    toTransferToDefective(entryOrder) {
      // 找到次品仓并默认选中
      const defectiveWarehouses = this.erpWarehouses.filter(w => w.goodsType === 2)
      if (!defectiveWarehouses || !defectiveWarehouses.length) {
        this.$message.warning('本团队尚未创建次品仓')
        return
      }
      const defaultWarehouseCode = defectiveWarehouses[0].warehouseCode
      const itemsSelections = entryOrder.editing ? entryOrder.editingItems : entryOrder.items
      // 找到需要转次品勾选项目
      // const itemsSelections = this.itemsSelections
      // if (!itemsSelections || !itemsSelections.length) {
      //   this.$message.warning('请勾选需要转为次品的明细～')
      //   return
      // }
      const items = itemsSelections.map(item => {
        const {id, itemCode, planQty, inventoryType, erpSku} = item
        return {
          id,
          itemCode,
          erpSku,
          planQty,
          inventoryType,
          defective: ''
        }
      })

      this.transferForm = {
        entryOrder,
        items,
        warehouseCode: defaultWarehouseCode
      }
      this.transferDefectiveDialog = true
    },

    transferToDefective() {
      const form = this.transferForm
      const {entryOrder, items, warehouseCode} = form
      if (!items || !items.length || items.length > 1) {
        this.$message.warning('转次品数据异常，请联系技术')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      const item = items[0]
      const {defective} = item
      const {id} = entryOrder
      const deviceId = this.printerCode
      erpAfterSaleApi.toDefective(id, null, defective, warehouseCode, deviceId).then(() => {
        this.$message.success('转次品成功～')
        // 清空历史勾选
        this.itemsSelections = []
        this.$set(entryOrder, 'editing', false)
        this.editingEntryOrderId = null
        this.loadAfterSaleEntryOrder(this.curAfter, true)
        this.transferDefectiveDialog = false
        loading.close()
      }).catch(err => {
        loading.close()
        this.$message.error('转次品异常：' + err.message)
        console.log('createDefectiveEntryOrder err', err)
      })
    },

    finishEditEntryOrder(entryOrder) {
      // 应该来个确认对话框
      this.$confirm('确认提交对售后入库单的编辑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const entryOrderId = entryOrder.id
        const editingItems = entryOrder.editingItems
        const items = editingItems.map(item => {
          const {id, itemCode, planQty, actualQty, inventoryType, defective} = item
          return {
            id,
            itemCode,
            planQty,
            actualQty,
            inventoryType,
            defective
          }
        })
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        erpAfterSaleApi.updateAfterSaleEntryOrderItems(entryOrderId, items).then(() => {
          loading.close()
          this.$message.success('编辑成功')
          this.$set(entryOrder, 'editing', false)
          this.editingEntryOrderId = null
          this.loadAfterSaleEntryOrder(this.curAfter, true)
          // 清空历史勾选
          this.itemsSelections = []
        }).catch(err => {
          loading.close()
          this.$message.error('编辑失败：' + err.message)
          console.log('updateAfterSaleEntryOrderItems err', err)
        })
      }).catch(() => {
      })

    },

    toEditEntryOrder(entryOrder) {
      if (this.editingEntryOrderId) {
        this.$message.warning('存在编辑中的入库单, 请先完成编辑或者取消编辑～')
        return
      }

      if (entryOrder.status >= EntryOrderStatus.Reviewed || entryOrder.status === EntryOrderStatus.Suspend) {
        this.$message.warning(`单据状态为【${entryOrderStatus.getDescribe(entryOrder.status)}】，不可继续编辑`)
        return
      }

      // console.log('entryOrder', entryOrder)
      const {id, items} = entryOrder
      const editingItems = JSON.parse(JSON.stringify(items))
      this.$set(entryOrder, 'editing', true)
      this.$set(entryOrder, 'editingItems', editingItems)
      this.editingEntryOrderId = id
    },

    cancelEditEntryOrder(entryOrder) {
      this.$set(entryOrder, 'editing', false)
      // 清空历史勾选
      this.itemsSelections = []
      this.editingEntryOrderId = null
    },

    tableSelectable(row) {
      const {groupId} = row
      return groupId === this.editingEntryOrderId
    },

    handleItemsSelectionChange(selections) {
      this.itemsSelections = selections
    },

    handleWorkModeChange(val) {
      this.workMode = val
      this.afterList = []
      this.waybillInterceptDto = {afterList: []}
    },

    reprintAfterSaleLabel(entryOrder, row) {
      this.checkParam(this.printerCode, '请先选择标签机～')
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      const {id, planQty, itemCode, defective} = row
      const item = {
        id,
        planQty,
        itemCode,
        defective
      }
      erpAfterSaleApi.reprintAfterSaleLabel(entryOrder.id, this.printerCode, [item]).then(() => {
        loading.close()
        this.$message.success('已打印～')
      }).catch(err => {
        loading.close()
        this.$message.error('重打异常：' + err.message)
        console.log('reprintAfterSaleLabel err', err)
      })
    },

    printTagLabelForEntryOrder(entryOrder) {
      this.checkParam(this.printerCode, '请先选择标签机～')
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      erpAfterSaleApi.printTagLabelForEntryOrder(entryOrder.id, this.printerCode).then(() => {
        loading.close()
        this.$message.success('已打印～')
      }).catch(err => {
        loading.close()
        this.$message.error('打印异常：' + err.message)
        console.log('printTagLabelForEntryOrder err', err)
      })
    },

    addInterceptRemark(waybillInterceptDto) {
      const {waybillId} = waybillInterceptDto
      this.$prompt('追加仓库备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        let remark = value
        // let waybillId = child.waybill_id
        const teamId = this.teamForIntercept
        afterSaleApi.addInterceptRemark(waybillId, remark, teamId).then(() => {
          this.$message.success('追加仓库备注成功')
          //this.$set(row, 'failRemark', remark)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          this.loadWaybillIntercept(waybillId, teamId, false, loading)
        }).catch(err => {
          this.$message.error(err.message)
          console.log('addInterceptRemark err', err)
        })
      }).catch(() => {

      })
    },

    toUnusual() {
      let waybillId = this.afterWaybillId
      let unusual = this.unusual
      // let unusualItem = this.unusuals[unusual - 1]
      const unusualItem = this.unusuals.find(unItem => unItem.code === unusual)
      const warehouseCode = this.warehouseCode
      // let userId = this.userInfo.userId
      // let teamId = this.vipName
      if (!warehouseCode) {
        this.$message('未选择仓库！')
        return
      }
      if (!waybillId || !unusual) {
        this.$message("没有物流单号或未选异常原因")
        return false
      }
      this.$prompt(
          `异常原因:${unusualItem.name}`,
          `是否将${waybillId}转交异常处理`
      ).then((value) => {
        if (value.action === 'confirm') {
          let description = value.value
          this.doUnusual(waybillId, unusual, warehouseCode, description, 'false', [])
        }
      })
    },

    submitExchangeUnusualRecord(context) {
      return erpAfterSaleApi.unusualRecordNew(
          context.waybillId,
          8,
          this.warehouseCode,
          context.description,
          'false',
          []
      )
    },

    doUnusual(waybillId, unusual, warehouseCode, description, confirm, items, callback) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      erpAfterSaleApi.unusualRecordNew(waybillId, unusual, warehouseCode, description, confirm, items).then(() => {
        loading.close()
        this.$message.success(`【${waybillId}】转异常完成`)
        this.afterWaybillId = null
        if (callback) {
          callback()
        }
      }).catch(err => {
        loading.close()
        if (err.message.indexOf('已转过异常') > -1) {
          this.doUnusual(waybillId, unusual, warehouseCode, description, 'true')
        } else {
          console.log('unusualRecordNew err', err)
          this.$alert(err.message, '转异常错误')
        }
      })
    },

    showEntryOrders(after) {
      this.curAfter = after
      this.afterSaleEntryOrderDialog = true
    },

    // 加载售后入库单的信息
    loadAfterSaleEntryOrder(afterSaleInfo, showLoading) {
      const {waybillId, aftersaleId} = afterSaleInfo
      const query = {
        expressCode: waybillId,
        relatedOrder: aftersaleId
      }
      let loading = null
      if (showLoading) {
        loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
      }
      this.$set(afterSaleInfo, 'entryOrderList', [])
      entryOrderApi.findEntryOrders(query).then(data => {
        data.data.sort((a, b) => {
          if (a.goodsType === b.goodsType) {
            return a.id - b.id
          } else {
            return a.goodsType - b.goodsType
          }
        })
        this.$set(afterSaleInfo, 'orderType', EntryOrderType.STRK)
        this.$set(afterSaleInfo, 'entryOrderList', data.data)
        if (showLoading) {
          loading.close()
        }
      }).catch(err => {
        if (showLoading) {
          loading.close()
        }
        this.$message.error('加载入库单信息异常：' + err.message)
        console.log('editEntryOrder err', err)
      })

    },

    processAfterSale(printQualifiedCert = false) {
      const confirmDto = this.afterSaleConfirmDto
      const {
        items,
        comment,
        after,
        customRemark,
        unusualItems,
        defectiveItems = [],
        defectiveWarehouseCode
      } = confirmDto
      const printerCode = this.printerCode
      const warehouseCode = this.warehouseCode
      const afterSaleInfo = JSON.parse(JSON.stringify(after))
      afterSaleInfo.customRemark = customRemark
      items.forEach(item => {
        item.customRemark = customRemark
      })
      defectiveItems.forEach(item => {
        item.customRemark = customRemark
        item.warehouseCode = defectiveWarehouseCode
      })
      afterSaleInfo.items = [...items, ...defectiveItems]

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      erpAfterSaleApi.processAfterSale(afterSaleInfo, comment, warehouseCode, printerCode, printQualifiedCert).then(() => {
        // this.qrText = ''
        // 关闭对话框
        this.$set(this.afterSaleConfirmDto, 'dialogVisible', false)
        this.$message.success('拆包件处理完成')
        this.$set(after, 'refundStatusDesc', '处理完成')
        loading.close()
        this.loadAfterSaleEntryOrder(after)

        // 转异常结果
        if (unusualItems && unusualItems.length) {
          const waybill = this.afterWaybillId
          // 少件
          const unusual = 3
          const items = unusualItems.map(item => {
            const {orderVo, num} = item
            const {code, order_id, pid, platform} = orderVo
            return {
              itemCode: code,
              planQty: num,
              actualQty: 0,
              platform,
              orderId: order_id,
              parentOrderId: pid
            }
          })
          this.doUnusual(waybill, unusual, warehouseCode, '少件', 'false', items, () => {
            this.loadAfterSaleEntryOrder(after)
          })
        } else if (this.shouldPromptExchangeUnusual(comment, unusualItems)) {
          this.confirmExchangeUnusual({
            after,
            items: afterSaleInfo.items,
            teamId: this.vipName,
            waybillId: afterSaleInfo.waybillId || this.afterWaybillId
          })
        }
      }).catch(err => {
        this.$alert(err.message, '拆包收货错误')
        loading.close()
      })
    },

    deleteItem(row) {
      // 还是需要一个确认框吧
      this.$confirm('确认删除此明细？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let items = this.afterSaleConfirmDto.items
        const {orderVo} = row
        const {code} = orderVo
        items = items.filter(item => item.orderVo.code !== code)
        this.$set(this.afterSaleConfirmDto, 'items', items)
      }).catch(() => {
      })
    },

    editItem(row) {
      if (row) {
        this.rowToUpdate = row
      } else {
        this.rowToUpdate = null
      }
      this.$set(this.afterSaleConfirmDto, 'innerDialog', true)
    },

    handleConfirmSelection(row) {
      // console.log('选款', row)
      const {image, code, productName, specs} = row
      // 校验一下，选的款是不是已经存在于明细之中
      const items = this.afterSaleConfirmDto.items
      const codeList = items.map(it => it.orderVo.code)
      if (codeList.indexOf(code) > -1) {
        this.$message.warning('此款已经存在于明细之中，请检查～')
        return
      }
      const rowToUpdate = this.rowToUpdate
      if (rowToUpdate) {
        // 如果是来自替换的操作
        // 直接替换原来的item的orderVo的商品信息
        console.log('rowToUpdate', rowToUpdate)
        const {orderVo} = rowToUpdate
        this.$set(orderVo, 'product_pic', image)
        this.$set(orderVo, 'product_name', productName)
        this.$set(orderVo, 'code', code)
        this.$set(orderVo, 'specs', specs)
        this.$message.success('成功修改一条明细~')
      } else {
        // 如果是来自新增的操作
        // 构造一个item插入到原来到items
        const item = {
          newCreated: true,
          num: 1,
          actualQty: 1,
          giveaway: false,
          orderVo: {
            product_name: productName,
            code,
            specs,
            product_pic: image
          }
        }
        const items = this.afterSaleConfirmDto.items
        items.push(item)
        this.$set(this.afterSaleConfirmDto, 'items', items)
        this.$message.success('成功插入一条明细~')
      }
      this.$set(this.afterSaleConfirmDto, 'innerDialog', false)

    },

    warehouseCodeChange(val) {
      this.warehouseCode = val
    },

    showOriginWaybill() {
      this.scanWaybillId = this.originWaybillId
      this.popVisible = true
      setTimeout(() => {
        this.popVisible = false
      }, 3000)
    },

    changePrinter(value) {
      this.printerCode = value
    },

    labelPrinterChange(value) {
      // console.log(value)
      this.printerCode = null
      if (value) {
        this.loadLocalPrinters()
      } else {
        this.loadPrinters()
      }
    },

    loadLocalPrinters() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      if (!local_printer.getConnect()) {
        local_printer.doConnect()
      }
      setTimeout(() => {
        local_printer.status().then(info => {
          local_printer.findAllDevice().then(data => {
            local_printer.getDeviceId().then(deviceId => {
              this.printerCodes = data.map(item => {
                return {
                  name: item,
                  code: deviceId + ":::" + item
                }
              })
              loading.close()
            }).catch(err => {
              this.$message(err)
              loading.close()
            })
          }).catch(err => {
            this.$message(err)
            loading.close()
          })
        }).catch(err => {
          this.$message(err)
          loading.close()
        })
      }, 1000 * 2)
    },

    loadPrinters() {
      const warehouseId = this.userInfo.warehouseId
      afterSaleApi.findAllPrinters(2, warehouseId).then(data => {
        this.printerCodes = data.map(item => {
          return {
            name: item.name,
            code: item.deviceId
          }
        })
      })
    },

    changeVip(val, callback) {
      this.vipName = val ? val : null
      if (this.vipName) {
        const vips = this.vips
        const index = vips.findIndex(v => v.teamId === this.vipName)
        if (index > -1) {
          const team = vips[index]
          // console.log('team', team)
          if (!team.version) {
            // 整理一个dto返回去
            // 目前只有 多件发货 和 售后管理需要选择客户
            // 1、记住当前的 view
            // 2、记住当前选择的客户

            // 3、记住当前的标签机
            // 4、记住是本地打印还是云打印
            // 5、记住拆包当前的处理内容
            const memo = {
              view: this.view,
              teamId: this.vipName,
              afterView: {
                printerCode: this.printerCode,
                labelPrinter: this.labelPrinter,
                workMode: this.workMode,
                qrText: this.qrText,
                originWaybillId: this.originWaybillId
              }
            }
            this.$emit('switchToOldSysFromTeamChange', memo)
            return
          }
        }
      }
      this.loadErpWarehouses(this.vipName, callback)
    },

    async loadMultipleOrders(teamId, flush) {
      const warehouseCode = this.warehouseCode
      if (!teamId || !warehouseCode) {
        this.clearPickingMatch()
        this.pickingStockOutId = null
        this.pickingTasks = []
        this.$message.warning(!teamId ? '请选择客户' : '请选择仓库')
        return
      }
      this.teamId = teamId
      if (!flush) {
        this.clearPickingMatch()
        this.pickingStockOutId = null
        this.pickingTasks = []
      }
      const scope = this.capturePickingScope()
      const requestID = uuid.getUUID(8, 16)
      this.multipleOrdersRequestID = requestID
      this.multipleOrders = []
      this.pickingTasksLoading = true
      this.pickingOrdersLoading = true
      this.clearAutoSendData()
      const loading = this.$loading({lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'})
      const isCurrent = () => requestID === this.multipleOrdersRequestID && this.isPickingScopeCurrent(scope)
      try {
        // 先加载拣货单，也让后端恢复仍有效的旧关联，然后再查询发货任务。
        const tasks = await warehouseApi.findMultiplePickingTasks(teamId, warehouseCode)
        if (!isCurrent()) return
        const selected = this.pickingTasks.find(task => String(task.id) === String(scope.stockOutId))
        this.pickingTasks = tasks.slice()
        // 已选单没有待发订单时保留选择，不能自动回退到未关联订单。
        if (scope.stockOutId && !tasks.some(task => String(task.id) === String(scope.stockOutId))) {
          this.pickingTasks.push({...selected, id: scope.stockOutId, orderCount: 0, unavailable: true})
        }
        this.pickingTasks.sort((a, b) => a.id - b.id)
        const taskId = scope.stockOutId ? null : this.taskGroup.id
        const [orders, groups] = await Promise.all([
          this.findMultipleOrdersForScope(scope, taskId, null, isCurrent),
          scope.stockOutId ? Promise.resolve([]) : warehouseApi.findAllRemnantReadyOrderGroup(teamId, 1, null, warehouseCode)
        ])
        if (!isCurrent()) return
        this.multipleOrders = orders
        this.taskGroups = [{id: 0, title: '未分配'}, ...groups]
      } catch (err) {
        if (isCurrent()) {
          this.multipleOrders = []
          this.$message.error(err.message || '加载发货任务失败')
        }
      } finally {
        loading.close()
        if (isCurrent()) {
          this.pickingTasksLoading = false
          this.pickingOrdersLoading = false
        }
      }
    },

    loadErpWarehouses(teamId, callback) {
      const requestID = uuid.getUUID(8, 16)
      this.erpWarehousesRequestID = requestID
      this.warehouseCode = null
      this.erpWarehouses = []
      this.erpWarehousesLoading = true
      erpCloudWarehouseApi.findWarehouseByTeamId(teamId).then(warehouses => {
        if (requestID !== this.erpWarehousesRequestID) return
        this.erpWarehousesLoading = false
        this.erpWarehouses = warehouses
        if (warehouses && warehouses.length) {
          // 售后正品仓优先级：逆向仓（1）、正向仓（0）、其他正品仓
          const getAfterSalePriority = warehouse => {
            const subGoodsType = warehouse.subGoodsType || 0
            if (subGoodsType === 1) {
              return 0
            }
            return subGoodsType === 0 ? 1 : 2
          }
          const sorter = (a, b) => {
            // 正品仓优先
            if (a.goodsType !== b.goodsType) {
              return a.goodsType - b.goodsType
            }
            if (this.view === 6 && a.goodsType === 1) {
              return getAfterSalePriority(a) - getAfterSalePriority(b)
            }
            return 0
          }
          this.warehouseCode = warehouses.sort(sorter)[0].warehouseCode
        }
        if (callback) {
          callback()
        }
      }).catch(err => {
        if (requestID !== this.erpWarehousesRequestID) return
        this.erpWarehousesLoading = false
        this.$message.error(err.message)
      })
    },

    confirmRec(after, item, comment) {
      this.checkParam(this.printerCode, "请选择打印机！")
      this.checkParam(this.warehouseCode, "请选择仓库！")
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      let suffix = comment === 0 ? '退款收货' : (comment === 1 ? '换货收货' : '仅收货')
      suffix = '-【' + suffix + '】'
      // 检查是否包含组合商品
      const checkCombinationPromise = new Promise(resolve => {
        const {items} = after
        const promises = []
        const allItems = []
        items.forEach(it => {
          const {orderVo} = it
          const {code} = orderVo
          const p = new Promise(innerResolve => {
            const finalCode = encodeURIComponent(code)
            erpProductApi.findErpSkuVoByTeamIdAndCode(this.vipName, finalCode).then(erpSkuVo => {
              const {skuType, combinationSkuDto, intercept} = erpSkuVo
              if (skuType === 1 && combinationSkuDto && combinationSkuDto.splitSkuDtoList && combinationSkuDto.splitSkuDtoList.length) {
                const splitItems = combinationSkuDto.splitSkuDtoList
                const finalItems = []
                splitItems.forEach(split => {
                  const itemCpy = JSON.parse(JSON.stringify(it))
                  const {orderVo} = itemCpy
                  orderVo.product_name = split.productName
                  orderVo.code = split.skuCode
                  orderVo.specs = split.specs
                  itemCpy.num = split.num
                  itemCpy.actualQty = split.num
                  // 保存 intercept 字段到 item 中
                  itemCpy.intercept = intercept
                  finalItems.push(itemCpy)
                })
                innerResolve(finalItems)
              } else {
                it.actualQty = it.num
                // 保存 intercept 字段到 item 中
                it.intercept = intercept
                innerResolve([it])
              }
            }).catch(ignore => {
              it.actualQty = item.num
              innerResolve([it])
            })
          })
          promises.push(p)
        })
        Promise.all(promises).then(resultList => {
          resultList.forEach(its => {
            allItems.push(...its)
          })
          resolve(allItems)
        })
      })
      // after.items.forEach(item => item.actualQty = item.num)
      checkCombinationPromise.then(items => {
        loading.close()
        this.afterSaleConfirmDto = {
          dialogVisible: true,
          after,
          comment,
          items: JSON.parse(JSON.stringify(items)),
          suffix,
          remark: '',
          defectiveItems: [],
          unusualItems: [],
          teamId: this.vipName,
          printQualifiedCert: this.getDefaultPrintQualifiedCert(this.vipName)
        }
        // 默认的次品仓（如需要转次品）
        const defectiveWarehouseCodes = this.erpWarehouses.filter(w => w.goodsType === 2).map(w => w.warehouseCode)
        if (defectiveWarehouseCodes && defectiveWarehouseCodes.length) {
          this.afterSaleConfirmDto.defectiveWarehouseCode = defectiveWarehouseCodes[0]
        }

        // 检查是否有拦截件，如果有则自动标记为次品
        const interceptItems = items.filter(item => item.intercept === true)
        if (interceptItems.length > 0) {
          interceptItems.forEach(item => {
            this.markItem(item, 'defectiveItems')
          })
        }

        this.$nextTick(() => {
          this.$refs.afterSaleRemarkInput.focus()
        })
      })

      // this.$prompt("备注内容（50字以内）", "确认退货?", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      //   inputValidator: () => {
      //     return true
      //   },
      // }).then((value) => {
      //   if (value.action === "confirm") {
      //     let message = value.value || ""
      //     if (message.length > 50) {
      //       this.$alert("备注小于50字")
      //       return false
      //     }
      //     item.customRemark = message
      //     this.processAfter(after, item, comment)
      //   }
      // })
    },

    processAfter(after, item, comment) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let info = item
      info.aftersaleId = after.aftersaleId
      info.shopId = after.shopId
      info.hasGivenOrders = after.hasGivenOrders
      afterSaleApi
          .processAfterSale(
              comment,
              this.vipName,
              this.printerCode,
              info,
              this.userInfo.userId
          )
          .then(() => {
            loading.close()
            this.$message.success('处理完成')
            this.$set(after, 'refundStatusDesc', '处理完成')
          })
          .catch((err) => {
            this.$alert(err.message)
            loading.close()
          })
    },

    handleWaybillKeyUp(e) {
      if (!this.waybillScanner) {
        this.waybillScanner = createScannerHandler({
          onComplete: qrText => {
            this.qrText = qrText
            this.waybillScan(this.event, null, true)
          },
          // onInput: qrText => this.qrText = qrText,
          maxInterval: 100
        })
      }
      this.waybillScanner.handleKeyUp(e)
    },

    changeView(view) {
      if (view === 6 || view === 5 || view === 2 || view === 8) {
        this.checkParam(this.userInfo.userId, "请先登录")
      }
      if (view === 8) {
        const memo = {
          view,
          teamId: this.vipName
        }
        this.$emit('switchToOldSysFromTeamChange', memo)
        return
      }
      this.view = view

      // 如果切换到多件发货页面，自动聚焦到自动发货输入框
      if (view === 2) {
        this.$nextTick(() => {
          if (this.$refs.autoSendInput) {
            this.$refs.autoSendInput.focus()
          }
        })
      }
    },

    checkParam(p, msg) {
      if (!p) {
        this.$message(msg)
        throw msg
      }
      return p
    },

    waybillScan(event, waybill, showQrText) {
      let loadingComponent = null
      if (!showQrText) {
        loadingComponent = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
      }

      if (this.qrText) {
        waybill = this.qrText
      }

      let teamId = this.vipName

      if (this.workMode === 0 || this.workMode === 3) {
        this.scanWaybillId = waybill
        if (showQrText) {
          this.popVisible = true
          setTimeout(() => {
            this.popVisible = false
          }, 3000)
        }
        this.afterList = []
        const autoTeamPromise = new Promise((resolve, reject) => {
          if (this.autoTeam) {
            afterSaleApi.findTeamByAfterSaleWaybillId(waybill).then(tid => {
              if (tid != null) {
                this.changeVip(tid)
                resolve(tid)
              }
              resolve(teamId)
            }).catch(err => {
              // 后端抛异常时，检查当前是否有选择团队
              if (this.vipName) {
                resolve(this.vipName)
              } else {
                reject(new Error('请手动选择团队'))
              }
            })
          } else {
            return resolve(teamId)
          }
        })
        autoTeamPromise.then(finalTeamId => {
          let onlySearch = this.workMode === 0 ? 0 : 1
          this.afterWaybillId = waybill
          const requestID = this.getRequestID()
          this.currentRequestID = requestID
          afterSaleApi
              .searchAfterSales(waybill, finalTeamId, this.userInfo.userId, onlySearch, 'true')
              .then((data) => {
                if (this.currentRequestID === requestID) {
                  // console.log('searchAfterSales data', data)
                  this.afterList = data
                  data.forEach(after => {
                    this.loadAfterSaleEntryOrder(after)
                  })
                  if (!data || !data.length) {
                    this.$message.warning('暂无数据')
                  }
                  if (loadingComponent) loadingComponent.close()
                }
              })
              .catch((err) => {
                if (this.currentRequestID === requestID) {
                  if (loadingComponent) loadingComponent.close()
                  this.$message(err.message)
                }
              })
        }).catch(err => {
          this.$alert(err.message, '错误提示')
        })
      } else if (this.workMode === 1) {
        this.loadWaybillIntercept(waybill, teamId, showQrText, loadingComponent)
      }
    },

    loadWaybillIntercept(waybill, teamId, showQrText, loadingComponent) {
      this.scanWaybillId = waybill
      if (showQrText) {
        this.popVisible = true
        setTimeout(() => {
          this.popVisible = false
        }, 3000)
      }
      this.afterWaybillId = waybill

      const originWaybillId = this.originWaybillId
      if (originWaybillId) {
        if (!waybill) {
          if (loadingComponent) loadingComponent.close()
          this.$alert('实收物流单号不能为空!')
          return
        }
        this.changeWaybillId = waybill
        waybill = this.originWaybillId
      } else {
        this.changeWaybillId = ''
      }

      this.waybillInterceptPreQueryPromise(waybill, teamId).then(result => {
        if (result) {
          if (loadingComponent) loadingComponent.close()
        } else {
          this.teamForIntercept = teamId
          this.waybillInterceptDto = {afterList: []}
          const requestID = this.getRequestID()
          this.currentRequestID = requestID
          afterSaleApi.searchWaybillInterceptOrder(waybill, teamId).then(data => {
            if (this.currentRequestID === requestID) {
              if (loadingComponent) loadingComponent.close()
              if (!data || !data.length) {
                this.$message.info('暂无数据')
                return
              }
              const child = data[0]
              const {waybill_id, isYiboSend} = child
              this.waybillInterceptDto = {
                orderType: EntryOrderType.LJRK,
                afterList: data,
                // 保存teamId信息
                teamId,
                waybillId: waybill_id,
                isYiboSend
              }
              this.loadInterceptEntryOrder(this.waybillInterceptDto)
            }
          }).catch((err) => {
            const {message} = err
            if (loadingComponent) loadingComponent.close()
            if (message.includes('没找到相关订单信息')) {
              this.$alert('非毅播发货，没找到相关订单信息，请确认团队是否选择正确', '错误提示')
            } else if (message.includes('请切换为正确的团队')) {
              const rightTeamId = message.split('：')[1] * 1
              const rightTeam = this.getVipByTeamId(rightTeamId)
              if (rightTeam) {
                const needChangeSys = !(rightTeam.version)
                const callback = needChangeSys ? null : () => {
                  this.waybillScan()
                }
                this.changeVip(rightTeamId, callback)
              } else {
                this.$alert('非毅播发货，团队选择错误，请手动切换正确的团队', '错误提示')
              }
            } else {
              if (this.currentRequestID === requestID) {
                this.$alert(err.message, '错误提示')
              }
            }
          })
        }
      })
    },

    getTagTypeByStatus(status) {
      if (status <= EntryOrderStatus.Accepted) {
        return 'danger'
      } else if (status <= EntryOrderStatus.Suspend) {
        return 'warning'
      } else if (status <= EntryOrderStatus.PartReviewed) {
        return 'primary'
      } else if (status <= EntryOrderStatus.Pushed) {
        return 'success'
      } else {
        return 'info'
      }
    },

    getWarehouseType(goodsType) {
      switch (goodsType * 1) {
        case 1:
          return '正品仓'
        case 2:
          return '次品仓'
        case 3:
          return '冻结仓'
        default:
          return '未知仓库类型:' + goodsType
      }
    },

    /**
     * 处理全局键盘按下事件
     */
    handleGlobalScanKeyDown(e) {
      // 防止按键事件重复传递
      // e.preventDefault();
    },

    /**
     * 处理全局键盘抬起事件，用于捕获扫描枪输入
     */
    handleGlobalScanKeyUp(e) {
      if (this.view !== 6 && this.enableGlobalScanListener) {
        // 仅售后模块触发 且 打开开关才触发
        return
      }

      if (e.target.matches('input, textarea')) {
        // 如果是子元素的冒泡，阻止触发
        // console.log('阻止子元素冒泡触发', e.target)
        return;
      }

      if (!this.globalScanner) {
        this.globalScanner = this.getGlobalScannerHandler()
      }

      this.globalScanner.handleKeyUp(e)
    },

    updateScannerListeners() {
      if (this.enableGlobalScanListener) {
        window.addEventListener('keydown', this.handleGlobalScanKeyDown);
        window.addEventListener('keyup', this.handleGlobalScanKeyUp);
        console.log('物流单号扫描监听已启用');
      } else {
        window.removeEventListener('keydown', this.handleGlobalScanKeyDown);
        window.removeEventListener('keyup', this.handleGlobalScanKeyUp);
        console.log('物流单号扫描监听已禁用');
      }
    },
  },

  mounted() {
    this.statusMap = actionStatusUtils.getActionStatusMap()
    // 接收传进来的登录信息 和 所选团队信息 和 原本的页面的信息
    this.userInfo = this.loginInfo
    this.vipName = this.fromTeamId
    if (this.vipName) {
      // 拦截件跳转
      let callback = null
      if (this.fromWorkMode === 1 && this.fromQrText) {
        this.qrText = this.fromQrText
        this.originWaybillId = this.fromOriginWaybill || ''
        callback = () => {
          this.waybillScan()
        }
      } else if ((this.fromWorkMode === 0 || this.fromWorkMode === 3) && this.fromQrText) {
        this.qrText = this.fromQrText
        callback = () => {
          this.waybillScan()
        }
      }
      this.loadErpWarehouses(this.vipName, callback)
    }
    this.workMode = this.fromWorkMode
    if (this.userInfo.userId) {
      // 跳转到已选择的模块
      this.view = this.fromView || 1
      this.loadPrinters()

      //如果是多件发货模块，并且已经选择了团队
      if (this.view === 2 && this.vipName) {
        this.loadErpWarehouses(this.vipName, () => {
          this.loadMultipleOrders(this.vipName, false)
        })
      }
    }
    this.printerCodes = printerCodeUtils.getPrinterCodes()
    this.printerCode = this.fromPrinterCode
    this.vips = this.fromVips.filter(v => v.version)

    this.loadAndSaveCourier()
    const _this = this
    setTimeout(() => {
      _this.getPrinters()
    }, 3000)

    if (this.fromAutoWaybill) {
      this.enableGlobalScanListener = true
      this.globalScanner = this.getGlobalScannerHandler()
    }
    // 初始检查，则添加监听
    this.updateScannerListeners();

    // 初始化自动发货模式状态
    this.autoSendMode = false
    this.clearAutoSendData()

    // 初始化最近发货记录
    this.recentShipments = []

    // 初始化播种校验模式
    this.verifyMode = false

  },
  beforeDestroy() {
    if (this.lastScanTimer != null) {
      clearTimeout(this.lastScanTimer)
    }

    // 清理物流单号扫描处理器
    if (this.globalScanner) {
      // this.globalScanner.destroy();
      this.globalScanner = null;
    }

    // 确保移除全局键盘事件监听
    if (this.enableGlobalScanListener) {
      window.removeEventListener('keydown', this.handleGlobalScanKeyDown);
      window.removeEventListener('keyup', this.handleGlobalScanKeyUp);
    }

  },

  computed: {
    renderedMultipleOrders() {
      const orders = this.filteredMultipleOrders || []
      if (!this.pickingStockOutId) return orders
      const maxPage = Math.max(1, Math.ceil(orders.length / this.multipleRenderPageSize))
      const page = Math.min(this.multipleRenderPage, maxPage)
      const start = (page - 1) * this.multipleRenderPageSize
      return orders.slice(start, start + this.multipleRenderPageSize)
    },
    waybillPopoverWidth() {
      // 根据字体大小计算弹窗宽度：60px字体对应50%宽度，180px字体对应95%宽度
      const minFontSize = 60;
      const maxFontSize = 180;
      const minWidth = 50;
      const maxWidth = 95;
      const ratio = (this.waybillFontSize - minFontSize) / (maxFontSize - minFontSize);
      const width = minWidth + ratio * (maxWidth - minWidth);
      return `${width}%`;
    },
    logisticsId: {
      get() {
        return this.fromLogisticsId
      },
      set(val) {

      }
    },

    vips: {
      get() {
        return this.fromVips
        // return this.fromVips.filter(v => v.version)
      },
      set(val) {

      }
    },

    recordsNum() {
      if (this.records == null) {
        return 0;
      }
      let num = 0;
      for (let r of this.records) {
        num += r.num || 1;
      }
      return num;
    },

    hasInterceptItems() {
      console.log("sss")
      if (!this.afterSaleConfirmDto || !this.afterSaleConfirmDto.defectiveItems) {
        return false;
      }
      return this.afterSaleConfirmDto.defectiveItems.some(item => item.intercept === true);
    },

    productInfo() {
      const index = this.queueIndex
      if (index > -1) {
        let printData = this.qrTextQueue[index].printDataList
        if (printData && printData.length > 0) {
          for (let i = 0; i < printData.length; i++) {
            if (printData[i].productPic)
              return {
                productPic: printData[i].productPic,
                productName: printData[i].productName,
                specs: printData[i].specs,
                code: printData[i].code
              }
          }
        }
        return {}
      } else {
        return {}
      }
    },

    superior() {
      return (
          this.userInfo.roles != null &&
          (this.userInfo.roles.includes("WarehouseSuperior") || this.userInfo.roles.includes("SelfSuperior"))
      )
    },

    queueIndex() {
      let index = -1
      let bId = this.qrSelected
      let queue = this.qrTextQueue
      if (bId !== null) {
        index = queue.findIndex(item => item.batchId === bId)
      }
      return index
    },

    scanTextResult() {
      let index = this.queueIndex
      if (index > -1) {
        let stAdvised = 0
        let ytAdvised = 0
        let ztAdvised = 0
        let sfAdvised = 0
        let jdAdvised = 0

        let total = 0
        let printMiss = 0
        let success = 0
        let fail = 0
        let retry = 0
        let printData = this.qrTextQueue[index].printDataList
        printData.forEach(item => {
          if (item.nextStatus === 1) {
            retry++
          }
          if (item.status === 0) {
            if ((item.printStatus && item.printStatus.status !== 'success') || !item.printStatus) {
              printMiss++
            }
            success++
            total++
          } else {
            fail += item.errNum || 1
            total += item.errNum || 1
          }
          // 可换快递
          if (item.status === 12 && item.errorMsg) {
            const {errorMsg} = item
            if (errorMsg.indexOf('请用申通') > -1) {
              stAdvised++
            } else if (errorMsg.indexOf('请用圆通') > -1) {
              ytAdvised++
            } else if (errorMsg.indexOf('请用中通') > -1) {
              ztAdvised++
            } else if (errorMsg.indexOf('请用顺丰') > -1) {
              sfAdvised++
            } else if (errorMsg.indexOf('请用京东') > -1) {
              jdAdvised++
            }
          }
        })
        return {
          success,
          fail,
          total,
          retry,
          stAdvised,
          ytAdvised,
          ztAdvised,
          sfAdvised,
          jdAdvised,
          printMiss
        }
      } else {
        return {
          success: 0,
          fail: 0,
          total: 0,
          retry: 0,
          stAdvised: 0,
          ytAdvised: 0,
          ztAdvised: 0,
          sfAdvised: 0,
          jdAdvised: 0,
          printMiss: 0
        }
      }
    },

    filterPrintData() {
      let index = this.queueIndex
      if (index > -1) {
        let printData = this.qrTextQueue[index].printDataList
        let filterSelected = this.filterSelected
        if (filterSelected === 1) {
          printData = printData.filter(item => item.status === 0)
        } else if (filterSelected === 2) {
          printData = printData.filter(item => item.status !== 0)
        } else if (filterSelected === 4) {
          printData = printData.filter(item => item.nextStatus === 1)
        } else if (filterSelected === 5) {
          printData = printData.filter(item => {
            return item.status === 0 && ((item.printStatus && item.printStatus.status !== 'success') || !item.printStatus)
          })
        }
        return printData
      } else {
        return []
      }
    },

    // 过滤显示的多件订单，只显示包含已扫描商品的订单
    filteredMultipleOrders() {
      const {multipleOrders} = this
      const {codeCounts} = this.autoSendData

      // 如果不是自动发货模式，显示所有订单
      if (!this.autoSendMode) {
        return multipleOrders || []
      }

      // 调试信息




      // 如果没有扫描任何商品，显示所有订单
      if (!codeCounts || Object.keys(codeCounts).length === 0) {

        return multipleOrders || []
      }

      // 获取已扫描的商品编码列表
      const scannedCodes = Object.keys(codeCounts).filter(code => codeCounts[code] > 0)

      // 过滤出包含所有已扫描商品的订单，并且扫描数量不超过订单需求
      const filtered = (multipleOrders || []).filter(order => {
        if (!order.children || order.children.length === 0) return false

        // 检查订单是否包含所有已扫描的商品
        const containsAllScanned = scannedCodes.every(scannedCode => {
          return order.children.some(child => child.code === scannedCode)
        })

        if (!containsAllScanned) {

          return false
        }

        // 检查扫描数量是否超过订单需求
        const hasExcessQuantity = order.children.some(child => {
          const scannedCount = codeCounts[child.code] || 0
          return scannedCount > child.combo_num
        })

        if (hasExcessQuantity) {

          return false
        }

        return true
      })



      return filtered
    },


  }
}
</script>

<style scoped>
.multiple-order-pagination {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
}

.flex_div {
  display: flex;
  justify-content: left;
  align-items: center;
}

.deliver-taq {
  font-size: 10px;
  margin-left: 8px;
}

.dashed_line {
  height: 0px;
  border-top: 2px dashed gray;
  margin-top: 18px;
  margin-bottom: 18px;
}

.sku-code {
  color: rgb(255, 153, 18);
}

.op_div {
  display: flex;
  flex-direction: column;
}

.op_div div {
  margin-bottom: 5px;
}

/* 拦截件次品按钮样式 */
.intercept-defective-btn {
  font-weight: bold !important;
  border: 2px solid #f56c6c !important;
  background-color: #fef0f0 !important;
  color: #f56c6c !important;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 108, 108, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
  }
}

.entry_btn_div div {
  margin-left: 5px;
  margin-right: 5px;
}

/* 自动发货模式布局样式 */
.auto-send-layout {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  height: calc(100vh - 300px);
  min-height: 600px;
  background: #f5f7fa;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.auto-send-left {
  width: 380px;
  flex-shrink: 0;
  background: white;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e4e7ed;
  overflow-y: auto;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
}

.auto-send-right {
  flex: 1;
  overflow-y: auto;
  background: white;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
}

.auto-send-section {
  margin-bottom: 20px;
}

.auto-send-section h3 {
  margin: 0 0 20px 0;
  color: #303133;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 3px solid #409eff;
  padding-bottom: 10px;
  text-align: center;
}

.auto-send-section h4 {
  margin: 15px 0 12px 0;
  color: #606266;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.auto-send-section h4::before {
  content: '';
  width: 4px;
  height: 16px;
  background: #409eff;
  margin-right: 8px;
  border-radius: 2px;
}

.auto-send-input-section {
  margin-bottom: 20px;
}

.auto-send-input {
  width: 100%;
}

.auto-send-status {
  margin-bottom: 20px;
  padding: 18px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.auto-send-codes {
  padding: 18px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.auto-send-delete-notice {
  margin-bottom: 20px;
  padding: 15px;
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
  border-radius: 8px;
  border: 1px solid #ffcdd2;
  box-shadow: 0 2px 8px 0 rgba(255, 71, 87, 0.2);
}

.auto-send-history {
  margin-bottom: 20px;
  padding: 18px;
  background: linear-gradient(135deg, #f0f8ff 0%, #ffffff 100%);
  border-radius: 8px;
  border: 1px solid #d0e6ff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.auto-send-history .el-table {
  font-size: 12px;
  max-width: 100%;
  table-layout: fixed;
}

.auto-send-history .el-table th {
  padding: 5px 0;
  font-size: 12px;
}

.auto-send-history .el-table td {
  padding: 5px 0;
}

.auto-send-history .el-button--mini {
  transform: scale(0.9);
}

.auto-send-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 15px;
}

.auto-send-tag {
  margin: 0;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.auto-send-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
}

.auto-send-order-card {
  margin-bottom: 8px;
  border-radius: 6px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.auto-send-order-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
}

/* 自动发货模式下的订单卡片紧凑样式 */
.auto-send-order-card .el-card__header {
  padding: 10px 16px;
  font-size: 13px;
  background: #f8f9fa;
}

.auto-send-order-card .el-card__body {
  padding: 10px 16px;
}

.auto-send-order-card .text.item {
  margin-bottom: 6px;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.auto-send-order-card .text.item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.auto-send-order-card .text.item.auto-send-matched-item {
  background: rgba(103, 194, 58, 0.12);
  border: 1px solid rgba(103, 194, 58, 0.35);
  border-radius: 6px;
  padding: 8px;
}

.auto-send-match-tip {
  color: #67c23a !important;
  font-weight: bold;
}

.auto-send-order-card .el-image {
  width: 70px !important;
  height: 70px !important;
  border-radius: 4px;
}

.auto-send-order-card .el-col-8,
.auto-send-order-card .el-col-16 {
  display: flex;
  align-items: center;
}

.auto-send-order-card .el-col-16 {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.auto-send-order-card .el-col-16 div {
  font-size: 12px;
  line-height: 1.3;
  margin-bottom: 3px;
}

.auto-send-order-card .el-col-16 div:last-child {
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .auto-send-layout {
    flex-direction: column;
    height: auto;
    gap: 15px;
  }

  .auto-send-left {
    width: 100%;
    order: 2;
  }

  .auto-send-right {
    order: 1;
  }
}

@media (max-width: 768px) {
  .auto-send-layout {
    padding: 15px;
    margin-top: 15px;
  }

  .auto-send-left,
  .auto-send-right {
    padding: 15px;
  }

  .auto-send-section h3 {
    font-size: 16px;
  }

  .auto-send-section h4 {
    font-size: 14px;
  }
}

/* 自动删除条码提示样式 */
.auto-delete-message {
  font-size: 18px !important;
  font-weight: bold !important;
  background: linear-gradient(135deg, #ff4757 0%, #ff3742 50%, #ff3838 100%) !important;
  border: 3px solid #ff3838 !important;
  box-shadow: 0 6px 20px rgba(255, 71, 87, 0.6) !important;
  animation: shake 0.6s ease-in-out, pulse 2s infinite !important;
  border-radius: 8px !important;
  min-width: 400px !important;
  z-index: 9999 !important;
}

.auto-delete-message .el-message__content {
  color: white !important;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5) !important;
  line-height: 1.5 !important;
  white-space: pre-line !important;
}

.auto-delete-message .el-message__icon {
  font-size: 20px !important;
  margin-right: 10px !important;
}

.auto-delete-message .el-message__closeBtn {
  color: white !important;
  font-size: 18px !important;
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-3px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(3px);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 6px 20px rgba(255, 71, 87, 0.6);
  }
  50% {
    box-shadow: 0 6px 20px rgba(255, 71, 87, 0.8), 0 0 0 10px rgba(255, 71, 87, 0.1);
  }
  100% {
    box-shadow: 0 6px 20px rgba(255, 71, 87, 0.6);
  }
}

.el-table .warning-row {
  color: red;
}

.el-table .success-row {
  color: black;
}

.el-table .success-row1 {
  background: #a6e782;
}

.el-table .select-row {
  background: lemonchiffon;
}

.el-table .warning-cell {
  background: lemonchiffon;
}

.el-table .success-cell {
  background: #a6e782;
}

.warning_text {
  color: red;
  font-weight: bold;
}

.delivery_advice div {
  margin-right: 25px;
}

.custom_clearable {
  position: absolute;
  top: 3px;
  right: 8px;
  cursor: pointer;
  color: #C0C4CC;
}

.custom_clearable:hover {
  color: #F56C6C;
}

.match_channel_success {
  border: 3px solid #67C23A;
  border-radius: 5px;
}

.match_channel_danger {
  border: 4px dashed red;
  border-radius: 5px;
}

/* 自动发货相关样式 */
.auto-send-container {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  margin: 10px 0;
}

.auto-send-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 600px;
  margin-top: 10px;
}

.auto-send-tag {
  transition: all 0.3s ease;
}

.auto-send-tag:hover {
  transform: scale(1.05);
}

.auto-send-input {
  border: 2px solid #409EFF;
  border-radius: 6px;
}

.auto-send-input:focus {
  border-color: #67C23A;
  box-shadow: 0 0 8px rgba(103, 194, 58, 0.3);
}

</style>

<style>
.waybill-popover {
  padding: 30px 40px !important;
  position: fixed !important;
  top: 10% !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  background: yellow !important;
  box-sizing: border-box !important;
}

.waybill-popover > div {
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NewSysPage/index.vue